import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, Renderer2, SimpleChanges, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ConfirmationService, MessageService } from "primeng/api";
import { AppMainComponent } from "src/app/app.main.component";
import { SalesOrderService } from "../sales-order.service";
import * as _ from "lodash";
import { DatePipe, TitleCasePipe } from "@angular/common";
import { uploadFiles, validateFiles } from "src/app/shared/upload-files";
import * as moment from "moment";
import { AppMainService } from "src/app/app-main.service";
import { TypeIds, ContactSelectionType, SoStageId, BackOrderOptions, DialogType, SOChannel, accCreditMsg, ApprovalStatus, accHoldMsg } from "../constants/constants";
import { UtilityService } from "../utils/utility.service";
import { Status, SalesOrderStatus, Severity } from "../../constants/constants";
import { SoStageChangeService } from "../services/so-stage-change.service";
import { catchError, finalize, forkJoin, from, map, of, Subject, takeUntil, tap } from "rxjs";
import { ISalesOrder, ISalesOrderAddDiscount, ISalesOrderBundleProduct, ISalesOrderBundleProductList, ISalesOrderProduct, ISalesOrderProductSubTax } from "../models/sales-order.model";
import { SoShipmentService } from "../services/so-shipment.service";
import { IInvoice, IInvoiceAddDiscount, IInvoiceBundleProduct, IInvoiceProduct, IInvoiceProductSubTax, IInvoiceSerialDetail } from "../models/invoice.model";
import { AccountsHttpService } from "src/app/modules/shared/services/accounts.http.service";
import { PaymenttermService } from "src/app/configurations/inventory/setup/paymentterm/paymentterm.service";
import { PaymentmethodService } from "src/app/configurations/inventory/setup/paymentmethod/paymentmethod.service";
import { ShippingtermService } from "src/app/configurations/inventory/setup/shippingterm/shippingterm.service";
import { ProductsService } from "../../products/products.service";
import { v4 as uuidv4 } from "uuid";
import { ProductDataService } from "src/app/modules/shared/services/product-data.service";
import { ReceivedPaymentRequestBuilderService } from "../services/received-payment-request-builder.service";
import { ImportserialService } from "src/app/modules/shared/services/importserial.service";
import { AccountServiceN } from "src/app/accounts-v2/services/account.services";
import { AccountFlatteningService } from "../services/account-flattening.service";
import { CreditControlEnum } from "src/app/models/statusEnums";
import { ClosingYearDisplayMessages } from "src/app/finance/constants/closing-year.constant";
import { AccountLeadDataService } from "src/app/modules/shared/stores/accountLeadDataStore/accountLeadData.service";
import { Currency } from "src/app/modules/shared/model/currency.model";
import { OverlayPanel } from "primeng/overlaypanel";
import { UtilsService } from "src/app/inventory/purchases/utility/utils.service";
import { DialogTypeFeeOrDiscount, Fee, FeeOrDiscountContext } from "src/app/modules/shared/components/fees-and-discounts-manager/models/fee.model";
import { TaxSelectionModel } from "../../../modules/shared/components/tax-selection-modal/models/tax.model";
import { ProductCalculationUtilityService } from "../utils/product-calculation-utility.service";
import { IPostingPeriodDetails } from "src/app/modules/shared/components/posting-period-selector/models/posting-period.model";

@Component({
    selector: "app-sales-order-add-edit",
    templateUrl: "./sales-order-add-edit.component.html",
    styleUrls: ["./sales-order-add-edit.component.scss"],
})
export class SalesOrderAddEditComponent implements OnInit, OnChanges, OnDestroy {
    @Input() type: any;
    @Input() orderHeaderText: any;
    @Input() allShippingMethods: any;
    @Input() footerTaxEnabled;
    @Input() accountChannels;
    @Input() footerDiscountEnabled;
    @Input() selectedEstimate: any;
    @Input() selectedReturn: any;
    @Input() selectedOrder: any;
    @Input() displayConvertToSalesOrder: boolean;
    @Input() templates: any;
    @Input() allTemplates: any;
    @Input() allCustomAttributes: any;
    @Input() isEnabledBackOrder;
    @Input() isEnabledBackOrderKit;
    @Input() isEnabledBackOrderBundle;
    @Input() estimateObjectId;
    @Input() customerRmaObjectId;
    @Input() salesObjectId;
    @Input() invoiceObjectId;
    @Input() billingAddressType;
    @Input() shippingAddressType;
    @Input() isOrderVoid;
    @Input() showOrderVoidMsg;
    @Input() orgHeadOfficeAddress;
    @Input() newStage;
    @Input() isOrderToBeShipped = false;
    @Input() selectedChannel: any;

    @Output() onSaveComplete = new EventEmitter();
    @Output() onCancelClicked = new EventEmitter();
    @Output() onVoidSO = new EventEmitter();
    @Output() onHoldSO = new EventEmitter();

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();
    @ViewChild("editor") editor: any;
    @ViewChild("editCurrency") overlayPanel: OverlayPanel;

    allTax: any[] = [];
    allPaymentTerms: any[] = [];
    allPaymentMethods: any[] = [];
    allShippingTerms: any[] = [];
    allUser: any[] = [];
    allLocations: any[] = [];
    orderChannels: any[] = [];
    shippingMethods: any[] = [];
    aggregateDiscount: boolean = false;
    pricebookConfig: boolean = false;

    combinedCustomFields = {
        billing_address_item: [],
        shipping_address_item: [],
        misc_item: [],
        section_item: [],
        footer_item: [],
        message_item: [],
        other1_item: [],
        other2_item: [],
        other3_item: [],
    };

    allChecked: boolean = false;
    isVisibleRowTax = false;
    isVisibleRowDiscount = false;
    isVisibleFooterTax = false;
    isVisibleFooterDiscount = false;
    stageId = 1;
    contactType = ContactSelectionType;
    typeIds = TypeIds;
    options: any = {};
    allAccountsDD: any[] = [];
    accountInfo;
    accountAddressInfo;
    shippingAddressInfo;
    contactInfo;
    selectedAccountAddress;
    selectedShippingAddress;
    displayAccountAddress = false;
    displayShippingAddress = false;
    allStatus: any[] = [];
    allProductsData: any[] = [];
    allStages: any[] = [];
    purchaseListTB: any[] = [];
    orderTotal: number = 0;
    sumTotal: number = 0;
    discount: number = 0;
    tax: number = 0;
    taxRate: number = 0;
    productsTotal: number = 0;
    selectedProductsList: any[] = [];
    soTax;
    selectedWarehouseList: any[] = [];
    selectedPL: any[] = [];
    shippingAddressContact;
    billingAddressContact;
    displayContactSelectionModal = false;
    contactSelectionModalType = "";
    accHoldMsg: string = "";
    selectedContact;

    defaultTax = [
        {
            id: 0,
            name: "Tax",
            taxRate: 5.01,
            value: 5.01,
        },
    ];

    soForm: FormGroup;
    triangle = "fa fa-caret-down";
    minimumDate = this.app._showDateTimeWithZone(new Date());
    displayOpenWarehouseList = false;
    warehouseLists: any[] = [];
    estDetails;
    returnDetails;
    soDetails;
    selectedBackOrderOption = 0;
    displayBackOrderOption = false;
    // for product dialog
    displayProductsTb = false;
    pageNumber: number = 1;
    productGlobalSearch = "";
    selectedTBChannel;
    pageSize = 15;
    selectedLocation;
    totalTBRecord;
    allProducts;
    productsData;
    productsTB;
    noCaseFindOrLoadingText;
    productChannels;
    filters: string;
    searchValue: string = "";
    searchColumns: string = "";
    sortBy: string = "";
    isAscending: string = "false";
    allowedExtensions = [".png", ".jpg", ".jpeg", ".gif"]; // For the attachment files
    disableLocation = true;
    selectedProductForScan;
    selectedBundleForScan;
    selectedKitForScan;
    displayScanInfo = false;
    trackingForm: FormGroup;
    listLength = 0;
    nameLists: any[] = [];
    autoGenerateLists: any[] = [];
    productHeader;
    showScanInfoTB = false;
    showScanInfoTB2 = false;
    nameListsTB: any[] = [];
    nameListsTB2: any[] = [];
    isLot: boolean;
    isRevision: boolean;
    isDate: boolean;
    statementMessege: string = "";
    minDate: Date = new Date(1988, 0, 1);
    maxDate: Date = new Date(2050, 11, 31);
    selectedBundle;
    displayProductSelectionModal = false;
    moduleName = "Invoice";
    isVisibleLocation = false;
    selectedLocationId = 0;
    headerText = "Products List";
    autoResize = true;
    cols = 0;
    footerlabelColSpan = 0;
    footerValueColSpan = 0;
    isDisabledSaveBtn = false;
    soStage = SoStageId;
    productSerialSettings;
    allAccounts: any[] = [];
    invoiceToBeCreated = false;

    couponValue;
    displayCouponList = false;
    couponLists = [
        {
            id: 1,
            code: "freeshipping",
            name: "Free Shipping",
            type: "Assigned to order total",
            limitation: "Unlimited",
            value: "$10",
        },
        {
            id: 2,
            code: "blackfriday",
            name: "Black Friday",
            type: "Assigned to shipping",
            limitation: "1 time only",
            value: "15%",
        },
        {
            id: 3,
            code: "firstorder",
            name: "First Order",
            type: "Assigned to order subtotal",
            limitation: "1 time per customer",
            value: "10%",
        },
    ];
    selectedCoupon;
    soStatus = SalesOrderStatus;
    soChannel = SOChannel;
    isAvailableEnoughAccCredit = true;
    accCreditMsg = accCreditMsg;

    //tracking
    isPrefix: boolean = false;
    disabledSave: boolean = false;
    isAutoGenerated: boolean = false;
    prefixValue: string = "";
    displayImport = false;
    first: number = 0;
    rowsPerPageTB = [100, 200, 300, 500];
    systemTrackingData: any[] = [];
    @Input() trackingOptions = [];
    unMatchedSerials: any[] = [];
    serialConfig;
    refId: string = '';
    displayTracking: boolean = false;
    scanQty = 0;
    importForAllProducts: boolean = false;
    disabledCheckbox = false;
    isAutoPick = false;
    isAutoPack = false;

    displayAppliedAmountViewModal = false;
    dialogType = DialogType;
    displayAccountViewEdit: boolean = false;
    selectedAccountId: number;
    selectedAccountChannelId: number;
    filteredSection: any[] = [];
    measurementUnits: any[] = [];
    decimalPlacesMap: { [key: number]: number } = {};
    selectedProduct: any;
    currencies = [];
    defaultCurrency: Currency;

    /** SalesOrder Context Menu */
    isContextMenuVisible = false;
    productconfigMenu = [
        {
            label: "Copy",
            icon: "pi pi-copy",
            visible: true,
            command: () => {
                this.copyProduct();
            },
        },
    ];

    /** Additional Discounts */
    discountOptions: any[] = [];
    additionalDiscounts: any[] = [];
    additionalDiscountRateTypes: any[] = [];
    additionalDiscountAmount: Number = 0;

    /** Tax */
    taxSettings: any;
    taxConfig: any;
    allTaxRates: any[] = []; // account based taxes
    subTaxCodeNames = "";
    orderTotalTax = 0;
    displayTaxSelectionDialog: boolean = false;
    selectedTax: any;
    appliedTax: any;
    currentProduct: any;
    currentProductType: string;
    taxDialogContext: 'product' | 'footer' | null = null;

    // additional Fees
    additionalFees: any[] = [];
    totalAdditionalFee: number = 0;
    productsTotalAdditionalFee: number = 0;

    // credit memo selection
    displayCreditSelect: boolean = false;
    creditAppliedTotal: number = 0;
    totalCreditAmount: number = 0;
    selectedCredits: any[] = [];
    receivedPayment: any;
    applyCreditMemoType: string = "";
    // fraction digits
    fractionDigits: number = 0;
    qtyFractionDigits: number = 0;
    creditControl = CreditControlEnum;
    //footer & line level discount & fee
    selectedDProduct: any = null;
    selectedHProduct: any = null;
    lineLevelDiscounts: any[] = [];
    footerLevelDiscounts: any[] = [];
    lineLevelHandlingFees: any[] = [];
    footerLevelHandlingFees: any[] = [];
    FeeOrDiscountContext = FeeOrDiscountContext;
    feeOrDiscountContext: FeeOrDiscountContext;
    DialogTypeFeeOrDiscount = DialogTypeFeeOrDiscount;
    currentDialogType: DialogTypeFeeOrDiscount;
    displayFeeOrDiscountDialog = false;
    isFooterDiscount: boolean = false;
    // currency
    baseCurrency: any;
    orgCurrency = [];
    currencyExchangeRate: number;
    savedCurrencyExchangeRate: number;
    previousCurrencyExchangeRate: number;

    // posting period
    currentPostingPeriodInfo: IPostingPeriodDetails;
    updatedPostingPeriodInfo: IPostingPeriodDetails;
    isAllowPostingPeriod: boolean = false;

    constructor(
        public app: AppMainComponent,
        private fb: FormBuilder,
        private salesOrderService: SalesOrderService,
        private messageService: MessageService,
        public datepipe: DatePipe,
        private appMainService: AppMainService,
        public utilityService: UtilityService,
        private confirmationService: ConfirmationService,
        private soStageChangeService: SoStageChangeService,
        private soShipmentService: SoShipmentService,
        private accountsHttpService: AccountsHttpService,
        private paymentTermService: PaymenttermService,
        private paymentMethodService: PaymentmethodService,
        private shippingtermService: ShippingtermService,
        private productsService: ProductsService,
        private productDataService: ProductDataService,
        private receivedPaymentRequestBuilderService: ReceivedPaymentRequestBuilderService,
        private importService: ImportserialService,
        private renderer: Renderer2,
        private accountServiceN: AccountServiceN,
        private titlecasePipe: TitleCasePipe,
        private accountFlatteningService: AccountFlatteningService,
        private accountDataService: AccountLeadDataService,
        private utilService: UtilsService,
        private productCalculationUtilityService: ProductCalculationUtilityService,
    ) {}

    ngOnInit(): void {
        this.getFractionDigits();
        this.getQtyDecimalDigits();
        this.fetchUnitOfMeasureCategories();
        this.getBaseCurrency();
        this.initForm();
        this.utilityService.getFilteredSectionsByType(0).subscribe((res) => {
            this.filteredSection = res;
        });
        const iSettings = this.utilityService.getISettings();
        this.isAllowPostingPeriod = iSettings?.find((obj) => obj.code === "posting")?.enabled ?? false;
    }
    ngOnChanges(changes: SimpleChanges): void {
        if (changes.displayConvertToSalesOrder && changes.displayConvertToSalesOrder.currentValue) {
            this.displayConvertToSalesOrder = changes.displayConvertToSalesOrder.currentValue;
            this.stageId = 1;
            this.selectedBackOrderOption = 0;
            this.isDisabledSaveBtn = false;
        }
        if (changes.allShippingMethods && changes.allShippingMethods.currentValue) {
            this.allShippingMethods = changes.allShippingMethods.currentValue;
            this.shippingMethods = this.utilityService.prepareShippingMethods(this.allShippingMethods);
        }
        if (changes.templates && changes.templates.currentValue) {
            this.templates = changes.templates.currentValue;
            this.checkTaxDiscountVisibility();
        }
        if (changes.type && changes.type.currentValue) {
            this.type = changes.type.currentValue;
            this.isAvailableEnoughAccCredit = true;
            this.initForm();
            this.loadData();
            this.getColsCount();
            this.selectedCredits = [];
            this.applyCreditMemoType = "";
            this.loadCurrencies();
        }
    }
    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }
    getFractionDigits() {
        this.importService
            .getDecimalValue()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (value) => {
                    if (value) {
                        this.fractionDigits = value;
                    }
                },
                error: (error) => {},
            });
    }
    getQtyDecimalDigits() {
        this.importService.getQtyDecimalValue().subscribe((value) => {
            if (value) {
                this.qtyFractionDigits = value;
            }
        });
    }
    fetchUnitOfMeasureCategories() {
        this.salesOrderService.fetchUnitOfMeasureCategories().subscribe((resp) => {
            this.measurementUnits = resp;
        });
    }
    getBaseCurrency() {
        this.importService
            .getOrgCurrency()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((value) => {
                if (value) {
                    this.baseCurrency = value.find((cr) => cr.isBaseCurrency);
                    this.orgCurrency = value;
                }
            });
    }
    loadData() {
        this.appMainService.isShowSpinner("loadData");
        const taxObservable = this.salesOrderService.getAllTax().pipe(catchError((error) => this.handleError("Payment Term", error)));
        const orderChannelsObservable = this.salesOrderService.getAllOrdersChannel("Orders Type").pipe(catchError((error) => this.handleError("Order Channels", error)));
        const shippingTermObservable = this.shippingtermService.getShippingTermList().pipe(catchError((error) => this.handleError("Shipping Term", error)));
        const allUserObservable = this.salesOrderService.getAllUser().pipe(catchError((error) => this.handleError("All User", error)));
        const allLocationObservable = this.salesOrderService.getAllLocations("0", "0", "").pipe(catchError((error) => this.handleError("All Location", error)));
        const allTiersObservable = this.productsService.getAllTiers().pipe(catchError((error) => this.handleError("All Tiers", error)));
        const discountSelectionObservable = this.salesOrderService.getAllDiscountOption("TierApplicationRule").pipe(catchError((error) => this.handleError("Discount Selection", error)));
        const additionalDiscountObservable = this.salesOrderService.getDiscounts(false).pipe(catchError((error) => this.handleError("Discount", error)));
        const additionalFeesObservable = this.salesOrderService.getAdditionalFees().pipe(catchError((error) => this.handleError("Additional Fees", error)));

        forkJoin([taxObservable, orderChannelsObservable, shippingTermObservable, allUserObservable, allLocationObservable, allTiersObservable, discountSelectionObservable, additionalDiscountObservable, additionalFeesObservable]).subscribe(
            ([taxData, orderChannelData, shippingTermData, allUserData, allLocationData, allTiersData, discountSelectionData, additionalDiscounts, additionalFees]) => {
                this.setAllTaxData(taxData);
                this.setOrderChannelData(orderChannelData);
                this.setShippingTermData(shippingTermData);
                this.setAllUserData(allUserData);
                this.setAllLocationData(allLocationData);
                this.setAllTiersData(allTiersData);
                this.setDiscountSelectionData(discountSelectionData);
                this.setAdditionalDiscounts(additionalDiscounts);
                this.setAdditionalFees(additionalFees);

                if (this.type == DialogType.CONVERT) {
                    this.initCustomFields();
                    this.getEstimateDetailsById();
                } else if (this.type == DialogType.CONVERT_FROM_RMA) {
                    this.initCustomFields();
                    this.initConvertToSalesOrderFromRMA();
                } else if (this.type == DialogType.CREATE) {
                    this.filterActiveAccounts();
                    this.filterActiveLocations();
                    this.initCustomFields();
                    this.initCreateSalesOrder();
                } else if (this.type == DialogType.EDIT || this.type == DialogType.VIEW || this.type == DialogType.COPY) {
                    this.initCustomFields();
                    this.prepareSalesOrderDataToView();
                }
                this.appMainService.isHideSpinner("loadData");
            },
            (error) => {
                this.appMainService.isHideSpinner("loadData");
                this.messageService.add({ severity: "error", summary: "Error", detail: "Error occurred..." });
            },
        );
    }

    initForm() {
        this.soForm = this.fb.group({
            id: [0],
            accountChannel: [this.accountChannels?.filter((ac) => ac.isDefault == true)[0]],
            account: ["", Validators.required],
            estimateDate: [this.app._showDateTimeWithZone(new Date())],
            expiryDate: [this.app._showDateTimeWithZone(new Date())],
            salesOrderStage: [""],
            salesOrderStatus: [""],
            reference: [""],
            shippingChargeAmount: [0],
            taxAmount: [0],
            discountType: [null],
            discountValue: [0],
            // couponValue: [""],
            vendorMessage: [""],
            memo: [""],
            paymentTerm: [""],
            paymentMethod: [""],
            shippingTerm: [""],
            shippingMethod: [""],
            salesRep: [""],
            tax: [""],
            location: [""],
            statusId: [true],
            trackingNo: [""],
            additionalDiscountRate: [0],
            additionalDiscountType: [null],
            additionalDiscountTypeName: [null],
            additionalFeeType: [null],
            additionalFee: [0],
        });
        this.minDate = new Date(2000, 0, 1);
        this.maxDate = new Date(2050, 11, 31);
        this.prepareTrackingForm();
    }

    /** New Sales Order */

    /*** Initialize required data for creating new sales order */
    initCreateSalesOrder() {
        this.initForm();
        this.accountInfo = null;
        this.accountAddressInfo = null;
        this.shippingAddressInfo = null;
        this.selectedAccountAddress = null;
        this.selectedShippingAddress = null;
        this.billingAddressContact = null;
        this.shippingAddressContact = null;
        this.sumTotal = 0;
        this.orderTotal = 0;
        this.allProductsData = [];
        this.purchaseListTB = [];
        this.allPaymentTerms = [];
        this.allPaymentMethods = [];

        this.combinedCustomFields = this.utilityService.getCustomAttributesForCommon(this.templates, this.allCustomAttributes);
        const salesChannel = this.orderChannels?.filter((s) => s.name == this.soChannel.SALES_ORDER)[0];
        this.allStages = salesChannel?.stages;
        const selectedStageId = this.allStages[0]?.id;
        this.allStatus = this.allStages.filter((s) => s.id == selectedStageId)[0].status;
        if (this.allLocations && this.allLocations.length) {
            this.soForm?.controls["location"].setValue(this.allLocations.filter((l) => l.isDefault == true)[0]);
        }
        if (this.shippingMethods && this.shippingMethods.length) {
            this.soForm?.controls["shippingMethod"].setValue(this.shippingMethods.filter((sm) => sm.isDefault == true)[0]);
        }
        if (this.allAccounts && this.allAccounts.length) {
            this.soForm?.controls["accountChannel"].setValue(this.accountChannels?.filter((ac) => ac.isDefault == true)[0]);
        }
        if(this.accountChannels && this.accountChannels?.length > 0) {
            this.soForm?.controls["accountChannel"].setValue(this.accountChannels?.filter((ac) => ac?.id == this.selectedChannel?.id)[0]);
        }
        
        // this.soForm?.controls["discountType"].setValue(this.discountOptions[0]);
        this.soForm?.controls["estimateDate"].setValue(this.app._showDateTimeWithZone(new Date()));
        this.soForm?.controls["salesOrderStage"].setValue(this.allStages[0]);
        this.soForm?.controls["salesOrderStatus"].setValue(this.allStatus[0]);
        this.soForm?.controls["salesOrderStage"].disable();
        this.soForm?.controls["tax"].setValue(this.soTax);
        this.taxRate = this.soTax && this.soTax?.taxRate ? this.soTax?.taxRate : 0;
    }
    filterActiveLocations() {
        const loc = _.cloneDeep(this.allLocations);
        if (loc && loc.length) {
            this.allLocations = loc.filter((l) => l.statusId == 1);
        }
    }

    filterActiveAccounts() {
        const acc = _.cloneDeep(this.allAccounts);
        if (acc && acc.length) {
            this.allAccounts = acc.filter((a) => a.statusId == 1);
        }
    }

    /** End New Sales Order */

    /** View Sales Order  */

    prepareSalesOrderDataToView() {
        this.initForm();
        this.allPaymentTerms = [];
        this.allPaymentMethods = [];
        this.appMainService.isShowSpinner("loadSO");
        this.salesOrderService
            .getSalesOrderDetailsById(this.selectedOrder.id)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(async (res) => {
                this.appMainService.isHideSpinner("loadSO");
                await this.prepareSalesOrderDetailsData(res);
            });
    }
    async prepareSalesOrderDetailsData(res) {
        this.allProductsData = [];
        this.purchaseListTB = [];
        this.selectedProductsList = [];
        this.soDetails = _.cloneDeep(res);
        this.savedCurrencyExchangeRate = Number(this.soDetails.exchangeRate);
        const currentYear = this.app._showDateTimeWithZone(this.soDetails?.salesOrderDate).getFullYear();
        this.minDate = new Date(currentYear, 0, 1);
        this.maxDate = new Date(currentYear, 11, 31);
        this.selectedBackOrderOption = this.soDetails?.backOrderTypeId;
        const salesChannel = this.orderChannels?.filter((s) => s.name == this.soChannel.SALES_ORDER)[0];
        this.allStages = this.type == DialogType.COPY && this.soDetails?.salesOrderStageId !== 1 ? [salesChannel?.stages[0]] : salesChannel?.stages?.filter((s) => Number(s.id) >= Number(this.soDetails?.salesOrderStageId));
        this.allStatus = this.type == DialogType.COPY && this.soDetails?.salesOrderStageId !== 1 ? salesChannel?.stages[0]?.status : this.allStages?.filter((s) => s.id == this.soDetails?.salesOrderStageId)[0].status;
        this.templates = this.soDetails && this.soDetails.configJSON ? JSON.parse(this.soDetails.configJSON) : this.templates;
        this.combinedCustomFields = this.utilityService.getCustomAttributesForCommon(this.templates, this.allCustomAttributes);
        this.stageId = this.soDetails?.salesOrderStageId;
        this.accountInfo = this.soDetails?.account;
        if (this.accountInfo) {
            this.accountInfo["nameWithSequenceNumber"] = this.accountInfo?.["sequenceNumber"] + "-" + this.accountInfo?.["businessName"];
        }
        this.getcurrencyExchangeRate();
        this.discount = this.soDetails?.discountAmount;
        this.taxRate = this.soDetails?.tax && this.soDetails?.tax?.taxRate ? this.soDetails.tax.taxRate : 0;
        const iSettings = this.utilityService.getISettings();
        this.isAutoPick = iSettings?.find((i) => i?.code?.toLowerCase() == "autopick")?.enabled ?? false;
        this.isAutoPack = iSettings?.find((i) => i?.code?.toLowerCase() == "autopack")?.enabled ?? false;
        this.serialConfig = iSettings?.find((value) => value.code == "enableserial");
        this.creditAppliedTotal = this.soDetails?.appliedAmount ?? 0;
        this.getColsCount();
        this.checkTaxDiscountVisibility();
        this.filterPaymentTermsAndMethods();
        this.setSalesOrderFormValueToView();
        await this.setAddressAndContactData();
        this.setDiscountValue(this.soDetails);
        this.prepareProductsListToView();
        this.setCustomFieldValueToView();

        /*** If status is hold or cancel or inactive, user is not allowed to perform stage change */
        const stName = this.soDetails.salesOrderStatus;
        if (stName == "Hold" || stName == "Cancel" || this.soDetails.statusId == Status.InActive || this.type == DialogType.EDIT) {
            this.soForm?.controls?.salesOrderStage.disable();
        }

        /** if type is edit location dropdown is disabled */
        if (this.type == DialogType.COPY) {
            this.stageId = SoStageId.Entered;
            this.soForm?.controls?.location.enable();
            this.setProductsInitialQtyForCopy();
        } else {
            this.soForm?.controls?.location.disable();
        }
        if (this.type == "VIEW") {
            this.soForm.disable();
        }
    }
    prepareProductsListToView(): void {
        this.allProductsData = this.soDetails?.salesOrderProducts?.map((product) => {
            /** Bundle Products */
            const bundleDetails: ISalesOrderBundleProductList[] = (product?.salesOrderBundleDetail || []).map((bundle) => {
                /** Kit/Bundle under Kit Products */
                const kitDetails: ISalesOrderBundleProductList[] = (bundle.childSalesOrderBundleDetail || []).map((kp) => {
                    const kunit = kp?.product?.productUOM?.find((uom) => uom.unitOfMeasureId === kp.productUOMId);
                    const kitDiscountType = this.discountOptions?.find((option) => option.id === kp.discountId);
                    const ktotalAvailQty = this.utilityService.getAvailQty(kp.productWarehouseDetailDTO, this.soDetails.warehouseId, kp.subProductId);
                    const kPickedQty = this.isOrderToBeShipped && this.soDetails.salesOrderStageId == SoStageId.Entered && this.isAutoPick ? kp.quantity : kp.pickedQty;
                    const kPackedQty = this.isOrderToBeShipped && this.soDetails.salesOrderStageId == SoStageId.Entered && this.isAutoPack ? kPickedQty : this.isOrderToBeShipped && this.soDetails.salesOrderStageId == SoStageId.Pick && this.isAutoPack ? kPickedQty : kp.packedQty;
                    let kitBackOrderQty = 0;
                    if (this.soDetails.salesOrderStageId == SoStageId.Shipped) {
                        kitBackOrderQty = kp.backOrderQty ?? 0;
                    } else {
                        if (this.isEnabledBackOrder) {
                            if (product.product?.typeId == TypeIds.KitTypeId && this.isEnabledBackOrderKit && kp.quantity > kPackedQty) {
                                kitBackOrderQty = kp.quantity - kPackedQty;
                            }
                        }
                    }
                    return {
                        id: kp.subProductId,
                        uuid: uuidv4(),
                        rowId: kp.id,
                        typeId: kp.product.typeId,
                        parentBundleId: kp.parentBundleId,
                        itemNo: kp.product.itemNo,
                        hsnsac: kp?.product?.hsnsac,
                        description: kp.description || "",
                        uom: kp.product.productUOM,
                        unit: kunit,
                        currentVal: kp.quantity,
                        availableQuantity: ktotalAvailQty ?? 0,
                        availabel: ktotalAvailQty ?? 0,
                        ordQty: kp.quantity,
                        originalQty: kp.originalQty,
                        bundleQty: kp.quantity,
                        cost: Number(kp?.product?.productPrice?.buyPrice ?? 0) * this.savedCurrencyExchangeRate,
                        price: Number(kp?.pricePerProduct ?? 0) * this.savedCurrencyExchangeRate,
                        originalprice: Number(kp.product?.accountProductPriceTiers?.find((tier) => tier.tierId === kp.product?.selectedtierId)?.calculatedPricePerQty),
                        accountPriceTier: kp.product?.accountProductPriceTiers,
                        isCustom: kp.product?.isCustom,
                        discountTypeName: kp.product?.tierTypeName,
                        selectedTierId: kp.product?.selectedtierId,
                        salesOrderBundleProductSerialDetail: kp.salesOrderBundleProductSerialDetail,
                        pickedQty: kPickedQty,
                        packedQty: kPackedQty,
                        shippedQty: kp.shippedQty,
                        discountType: kitDiscountType,
                        taxType: kp.tax || "",
                        discount: kp.discountRate ?? 0,
                        discountAmount: Number(kp.discountAmount) * this.savedCurrencyExchangeRate,
                        taxAmount: Number(kp.taxRate) * this.savedCurrencyExchangeRate,
                        totalQohInSelectedWareHouse: 0,
                        totalAvailInSelectedWareHouse: ktotalAvailQty,
                        subTotal: this.isOrderToBeShipped && kPackedQty == 0 ? 0 : !this.isOrderToBeShipped && this.soDetails.salesOrderStageId == SoStageId.Pick && kp.pickedQty == 0 ? 0 : !this.isOrderToBeShipped && (this.soDetails.salesOrderStageId == SoStageId.Pack || this.soDetails.salesOrderStageId == SoStageId.Verification || this.soDetails.salesOrderStageId == SoStageId.Labelling) && kp.packedQty == 0 ? 0 : Number(kp.totalAmount) * this.savedCurrencyExchangeRate,
                        baseSubTotal: this.isOrderToBeShipped && kPackedQty == 0 ? 0 : !this.isOrderToBeShipped && this.soDetails.salesOrderStageId == SoStageId.Pick && kp.pickedQty == 0 ? 0 : !this.isOrderToBeShipped && (this.soDetails.salesOrderStageId == SoStageId.Pack || this.soDetails.salesOrderStageId == SoStageId.Verification || this.soDetails.salesOrderStageId == SoStageId.Labelling) && kp.packedQty == 0 ? 0 : Number(kp.subTotal) * this.savedCurrencyExchangeRate,
                        totalQuantity: kp.totalQty,
                        isTrackingRequired: kp.product?.isTrackingRequired || false,
                        serialSettings: kp.product?.serialSettings ? JSON.parse(kp.product?.serialSettings) : null,
                        bundleDetailSubTax: kp.salesOrderBundleDetailSubTax,
                        productCategory: kp.product?.productCategories || [],
                        warehouseId: kp.product?.warehouseProduct[0]?.warehouseId,
                        binDetails: kp.productWarehouseDetailDTO?.[0]?.binDetail,
                        selectedBin: kp.productWarehouseDetailDTO?.[0]?.binDetail?.find((bin) => bin.binId == kp.binId),
                        backOrderQty: kitBackOrderQty,
                        isDuplicatedProduct: kp?.isCopied ?? false,
                        costPrice: Number(kp.costPrice ?? 0) * this.savedCurrencyExchangeRate,
                        totalCostPrice: Number(kp.totalCostPrice ?? 0) * this.savedCurrencyExchangeRate,
                    };
                });

                const unit = bundle?.product?.productUOM?.find((uom) => uom.unitOfMeasureId === bundle.productUOMId);
                const bundleDiscountType = this.discountOptions?.find((option) => option.id === bundle.discountId);
                const btotalAvailQty = this.utilityService.getAvailQty(bundle.productWarehouseDetailDTO, this.soDetails.warehouseId, bundle.subProductId);
                const bPickedQty = this.isOrderToBeShipped && this.soDetails.salesOrderStageId == SoStageId.Entered && this.isAutoPick ? bundle.quantity : bundle.pickedQty;
                const bPackedQty = this.isOrderToBeShipped && this.soDetails.salesOrderStageId == SoStageId.Entered && this.isAutoPack ? bPickedQty : this.isOrderToBeShipped && this.soDetails.salesOrderStageId == SoStageId.Pick && this.isAutoPack ? bPickedQty : bundle.packedQty;
                let bundleBackOrderQty = 0;
                if (this.soDetails.salesOrderStageId == SoStageId.Shipped) {
                    bundleBackOrderQty = bundle.backOrderQty ?? 0;
                } else {
                    if (this.isEnabledBackOrder) {
                        if (product.product?.typeId == TypeIds.BundleTypeId && this.isEnabledBackOrderBundle && bundle.quantity > bPackedQty) {
                            bundleBackOrderQty = bundle.quantity - bPackedQty;
                        } else if (product.product?.typeId == TypeIds.KitTypeId && this.isEnabledBackOrderKit && bundle.quantity > bPackedQty) {
                            bundleBackOrderQty = bundle.quantity - bPackedQty;
                        }
                    }
                }
                return {
                    id: bundle.subProductId,
                    uuid: uuidv4(),
                    rowId: bundle.id,
                    typeId: bundle.product.typeId,
                    itemNo: bundle.product.itemNo,
                    hsnsac: bundle?.product?.hsnsac,
                    description: bundle.description || "",
                    uom: bundle?.product?.productUOM,
                    unit: unit,
                    currentVal: bundle.quantity,
                    availableQuantity: btotalAvailQty ?? 0,
                    availabel: btotalAvailQty ?? 0,
                    ordQty: bundle.quantity,
                    originalQty: bundle.originalQty,
                    bundleQty: bundle.quantity,
                    cost: Number(bundle?.product?.productPrice?.buyPrice ?? 0) * this.savedCurrencyExchangeRate,
                    price: Number(bundle?.pricePerProduct ?? 0) * this.savedCurrencyExchangeRate,
                    originalprice: Number(bundle.product?.accountProductPriceTiers?.find((tier) => tier.tierId === bundle.product?.selectedtierId)?.calculatedPricePerQty),
                    accountPriceTier: bundle.product?.accountProductPriceTiers,
                    isCustom: bundle.product?.isCustom,
                    discountTypeName: bundle.product?.tierTypeName,
                    selectedTierId: bundle.product?.selectedtierId,
                    salesOrderBundleProductSerialDetail: bundle.salesOrderBundleProductSerialDetail,
                    pickedQty: bPickedQty,
                    packedQty: bPackedQty,
                    shippedQty: bundle.shippedQty,
                    discountType: bundleDiscountType,
                    taxType: bundle.tax || "",
                    discount: bundle.discountRate ?? 0,
                    discountAmount: Number(bundle.discountAmount) * this.savedCurrencyExchangeRate,
                    taxAmount: Number(bundle.taxRate) * this.savedCurrencyExchangeRate,
                    totalQohInSelectedWareHouse: 0,
                    totalAvailInSelectedWareHouse: btotalAvailQty,
                    subTotal: this.isOrderToBeShipped && bPackedQty == 0 ? 0 : !this.isOrderToBeShipped && this.soDetails.salesOrderStageId == SoStageId.Pick && bundle.pickedQty == 0 ? 0 : !this.isOrderToBeShipped && (this.soDetails.salesOrderStageId == SoStageId.Pack || this.soDetails.salesOrderStageId == SoStageId.Verification || this.soDetails.salesOrderStageId == SoStageId.Labelling) && bundle.packedQty == 0 ? 0 : Number(bundle.totalAmount) * this.savedCurrencyExchangeRate,
                    baseSubTotal: this.isOrderToBeShipped && bPackedQty == 0 ? 0 : !this.isOrderToBeShipped && this.soDetails.salesOrderStageId == SoStageId.Pick && bundle.pickedQty == 0 ? 0 : !this.isOrderToBeShipped && (this.soDetails.salesOrderStageId == SoStageId.Pack || this.soDetails.salesOrderStageId == SoStageId.Verification || this.soDetails.salesOrderStageId == SoStageId.Labelling) && bundle.packedQty == 0 ? 0 : Number(bundle.subTotal) * this.savedCurrencyExchangeRate,
                    totalQuantity: bundle.totalQty,
                    isTrackingRequired: bundle.product?.isTrackingRequired || false,
                    serialSettings: bundle.product?.serialSettings ? JSON.parse(bundle.product?.serialSettings) : null,
                    bundleDetailSubTax: bundle.salesOrderBundleDetailSubTax,
                    productCategory: bundle.product?.productCategories || [],
                    warehouseId: bundle.product?.warehouseProduct[0]?.warehouseId,
                    binDetails: bundle.productWarehouseDetailDTO?.[0]?.binDetail,
                    selectedBin: bundle.productWarehouseDetailDTO?.[0]?.binDetail?.find((bin) => bin.binId == bundle.binId),
                    backOrderQty: bundleBackOrderQty,
                    bundleDetails: kitDetails,
                    isDuplicatedProduct: bundle?.isCopied ?? false,
                    additionalFeeType: this.additionalFees?.find((af) => af.id == bundle?.additionalFeesId),
                    additionalFee: bundle?.additionalRate ?? 0,
                    additionalFeeAmount: Number(bundle?.additionalAmount ?? 0) * this.savedCurrencyExchangeRate,
                    costPrice: Number(bundle.costPrice ?? 0) * this.savedCurrencyExchangeRate,
                    totalCostPrice: Number(bundle.totalCostPrice ?? 0) * this.savedCurrencyExchangeRate,
                };
            });

            /** Product */
            const uom = product.product.productUOM?.find((po) => po.unitOfMeasureId === product.productUOMId);
            const productDiscountType = this.discountOptions?.find((option) => option.id === product.discountId);
            const totalAvailQty = this.utilityService.getAvailQty(product.productWarehouseDetailDTO, this.soDetails.warehouseId, product.productId);
            const productPickedQty = this.isOrderToBeShipped && this.soDetails.salesOrderStageId == SoStageId.Entered && this.isAutoPick ? product.quantity : product.pickedQty;
            const productPackedQty = this.isOrderToBeShipped && this.soDetails.salesOrderStageId == SoStageId.Entered && this.isAutoPack ? productPickedQty : this.isOrderToBeShipped && this.soDetails.salesOrderStageId == SoStageId.Pick && this.isAutoPack ? productPickedQty : product.packedQty;
            let productBackOrderQty = 0;
            if (this.soDetails.salesOrderStageId == SoStageId.Shipped) {
                productBackOrderQty = product.backOrderQty ?? 0;
            } else if (this.isEnabledBackOrder && product.product?.typeId == TypeIds.InventoryTypeId && product.quantity > productPackedQty) {
                productBackOrderQty = product.quantity - productPackedQty;
            }
            return {
                id: product.productId,
                uuid: uuidv4(),
                rowId: product.id,
                itemNo: product.product.itemNo,
                hsnsac: product?.product?.hsnsac,
                description: product.description || "",
                uom: product.product.productUOM,
                unit: uom,
                availableQuantity: totalAvailQty ?? 0,
                availabel: totalAvailQty ?? 0,
                ordQty: product.quantity,
                cost: Number(product?.product?.productPrice?.buyPrice ?? 0) * this.savedCurrencyExchangeRate,
                price: Number(product?.pricePerProduct ?? 0) * this.savedCurrencyExchangeRate,
                originalprice: Number(product.product?.accountProductPriceTiers?.find((tier) => tier.tierId === product.product?.selectedtierId)?.calculatedPricePerQty),
                accountPriceTier: product.product?.accountProductPriceTiers,
                isCustom: product.product?.isCustom,
                discountTypeName: product.product?.tierTypeName,
                selectedTierId: product.product?.selectedtierId,
                currentVal: product.quantity,
                pickedQty: productPickedQty,
                packedQty: productPackedQty,
                shippedQty: product.shippedQty,
                salesOrderSerialDetails: this.type == DialogType.COPY ? [] : product.salesOrderSerialDetail || [],
                typeId: product.product.typeId,
                bundleDetails: bundleDetails,
                productBundleLink: this.type == DialogType.COPY ? [] : product.product.productBundleLink || [],
                discountType: productDiscountType,
                taxType: product.tax || "",
                discount: product.discountRate ?? 0,
                discountAmount: Number(product.discountAmount) * this.savedCurrencyExchangeRate,
                taxAmount: Number(product.taxRate) * this.savedCurrencyExchangeRate,
                totalQohInSelectedWareHouse: 0,
                totalAvailInSelectedWareHouse: totalAvailQty,
                subTotal: this.isOrderToBeShipped && productPackedQty == 0 ? 0 : !this.isOrderToBeShipped && this.soDetails.salesOrderStageId == SoStageId.Pick && product.pickedQty == 0 ? 0 : !this.isOrderToBeShipped && (this.soDetails.salesOrderStageId == SoStageId.Pack || this.soDetails.salesOrderStageId == SoStageId.Verification || this.soDetails.salesOrderStageId == SoStageId.Labelling) && product.packedQty == 0 ? 0 : Number(product.totalAmount) * this.savedCurrencyExchangeRate,
                baseSubTotal: this.isOrderToBeShipped && productPackedQty == 0 ? 0 : !this.isOrderToBeShipped && this.soDetails.salesOrderStageId == SoStageId.Pick && product.pickedQty == 0 ? 0 : !this.isOrderToBeShipped && (this.soDetails.salesOrderStageId == SoStageId.Pack || this.soDetails.salesOrderStageId == SoStageId.Verification || this.soDetails.salesOrderStageId == SoStageId.Labelling) && product.packedQty == 0 ? 0 : Number(product.subTotal) * this.savedCurrencyExchangeRate,
                totalQuantity: product.totalQty,
                isTrackingRequired: product.product?.isTrackingRequired || false,
                serialSettings: product.product?.serialSettings ? JSON.parse(product.product?.serialSettings) : null,
                productSubTax: product.salesOrderProductSubTax || [],
                productCategory: product?.product?.productCategories || [],
                warehouseId: product?.product?.warehouseProduct[0]?.warehouseId,
                binDetails: product?.productWarehouseDetailDTO?.[0]?.binDetail,
                selectedBin: product?.productWarehouseDetailDTO?.[0]?.binDetail?.find((bin) => bin.binId == product.binId),
                backOrderQty: productBackOrderQty,
                isDuplicatedProduct: product?.isCopied ?? false,
                additionalFeeType: this.additionalFees?.find((af) => af.id == product?.additionalFeesId),
                additionalFee: product?.additionalRate ?? 0,
                additionalFeeAmount: Number(product?.additionalAmount ?? 0) * this.savedCurrencyExchangeRate,
                costPrice: Number(product.costPrice ?? 0) * this.savedCurrencyExchangeRate,
                totalCostPrice: Number(product.totalCostPrice ?? 0) * this.savedCurrencyExchangeRate,
            };
        });

        this.purchaseListTB = this.allProductsData;
        this.selectedProductsList = this.purchaseListTB;
        this.purchaseListTB.forEach((product) => {
            if (product.typeId === this.typeIds.BundleTypeId) {
                const totalSubTotal = product.bundleDetails?.reduce((acc, bundle) => acc + bundle.subTotal, 0) || 0;
                product.subTotal = totalSubTotal;
            }
        });
        this.calculateOrderTotal();
        this.checkIsDisabledCheckBox();
    }
    filterPaymentTermsAndMethods() {
        const paymentTerms = [];
        const paymentMethods = [];
        if (this.soDetails?.account?.accountPaymentTerms) {
            this.soDetails?.account?.accountPaymentTerms?.forEach((e) => {
                paymentTerms.push(e.paymentTerm);
            });
        }
        if (this.soDetails?.account?.accountPaymentMethods) {
            this.soDetails?.account?.accountPaymentMethods?.forEach((e) => {
                paymentMethods.push(e.paymentMethod);
            });
        }

        const term = paymentTerms.filter((pt) => pt?.id == this.soDetails?.paymentTermId)[0];
        if (!term && this.soDetails.paymentTerm) {
            paymentTerms.push(this.soDetails.paymentTerm);
        }
        const method = paymentMethods.filter((pm) => pm?.id == this.soDetails?.paymentMethodId)[0];
        if (!method && this.soDetails.paymentMethod) {
            paymentMethods.push(this.soDetails.paymentMethod);
        }
        this.allPaymentTerms = paymentTerms;
        this.allPaymentMethods = paymentMethods;
    }
    setSalesOrderFormValueToView() {
        const wh = this.allLocations.filter((l) => l.id == this.soDetails?.warehouseId)[0];
        const discType = this.soDetails?.discountId ? this.discountOptions?.filter((v) => v.id == this.soDetails?.discountId)[0] : null;
        const user = this.allUser?.filter((u) => u.id == this.soDetails?.userId)[0];
        let trackingNo = "";
        if (this.soDetails.shipment && this.soDetails.shipment.length) {
            this.soDetails.shipment.forEach((e) => {
                if (e.trackingNo) {
                    trackingNo += e.trackingNo;
                    trackingNo += "\n";
                }
            });
        }
        const additionalDiscount = this.soDetails?.salesOrderAddDiscount && this.soDetails.salesOrderAddDiscount.length > 0 ? this.soDetails.salesOrderAddDiscount[0] : null;
        this.additionalDiscountRateTypes = [additionalDiscount && this.additionalDiscounts && this.additionalDiscounts?.length > 0 ? this.additionalDiscounts?.find((a) => a?.id == additionalDiscount.discountId) : null];
        this.soForm.patchValue({
            ...this.soDetails,
            account: this.accountInfo,
            accountChannel: this.accountChannels?.filter((ac) => ac.id == this.soDetails?.account?.typeId)[0],
            estimateDate: this.app._showDateTimeWithZone(this.soDetails?.salesOrderDate),
            salesOrderStage: this.allStages.filter((s) => s.id == this.soDetails.salesOrderStageId)[0],
            salesOrderStatus: this.allStatus.filter((s) => s.id == this.soDetails.salesOrderStatusId)[0],
            shippingChargeAmount: this.type == DialogType.COPY ? 0 : (Number(this.soDetails.shippingChargeAmount ?? 0) * this.savedCurrencyExchangeRate).toFixed(this.fractionDigits),
            discountType: discType,
            discountValue: this.soDetails?.discountRate ?? 0,
            vendorMessage: this.soDetails?.salesOrderAudit && this.soDetails?.salesOrderAudit.length > 0 ? this.soDetails.salesOrderAudit[this.soDetails.salesOrderAudit.length - 1].note.comment : "",
            memo: this.soDetails?.salesOrderNote && this.soDetails?.salesOrderNote.length > 0 ? this.soDetails.salesOrderNote[this.soDetails.salesOrderNote.length - 1].note.comment : "",
            salesRep: user,
            location: wh,
            statusId: this.soDetails.statusId == 1 ? true : false,
            trackingNo: trackingNo,
            additionalDiscountRate: additionalDiscount ? additionalDiscount.discountRate : 0,
            additionalDiscountType: additionalDiscount && this.additionalDiscounts && this.additionalDiscounts?.length > 0 ? this.additionalDiscounts?.find((a) => a?.id == additionalDiscount.discountId) : null,
            additionalDiscountTypeName: additionalDiscount && this.additionalDiscounts && this.additionalDiscounts?.length > 0 ? this.additionalDiscounts?.find((a) => a?.id == additionalDiscount.discountId) : null,
            shippingMethod: this.utilityService.findShippingMethodById(this.shippingMethods, this.soDetails.shippingMethodId),
            additionalFeeType: this.additionalFees?.find((af) => af.id == this.soDetails?.additionalFeesId),
            additionalFee: this.soDetails?.additionalRate ?? 0,
        });
        this.enableDiableAdditionalDiscountRateField();
        this.setContentInEditor(this.soDetails?.salesOrderNote && this.soDetails?.salesOrderNote.length > 0 ? this.soDetails.salesOrderNote[this.soDetails.salesOrderNote.length - 1].note.comment : "");
    }

    isClosingStatementDate(event: string) {
        this.statementMessege = event;
    }

    async setAddressAndContactData() {
        /** billing address */
        this.selectedAccountAddress = this.soDetails?.account?.accountAddresses?.filter((d) => d.addressId == this.soDetails?.billingAddressId)[0];
        this.accountAddressInfo = this.selectedAccountAddress;

        /** shipping address */
        this.selectedShippingAddress = this.soDetails?.account?.accountAddresses?.filter((d) => d.addressId == this.soDetails?.shippingAddressId)[0];
        this.shippingAddressInfo = this.selectedShippingAddress;
        await this.getTaxByAddress(this.shippingAddressInfo?.address?.countryId, this.shippingAddressInfo?.address?.stateId);

        /** contact */
        this.billingAddressContact = this.soDetails?.contact;
        this.shippingAddressContact = this.soDetails?.shipContact;
    }
    checkIsDisabledCheckBox() {
        let totalPackQty = 0;
        this.purchaseListTB.forEach((product) => {
            if (product.typeId == this.typeIds.BundleTypeId) {
                product?.bundleDetails?.forEach((e) => {
                    totalPackQty += e.packedQty;
                });
            } else {
                totalPackQty += product.packedQty;
            }
        });
        this.disabledCheckbox = totalPackQty <= 0;
    }
    setDiscountValue(obj) {
        // if (obj?.discountType?.description == "$") {
        //     this.soForm?.controls?.discountValue.setValue(obj.discountAmount);
        // } else if (obj?.discountType?.description == "%") {
        //     let num = obj.discountAmount ? (Number(obj.discountAmount) * 100) / Number(obj.totalAmount) : 0;
        //     num = num ? Math.round(num * 100) / 100 : 0;
        //     this.soForm?.controls?.discountValue.setValue(num);
        // }
    }
    setCustomFieldValueToView() {
        if (this.soDetails.customAttributeValues && this.soDetails.customAttributeValues.length) {
            Object.keys(this.combinedCustomFields).forEach((key) => {
                const dataArr = this.combinedCustomFields[key];
                for (let element of dataArr) {
                    const filteredCustom = this.soDetails.customAttributeValues.filter((c) => c.customAttributeId == element.id)[0];
                    if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "InputBox") {
                        element.value = filteredCustom.value;
                    } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "Decimal") {
                        element.value = filteredCustom.value;
                    } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "Number") {
                        element.value = filteredCustom.value;
                    } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "DatePicker") {
                        element.value = this.datepipe.transform(filteredCustom.value, "MM/dd/yyyy");
                    } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == "FileUpload" || filteredCustom.customAttribute?.formControl?.name == "Picture")) {
                        element.customUploadedFiles = [];
                        filteredCustom.customeAttachement.forEach((el) => {
                            element.customUploadedFiles.push(el);
                        });
                    } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "Rating") {
                        element.value = filteredCustom.ratingId;
                    } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "ToggleButton") {
                        element.value = filteredCustom.toggle;
                    } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "DropDownList") {
                        element.value = filteredCustom.values;
                    } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "RadioButton") {
                        element.value = filteredCustom.values.name;
                    } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "CheckBox") {
                        element.value = [];
                        filteredCustom.multipleValues.forEach((el) => {
                            element.value.push(el.name);
                        });
                    } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "MultipleDropDownList") {
                        element.value = [];
                        filteredCustom.multipleValues.forEach((el) => {
                            element.value.push(el);
                        });
                    }
                }
            });
        }
    }

    /** End View Sales Order */

    /** Estimates To Sales Order */
    /*** Initialize form and required data for Converting Estimate to Sales Order */
    getEstimateDetailsById() {
        this.initForm();
        this.allProductsData = [];
        this.purchaseListTB = [];
        this.allPaymentTerms = [];
        this.allPaymentMethods = [];
        this.appMainService.isShowSpinner("loadEstimate");
        this.salesOrderService
            .getEstimatesDetailsById(this.selectedEstimate.id)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(
                async (res) => {
                    this.prepareSalesOrderDataFromEstimatesToView(res);
                    this.appMainService.isHideSpinner("loadEstimate");
                },
                (err) => {
                    this.appMainService.isHideSpinner("loadEstimate");
                    this.messageService.add({
                        severity: "error",
                        summary: "Error",
                        detail: "Error occurred...",
                    });
                },
            );
    }
    async prepareSalesOrderDataFromEstimatesToView(res: any) {
        this.estDetails = res;
        this.savedCurrencyExchangeRate = Number(this.estDetails.exchangeRate);
        const salesChannel = this.orderChannels?.filter((s) => s.name == this.soChannel.SALES_ORDER)[0];
        this.allStages = salesChannel?.stages;
        const selectedStageId = this.allStages[0]?.id;
        this.allStatus = this.allStages.filter((s) => s.id == selectedStageId)[0].status;
        this.combinedCustomFields = this.utilityService.getCustomAttributesForCommon(this.templates, this.allCustomAttributes);
        /** account information */
        this.accountInfo = this.estDetails?.account;
        this.selectedAccountAddress = this.estDetails?.account?.accountAddresses?.filter((d) => d.addressId == this.estDetails.billingAddressId)[0]; // billing address
        this.accountAddressInfo = this.selectedAccountAddress;
        this.billingAddressContact = this.estDetails?.contact;
        if (this.accountInfo) {
            this.accountInfo["nameWithSequenceNumber"] = this.accountInfo?.["sequenceNumber"] + "-" + this.accountInfo?.["businessName"];
        }
        this.getcurrencyExchangeRate();
        this.getColsCount();
        this.checkTaxDiscountVisibility();
        this.setSOPaymentTermAndPaymentMethodFromEstimate();
        this.setSOFormValueFromEstimate();

        /**
         * Estimates doesn't have shipping address entry option.
         * so that, if account has default shipping addres that should populate
         * else, billing address should populate in shipping address
         */
        const allShipAddress = this.estDetails?.account?.accountAddresses?.filter((d) => d.address.addressTypeId == this.shippingAddressType?.id); // shipping address
        this.shippingAddressInfo = allShipAddress ? allShipAddress.filter((s) => s.address?.isDefault == true)[0] : null;
        this.selectedShippingAddress = this.shippingAddressInfo;
        if (!this.selectedShippingAddress) {
            this.shippingAddressInfo = this.accountAddressInfo;
            this.selectedShippingAddress = this.shippingAddressInfo;
        }
        this.shippingAddressContact = this.estDetails?.contact;
        await this.getTaxByAddress(this.shippingAddressInfo?.address?.countryId, this.shippingAddressInfo?.address?.stateId);
        this.discount = this.estDetails?.discountAmount;
        this.taxRate = this.estDetails?.tax && this.estDetails?.tax?.taxRate ? this.estDetails.tax.taxRate : 0;
        this.setDiscountValue(this.estDetails);
        this.prepareSOProductsListFromEstimate();
        Object.keys(this.combinedCustomFields).forEach((key) => {
            const dataArr = this.combinedCustomFields[key];
            dataArr?.forEach((element) => {
                const filteredCustom = this.estDetails.customAttributeValues.filter((c) => c.customAttributeId == element.id)[0];
                if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "InputBox") {
                    element.value = filteredCustom.value;
                } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "Decimal") {
                    element.value = filteredCustom.value;
                } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "Number") {
                    element.value = filteredCustom.value;
                } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "DatePicker") {
                    element.value = this.datepipe.transform(filteredCustom.value, "MM/dd/yyyy");
                } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == "FileUpload" || filteredCustom.customAttribute?.formControl?.name == "Picture")) {
                    element.customUploadedFiles = [];
                    filteredCustom.customeAttachement.forEach((el) => {
                        element.customUploadedFiles.push(el);
                    });
                } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "Rating") {
                    element.value = filteredCustom.ratingId;
                } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "ToggleButton") {
                    element.value = filteredCustom.toggle;
                } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "DropDownList") {
                    element.value = filteredCustom.values;
                } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "RadioButton") {
                    element.value = filteredCustom.values.name;
                } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "CheckBox") {
                    element.value = [];
                    filteredCustom.multipleValues.forEach((el) => {
                        element.value.push(el.name);
                    });
                } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "MultipleDropDownList") {
                    element.value = [];
                    filteredCustom.multipleValues.forEach((el) => {
                        element.value.push(el);
                    });
                }
            });
        });
    }
    setSOPaymentTermAndPaymentMethodFromEstimate() {
        this.allPaymentTerms = this.estDetails?.account?.accountPaymentTerms?.map((term) => term.paymentTerm) || [];
        const term = this.allPaymentTerms.filter((pt) => pt.id == this.estDetails?.paymentTermId)[0];
        if (!term) {
            this.allPaymentTerms.push(this.estDetails.paymentTerm);
        }

        this.allPaymentMethods = this.estDetails?.account?.accountPaymentMethods?.map((method) => method.paymentMethod) || [];
        const method = this.allPaymentMethods.filter((pm) => pm.id == this.estDetails?.paymentMethodId)[0];
        if (!method) {
            this.allPaymentMethods.push(this.estDetails.paymentMethod);
        }
    }
    setSOFormValueFromEstimate() {
        const discType = this.estDetails?.discountId ? this.discountOptions?.filter((v) => v.id == this.estDetails?.discountId)[0] : null;
        const user = this.allUser?.filter((u) => u.id == this.estDetails?.userId)[0];
        const additionalDiscount = this.estDetails?.estimateAddDiscount && this.estDetails?.estimateAddDiscount.length > 0 ? this.estDetails?.estimateAddDiscount[0] : null;
        this.additionalDiscountRateTypes = [additionalDiscount && this.additionalDiscounts && this.additionalDiscounts?.length > 0 ? this.additionalDiscounts?.find((a) => a?.id == additionalDiscount.discountId) : null];
        this.soForm.patchValue({
            ...this.estDetails,
            account: this.accountInfo,
            accountChannel: this.accountChannels?.filter((ac) => ac.id == this.estDetails?.account?.typeId)[0],
            reference: this.estDetails?.referenceNumber,
            estimateDate: this.app._showDateTimeWithZone(new Date()),
            expiryDate: new Date(this.estDetails?.expiryDate),
            salesOrderStage: this.allStages[0],
            salesOrderStatus: this.allStatus[0],
            discountType: discType,
            discountValue: this.estDetails?.discountRate ?? 0,
            vendorMessage: this.estDetails?.estimateAudits && this.estDetails?.estimateAudits.length > 0 ? this.estDetails.estimateAudits[this.estDetails.estimateAudits.length - 1].note.comment : "",
            memo: this.estDetails?.estimateNotes && this.estDetails?.estimateNotes.length > 0 ? this.estDetails.estimateNotes[this.estDetails.estimateNotes.length - 1].note.comment : "",
            salesRep: user,
            statusId: this.estDetails.statusId == 1 ? true : false,
            additionalDiscountRate: additionalDiscount ? additionalDiscount.discountRate : 0,
            additionalDiscountType: additionalDiscount && this.additionalDiscounts && this.additionalDiscounts?.length > 0 ? this.additionalDiscounts?.find((a) => a?.id == additionalDiscount.discountId) : null,
            additionalDiscountTypeName: additionalDiscount && this.additionalDiscounts && this.additionalDiscounts?.length > 0 ? this.additionalDiscounts?.find((a) => a?.id == additionalDiscount.discountId) : null,
            shippingMethod: this.utilityService.findShippingMethodById(this.shippingMethods, this.estDetails.shippingMethodId),
            additionalFeeType: this.additionalFees?.find((af) => af.id == this.estDetails?.additionalFeesId),
            additionalFee: this.estDetails?.additionalRate ?? 0,
            shippingChargeAmount: (Number(this.estDetails?.shippingChargeAmount ?? 0) * this.savedCurrencyExchangeRate).toFixed(this.fractionDigits),
        });
        this.enableDiableAdditionalDiscountRateField();
        this.soForm?.controls?.salesOrderStage.disable();
        this.setContentInEditor(this.estDetails?.estimateNotes && this.estDetails?.estimateNotes.length > 0 ? this.estDetails.estimateNotes[this.estDetails.estimateNotes.length - 1].note.comment : "");
    }
    prepareSOProductsListFromEstimate(): void {
        this.allProductsData = (this.estDetails?.estimateProducts || []).map((estProduct) => {
            /** Bundle Products */
            const bundleDetails: ISalesOrderBundleProductList[] = (estProduct?.estimateBundleDetail || []).map((bundle) => {
                /** kit under kit Products */
                const kitDetails: ISalesOrderBundleProductList[] = (bundle?.childEstimateBundleDetail || []).map((kp) => {
                    const kunit = kp.product.productUOM?.find((uom) => uom.unitOfMeasureId === kp.productUOMId);
                    const kitDiscountType = this.discountOptions?.find((option) => option.id === kp.discountId);
                    return {
                        id: kp.subProductId,
                        rowId: kp.id,
                        typeId: kp.product.typeId,
                        itemNo: kp.product.itemNo,
                        hsnsac: kp?.product?.hsnsac,
                        description: kp.description || "",
                        uom: kp.product.productUOM,
                        unit: kunit,
                        currentVal: kp.quantity,
                        availableQuantity: kp.availableQuantity ?? 0,
                        ordQty: kp.quantity,
                        originalQty: kp.originalQty,
                        bundleQty: kp.quantity,
                        cost: Number(kp?.product?.productPrice?.buyPrice ?? 0) * this.savedCurrencyExchangeRate,
                        price: Number(kp?.pricePerProduct ?? 0) * this.savedCurrencyExchangeRate,
                        originalprice: Number(kp.product?.accountProductPriceTiers?.find((tier) => tier.tierId === kp.product?.selectedtierId)?.calculatedPricePerQty),
                        accountPriceTier: kp.product?.accountProductPriceTiers,
                        isCustom: kp.product?.isCustom,
                        discountTypeName: kp.product?.tierTypeName || "",
                        selectedTierId: kp.product?.selectedtierId,
                        salesOrderBundleProductSerialDetail: kp.salesOrderBundleProductSerialDetail,
                        discountType: kitDiscountType,
                        taxType: kp.tax || "",
                        discount: kp.discountRate ?? 0,
                        discountAmount: Number(kp.discountAmount) * this.savedCurrencyExchangeRate,
                        taxAmount: Number(kp.taxRate) * this.savedCurrencyExchangeRate,
                        subTotal: Number(kp.totalAmount) * this.savedCurrencyExchangeRate,
                        baseSubTotal: Number(kp.subTotal) * this.savedCurrencyExchangeRate,
                        totalQuantity: kp.totalQty,
                        isTrackingRequired: kp.product?.isTrackingRequired || false,
                        serialSettings: kp.product?.serialSettings ? JSON.parse(kp.product?.serialSettings) : null,
                        bundleDetailSubTax: kp.estimateBundleDetailSubTax || [],
                        productCategory: kp?.product?.productCategories || [],
                        binDetails: kp?.productWarehouseDetailDTO?.[0]?.binDetail,
                        selectedBin: this.utilityService.setBin(kp.totalQty, kp?.productWarehouseDetailDTO?.[0]?.binDetail),
                        pickedQty: 0,
                        packedQty: 0,
                        shippedQty: 0,
                        totalQohInSelectedWareHouse: 0,
                        totalAvailInSelectedWareHouse: 0,
                        warehouseId: 0,
                        backOrderQty: 0,
                        isDuplicatedProduct: kp?.isCopied ?? false,
                        additionalFeeType: this.additionalFees?.find((af) => af.id == kp?.additionalFeesId),
                        additionalFee: kp?.additionalRate ?? 0,
                        additionalFeeAmount: Number(kp?.additionalAmount ?? 0) * this.savedCurrencyExchangeRate,
                        costPrice: Number(kp.costPrice ?? 0) * this.savedCurrencyExchangeRate,
                        totalCostPrice: Number(kp.totalCostPrice ?? 0) * this.savedCurrencyExchangeRate,
                    };
                });
                const unit = bundle?.product?.productUOM?.find((uom) => uom.unitOfMeasureId === bundle.productUOMId);
                const bundleDiscountType = this.discountOptions?.find((option) => option.id === bundle.discountId);
                return {
                    id: bundle.subProductId,
                    rowId: bundle.id,
                    typeId: bundle?.product?.typeId,
                    itemNo: bundle?.product?.itemNo,
                    hsnsac: bundle?.product?.hsnsac,
                    description: bundle.description || "",
                    uom: bundle?.product?.productUOM,
                    unit: unit,
                    currentVal: bundle.quantity,
                    availableQuantity: bundle.availableQuantity ?? 0,
                    ordQty: bundle.quantity,
                    originalQty: bundle.originalQty,
                    bundleQty: bundle.quantity,
                    cost: Number(bundle?.product?.productPrice?.buyPrice ?? 0) * this.savedCurrencyExchangeRate,
                    price: Number(bundle?.pricePerProduct ?? 0) * this.savedCurrencyExchangeRate,
                    originalprice: Number(bundle.product?.accountProductPriceTiers?.find((tier) => tier.tierId === bundle.product?.selectedtierId)?.calculatedPricePerQty),
                    accountPriceTier: bundle.product?.accountProductPriceTiers,
                    isCustom: bundle.product?.isCustom,
                    discountTypeName: bundle.product?.tierTypeName || "",
                    selectedTierId: bundle.product?.selectedtierId,
                    salesOrderBundleProductSerialDetail: bundle.salesOrderBundleProductSerialDetail,
                    discountType: bundleDiscountType,
                    taxType: bundle.tax || "",
                    discount: bundle.discountRate ?? 0,
                    discountAmount: Number(bundle.discountAmount) * this.savedCurrencyExchangeRate,
                    taxAmount: Number(bundle.taxRate) * this.savedCurrencyExchangeRate,
                    subTotal: Number(bundle.totalAmount) * this.savedCurrencyExchangeRate,
                    baseSubTotal: Number(bundle.subTotal) * this.savedCurrencyExchangeRate,
                    totalQuantity: bundle.totalQty,
                    isTrackingRequired: bundle.product?.isTrackingRequired || false,
                    serialSettings: bundle.product?.serialSettings ? JSON.parse(bundle.product?.serialSettings) : null,
                    bundleDetailSubTax: bundle.estimateBundleDetailSubTax || [],
                    productCategory: bundle?.product?.productCategories || [],
                    binDetails: bundle?.productWarehouseDetailDTO?.[0]?.binDetail,
                    selectedBin: this.utilityService.setBin(bundle.totalQty, bundle?.productWarehouseDetailDTO?.[0]?.binDetail),
                    pickedQty: 0,
                    packedQty: 0,
                    shippedQty: 0,
                    totalQohInSelectedWareHouse: 0,
                    totalAvailInSelectedWareHouse: 0,
                    warehouseId: 0,
                    backOrderQty: 0,
                    bundleDetails: kitDetails,
                    isDuplicatedProduct: bundle?.isCopied ?? false,
                    additionalFeeType: this.additionalFees?.find((af) => af.id == bundle?.additionalFeesId),
                    additionalFee: bundle?.additionalRate ?? 0,
                    additionalFeeAmount: Number(bundle?.additionalAmount ?? 0) * this.savedCurrencyExchangeRate,
                    costPrice: Number(bundle.costPrice ?? 0) * this.savedCurrencyExchangeRate,
                    totalCostPrice: Number(bundle.totalCostPrice ?? 0) * this.savedCurrencyExchangeRate,
                };
            });

            /** Product */
            const uom = estProduct.product.productUOM?.find((po) => po.unitOfMeasureId === estProduct.productUOMId);
            const productDiscountType = this.discountOptions?.find((option) => option.id === estProduct.discountId);
            const totalAvailableQty = estProduct.productWarehouseDetailDTO.reduce((total, warehouseDetail) => total + warehouseDetail.availQty, 0);
            return {
                id: estProduct.productId,
                itemNo: estProduct.product.itemNo,
                hsnsac: estProduct?.product?.hsnsac,
                description: estProduct.description || "",
                uom: estProduct.product.productUOM,
                unit: uom,
                availableQuantity: totalAvailableQty ?? 0,
                ordQty: estProduct.quantity,
                cost: Number(estProduct?.product?.productPrice?.buyPrice ?? 0) * this.savedCurrencyExchangeRate,
                price: Number(estProduct?.pricePerProduct ?? 0) * this.savedCurrencyExchangeRate,
                originalprice: Number(estProduct.product?.accountProductPriceTiers?.find((tier) => tier.tierId === estProduct.product?.selectedtierId)?.calculatedPricePerQty),
                accountPriceTier: estProduct.product?.accountProductPriceTiers,
                isCustom: estProduct.product?.isCustom,
                discountTypeName: estProduct.product?.tierTypeName || "",
                selectedTierId: estProduct.product?.selectedtierId,
                currentVal: estProduct.quantity,
                warehouseList: estProduct.productWarehouseDetailDTO,
                selectedWarehouseList: estProduct.productWarehouseDetailDTO?.length > 1 ? [] : estProduct.productWarehouseDetailDTO,
                selectedWarehouseCode: estProduct.productWarehouseDetailDTO?.length > 1 ? "" : estProduct.productWarehouseDetailDTO?.[0].warehouseName,
                totalQohInSelectedWareHouse: estProduct.productWarehouseDetailDTO?.length > 1 ? 0 : estProduct.productWarehouseDetailDTO?.[0].qtyOnHand,
                totalAvailInSelectedWareHouse: estProduct.productWarehouseDetailDTO?.length > 1 ? 0 : estProduct.productWarehouseDetailDTO?.[0].availQty,
                typeId: estProduct.product.typeId,
                bundleDetails: bundleDetails,
                discountType: productDiscountType,
                taxType: estProduct.tax || "",
                discount: estProduct.discountRate ?? 0,
                discountAmount: Number(estProduct.discountAmount) * this.savedCurrencyExchangeRate,
                taxAmount: Number(estProduct.taxRate) * this.savedCurrencyExchangeRate,
                subTotal: Number(estProduct.totalAmount) * this.savedCurrencyExchangeRate,
                baseSubTotal: Number(estProduct.subTotal) * this.savedCurrencyExchangeRate,
                totalQuantity: estProduct.totalQty,
                isTrackingRequired: estProduct.product?.isTrackingRequired || false,
                serialSettings: estProduct.product?.serialSettings ? JSON.parse(estProduct.product?.serialSettings) : null,
                productSubTax: estProduct.estimateProductSubTax || [],
                productCategory: estProduct?.product?.productCategories || [],
                binDetails: estProduct?.productWarehouseDetailDTO?.[0]?.binDetail,
                selectedBin: this.utilityService.setBin(estProduct.totalQty, estProduct?.productWarehouseDetailDTO?.[0]?.binDetail),
                rowId: estProduct.id,
                pickedQty: 0,
                packedQty: 0,
                shippedQty: 0,
                salesOrderSerialDetails: [],
                productBundleLink: [],
                warehouseId: 0,
                backOrderQty: 0,
                isDuplicatedProduct: estProduct?.isCopied ?? false,
                additionalFeeType: this.additionalFees?.find((af) => af.id == estProduct?.additionalFeesId),
                additionalFee: estProduct?.additionalRate ?? 0,
                additionalFeeAmount: Number(estProduct?.additionalAmount ?? 0) * this.savedCurrencyExchangeRate,
                costPrice: Number(estProduct.costPrice ?? 0) * this.savedCurrencyExchangeRate,
                totalCostPrice: Number(estProduct.totalCostPrice ?? 0) * this.savedCurrencyExchangeRate,
            };
        });

        this.purchaseListTB = this.allProductsData;
        this.selectedProductsList = this.purchaseListTB;
        this.purchaseListTB.forEach((product) => {
            if (product.typeId === this.typeIds.BundleTypeId) {
                const totalSubTotal = product.bundleDetails?.reduce((acc, bundle) => acc + bundle.subTotal, 0) || 0;
                product.subTotal = totalSubTotal;
            }
        });
        this.calculateOrderTotal();
    }

    /*** Convert to SalesOrder */
    convertToSalesOrder() {
        const isValid = this.utilityService.checkvalidation(this.combinedCustomFields);
        const customattributeList = this.utilityService.getCustomAttributesForAddEdit(this.combinedCustomFields);
        if (isValid) {
            const salesOrders: ISalesOrder[] = [];
            const warehouseSet = new Set();
            let hasWh = true;
            this.purchaseListTB.forEach((product) => {
                if (product.selectedWarehouseList.length > 0) {
                    product.selectedWarehouseList.forEach((e) => {
                        warehouseSet.add(e.warehouseId);
                    });
                } else {
                    hasWh = false;
                }
            });

            /**
             * User must have to select at least an warehouse for each product
             * if not then user will get an error msg
             */
            if (warehouseSet && warehouseSet.size > 0 && hasWh) {
                this.isDisabledSaveBtn = true;
                this.appMainService.isShowSpinner("loadSO");
                const uniqueArr = [...warehouseSet];
                const uniqueMap: Map<any, any> = this.prepareProductsListForConvert(uniqueArr);
                for (const [key, value] of uniqueMap.entries()) {
                    if (value && value?.length > 0) {
                        // let sumTotal = 0;
                        const sumTotal = value?.reduce((total, v) => total + v.subTotal, 0) || 0;
                        let orderTotal: number = sumTotal + Number(this.productsTotalAdditionalFee ?? 0);
                        if (this.footerDiscountEnabled) {
                            orderTotal -= this.discount;
                        }
                        if (this.footerTaxEnabled) {
                            orderTotal += this.tax;
                        }
                        orderTotal += this.totalAdditionalFee;

                        /** Additional discount */
                        let addDiscount: number = 0;
                        if (this.soForm?.controls?.additionalDiscountTypeName?.value && this.soForm?.controls?.additionalDiscountType?.value) {
                            if (this.soForm?.controls?.additionalDiscountType.value.type.description == "%" || this.soForm?.controls?.additionalDiscountType.value.type.description == "Percentage") {
                                addDiscount = this.soForm?.controls?.additionalDiscountRate.value > 0 ? orderTotal * (Number(this.soForm?.controls?.additionalDiscountRate.value) / 100) : addDiscount;
                            } else {
                                addDiscount = Number(this.soForm?.controls?.additionalDiscountRate.value);
                            }
                        }
                        orderTotal = Number(orderTotal) - Number(addDiscount);
                        orderTotal = orderTotal + Number(this.soForm?.controls["shippingChargeAmount"].value);

                        const salesOrderAudit = this.prepareSalesOrderAudit();
                        const salesOrderNote = this.prepareSalesOrderNote();
                        const salesOrder: ISalesOrder = {
                            id: 0,
                            createdSource: this.app.userIP,
                            updatedSource: this.app.userIP,
                            createdBy: this.app.user.userId,
                            updatedBy: this.app.companyId,
                            createdDate: this.app._saveDateTimeWithZone(new Date()),
                            updatedDate: this.app._saveDateTimeWithZone(new Date()),
                            number: "",
                            name: "",
                            description: "",
                            contactId: this.billingAddressContact ? this.billingAddressContact?.id : 0,
                            shipContactId: this.shippingAddressContact ? this.shippingAddressContact?.id : 0,
                            salesOrderDate: this.app._saveDateTimeWithZone(this.soForm?.controls["estimateDate"].value),
                            organizationId: this.app.companyId,
                            accountId: this.soForm?.controls["account"].value?.id,
                            warehouseId: key,
                            userId: this.soForm?.controls["salesRep"].value && this.soForm?.controls["salesRep"].value?.id ? this.soForm?.controls["salesRep"].value?.id : 0,
                            shippingAddressId: this.selectedShippingAddress && this.selectedShippingAddress?.addressId ? this.selectedShippingAddress?.addressId : 0,
                            billingAddressId: this.selectedAccountAddress && this.selectedAccountAddress?.addressId ? this.selectedAccountAddress?.addressId : 0,
                            totalAmount: sumTotal,
                            discountTypeId: this.footerDiscountEnabled && this.templates?.labels_footer[1]?.isChecked && this.soForm?.controls["discountType"].value ? (this.soForm?.controls["discountType"]?.value?.discountBy ?? 0) : 0,
                            discountType: "",
                            discountAmount: this.footerDiscountEnabled && this.templates?.labels_footer[1]?.isChecked ? this.discount : 0,
                            discountFinancialId: this.footerDiscountEnabled && this.templates?.labels_footer[1]?.isChecked ? this.discountOptions?.filter((discount) => discount?.id == this.soForm?.controls["discountType"]?.value?.id).map((value) => value.incomeAccount)[0] : 0,
                            discountId: this.footerDiscountEnabled && this.templates?.labels_footer[1]?.isChecked ? this.discountOptions?.filter((discount) => discount?.id == this.soForm?.controls["discountType"]?.value?.id).map((value) => value?.id)[0] : 0,
                            discountRate: this.footerDiscountEnabled && this.templates?.labels_footer[1]?.isChecked ? (this.soForm?.controls["discountValue"]?.value ?? 0) : 0,
                            discountName: "",
                            taxId: 0,
                            taxAmount: this.footerTaxEnabled && this.templates?.labels_footer[2]?.isChecked ? this.tax : 0,
                            taxRate: this.footerTaxEnabled && this.templates?.labels_footer[2]?.isChecked ? this.tax : 0,
                            taxName: "",
                            taxRateTypeId: 0,
                            taxFinancialId: 0,
                            shippingChargeAmount: this.soForm?.controls["shippingChargeAmount"].value ? this.soForm?.controls["shippingChargeAmount"].value : 0,
                            netAmount: orderTotal,
                            balanceDue: orderTotal,
                            salesOrderStageId: this.soForm?.controls["salesOrderStage"].value?.id,
                            salesOrderStage: "",
                            paymentMethodId: this.soForm?.controls["paymentMethod"].value ? this.soForm?.controls["paymentMethod"].value?.id : 0,
                            paymentTermId: this.soForm?.controls["paymentTerm"].value ? this.soForm?.controls["paymentTerm"].value?.id : 0,
                            sourceId: 0,
                            defaultPriceListId: 0,
                            termsAndCondition: "",
                            reference: this.soForm?.controls["reference"].value,
                            saleCommission: 0,
                            holdOrderProcessedDate: this.app._saveDateTimeWithZone(new Date()),
                            isBackOrder: false,
                            backOrderInvoiceId: 0,
                            shippingMethodId: this.soForm?.controls?.shippingMethod?.value?.id ?? 0,
                            shippingFinancialId: this.soForm?.controls?.shippingMethod?.value?.financialAccountId ?? 0,
                            shippingTermId: this.soForm?.controls["shippingTerm"].value ? this.soForm?.controls["shippingTerm"].value?.id : 0,
                            salesOrderStatusId: this.soForm?.controls["salesOrderStatus"].value?.id,
                            salesOrderStatus: "",
                            typeId: 0,
                            groupId: 0,
                            statusId: this.soForm?.controls["statusId"].value ? 1 : 2,
                            isValid: true,
                            validFromDate: this.app._saveDateTimeWithZone(new Date()),
                            validToDate: this.app._saveDateTimeWithZone(new Date()),
                            salesOrderNote: salesOrderNote,
                            salesOrderAudit: salesOrderAudit,
                            salesOrderProducts: value,
                            customAttributeValues: this.setCustomAttributes(customattributeList),
                            configJson: "",
                            createdByUser: "",
                            estimateId: this.estDetails?.id,
                            estimateNo: this.estDetails.number,
                            estimateObjectId: this.estimateObjectId,
                            salesObjectId: this.salesObjectId,
                            businessName: this.accountInfo?.businessName,
                            isFreeShipping: false,
                            freeShippingDiscountName: "",
                            freeShippingDiscountAccountId: 0,
                            freeShippingDiscountId: 0,
                            channelId: this.soForm?.controls?.accountChannel.value?.id ?? 0,
                            salesOrderPaymentStatusId: 1,
                            additionalDiscount: Number(addDiscount),
                            salesOrderAddDiscount: this.prepareAdditionalDiscountsForNewSalesOrder(addDiscount),
                            additionalFeesId: this.templates?.labels_footer[10]?.isChecked ? (this.soForm?.controls["additionalFeeType"]?.value?.id ?? 0) : 0,
                            additionalRate: this.templates?.labels_footer[10]?.isChecked ? (this.soForm?.controls["additionalFee"]?.value ?? 0) : 0,
                            additionalAmount: this.templates?.labels_footer[10]?.isChecked ? this.totalAdditionalFee : 0,
                            additionalFeesFinancialId: this.templates?.labels_footer[10]?.isChecked ? (this.soForm?.controls["additionalFeeType"]?.value?.incomeAccount ?? 0) : 0,
                            approvalStatusId: ApprovalStatus.Default,
                            currencyUnitId: this.accountInfo?.currencyId ?? 0,
                            exchangeRate: this.currencyExchangeRate ?? this.baseCurrency?.exchangeRate,
                            isProductLevelDiscount: this.templates?.labels_table[6]?.isChecked ?? false,
                        };
                        salesOrders.push(salesOrder);
                    }
                }
                this.salesOrderService
                    .convertToSalesOrder(salesOrders, this.isBaseCurrency())
                    .then(() => {
                        this.messageService.add({
                            severity: "success",
                            summary: "Success",
                            detail: "Converted to Sales Order successfully...",
                        });
                        this.appMainService.isHideSpinner("loadSO");
                        this.displayConvertToSalesOrder = false;
                        this.onSaveComplete.emit(false);
                    })
                    .catch(() => {
                        this.isDisabledSaveBtn = false;
                        this.appMainService.isHideSpinner("loadSO");
                        this.messageService.add({
                            severity: "error",
                            summary: "Error",
                            detail: "Error occurred while converting data...",
                        });
                    });
            } else {
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Please select warehouse to continue...",
                });
            }
        } else {
            this.messageService.add({
                severity: "error",
                summary: "Error",
                detail: "Please fill up all required field...",
            });
        }
    }
    prepareProductsListForConvert(uniqueWarehouseArr: any[]) {
        const uniqueMap = new Map(uniqueWarehouseArr.map((u) => [u, []]));
        this.purchaseListTB.forEach((product) => {
            /**
             * User can select multiple warehouse for a product
             * from that list need to sort by availableqty
             */
            const sortedWh = product.selectedWarehouseList.sort((a, b) => b.availQty - a.availQty);
            let q = Number(product.ordQty);
            const uomValue = product?.unit?.uomDetail?.value || 1;
            sortedWh.forEach((wh) => {
                if (q > 0) {
                    /** bundle items */
                    const bundleItems: ISalesOrderBundleProduct[] = [];
                    let total = 0;
                    let totalOfBaseSubTotal = 0;
                    const wq = q ? q : 1;
                    product?.bundleDetails?.forEach((e) => {
                        const soBundleProduct: ISalesOrderBundleProduct = {
                            id: 0,
                            createdSource: this.app.userIP,
                            updatedSource: this.app.userIP,
                            createdBy: this.app.user.userId,
                            updatedBy: this.app.user.userId,
                            createdDate: this.app._saveDateTimeWithZone(new Date()),
                            updatedDate: this.app._saveDateTimeWithZone(new Date()),
                            salesOrderId: 0,
                            productId: product.id,
                            subproductId: e.id,
                            parentBundleId: 0,
                            parentProductId: 0,
                            productUOMId: e?.unit?.unitOfMeasureId || 0,
                            availableQuantity: e.availabel ?? 0,
                            quantity: e.ordQty,
                            pricePerProduct: e["price"],
                            totalAmount: e.subTotal,
                            subTotal: e.baseSubTotal,
                            discountTypeId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked && e.discountType ? (e.discountType.discountBy ?? 0) : (this.soForm?.controls["discountType"]?.value?.discountBy ?? 0),
                            discountType: "",
                            discountAmount: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? e.discountAmount : this.utilityService.calculateDiscountPerProduct(e.subTotal, this.sumTotal, this.discount),
                            discountFinancialId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? this.discountOptions?.filter((discount) => discount.id == e.discountType?.id).map((value) => value.incomeAccount)[0] : this.discountOptions?.filter((discount) => discount.id == this.soForm?.controls["discountType"]?.value?.id).map((value) => value.incomeAccount)[0],
                            discountId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? this.discountOptions?.filter((discount) => discount.id == e.discountType?.id).map((value) => value?.id)[0] : this.discountOptions?.filter((discount) => discount.id == this.soForm?.controls["discountType"]?.value?.id).map((value) => value?.id)[0],
                            discountRate: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? (e.discount ?? 0) : 0,
                            discountName: "",
                            taxId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && e.taxType ? e.taxType.id : 0,
                            taxAmount: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked ? e.taxAmount : 0,
                            taxRate: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked ? e.taxAmount : 0,
                            taxName: "",
                            taxRateTypeId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && e.taxType ? e.taxType.typeId : 0,
                            taxFinancialId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && e.taxType ? e.taxType.financialAccountId : 0,
                            statusId: Status.Active,
                            salesorderSerialNumber: null,
                            salesorderproductId: 0,
                            salesOrderBundleProductSerialDetail: e.salesOrderBundleProductSerialDetail && e.salesOrderBundleProductSerialDetail.length > 0 ? e.salesOrderBundleProductSerialDetail : null,
                            binId: this.templates?.labels_table[11].isChecked ? (this.type == DialogType.CONVERT_FROM_RMA ? (e.selectedBin ? e.selectedBin?.id : 0) : e.selectedBin ? e.selectedBin?.binId : 0) : 0,
                            pickedQty: e.pickedQty,
                            packedQty: e.packedQty,
                            shippedQty: e.shippedQty,
                            totalQty: e.totalQuantity,
                            salesOrderBundleDetailSubTax: this.footerTaxEnabled ? product.typeId == TypeIds.KitTypeId ? this.prepareProductsSubtaxCode(product.productSubTax, product.ordQty, product.price, product) : this.prepareProductsSubtaxCode(e.bundleDetailSubTax, e.ordQty, e.price, product, e) : [],
                            description: e?.description ?? "",
                            isPicked: false,
                            isPacked: false,
                            backOrderQty: 0,
                            isCopied: e.isDuplicatedProduct ?? false,
                            additionalFeesId: this.templates?.labels_table[15]?.isChecked ? (e?.additionalFeeType?.id ?? 0) : 0,
                            additionalRate: this.templates?.labels_table[15]?.isChecked ? (e?.additionalFee ?? 0) : 0,
                            additionalAmount: this.templates?.labels_table[15]?.isChecked ? (e?.additionalFeeAmount ?? 0) : 0,
                            additionalFeesFinancialId: this.templates?.labels_table[15]?.isChecked ? (e?.additionalFeeType?.incomeAccount ?? 0) : 0,
                            costPrice: e.costPrice ?? 0,
                            totalCostPrice: e.totalCostPrice ?? 0,
                        };
                        total += Number(e.subTotal);
                        totalOfBaseSubTotal += Number(e.baseSubTotal);
                        bundleItems.push(soBundleProduct);
                        /** kit under kit items **/
                        for (let kp of e.bundleDetails) {
                            const soKitProduct: ISalesOrderBundleProduct = {
                                id: 0,
                                createdSource: this.app.userIP,
                                updatedSource: this.app.userIP,
                                createdBy: this.app.user.userId,
                                updatedBy: this.app.user.userId,
                                createdDate: this.app._saveDateTimeWithZone(new Date()),
                                updatedDate: this.app._saveDateTimeWithZone(new Date()),
                                salesOrderId: 0,
                                productId: product.id,
                                subproductId: kp.id,
                                parentBundleId: 0,
                                parentProductId: e.id,
                                productUOMId: kp?.unit?.unitOfMeasureId || 0,
                                availableQuantity: kp.availabel ?? 0,
                                quantity: kp.ordQty,
                                pricePerProduct: kp["price"],
                                totalAmount: kp.subTotal,
                                subTotal: kp.baseSubTotal,
                                discountTypeId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked && kp.discountType ? (kp.discountType?.discountBy ?? 0) : (this.soForm?.controls["discountType"]?.value?.discountBy ?? 0),
                                discountType: "",
                                discountAmount: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? kp.discountAmount : this.utilityService.calculateDiscountPerProduct(kp.subTotal, this.sumTotal, this.discount),
                                discountFinancialId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? this.discountOptions?.filter((discount) => discount.id == kp.discountType?.id).map((value) => value.incomeAccount)[0] : this.discountOptions?.filter((discount) => discount.id == this.soForm?.controls["discountType"]?.value?.id).map((value) => value.incomeAccount)[0],
                                discountId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? this.discountOptions?.filter((discount) => discount.id == kp.discountType?.id).map((value) => value?.id)[0] : this.discountOptions?.filter((discount) => discount.id == this.soForm?.controls["discountType"]?.value?.id).map((value) => value?.id)[0],
                                discountRate: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? (kp.discount ?? 0) : 0,
                                discountName: "",
                                taxId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && kp.taxType ? kp.taxType.id : 0,
                                taxAmount: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked ? kp.taxAmount : 0,
                                taxRate: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked ? kp.taxAmount : 0,
                                taxName: "",
                                taxRateTypeId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && kp.taxType ? kp.taxType.typeId : 0,
                                taxFinancialId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && kp.taxType ? kp.taxType.financialAccountId : 0,
                                statusId: Status.Active,
                                salesorderSerialNumber: null,
                                salesorderproductId: 0,
                                salesOrderBundleProductSerialDetail: kp.salesOrderBundleProductSerialDetail && kp.salesOrderBundleProductSerialDetail.length > 0 ? kp.salesOrderBundleProductSerialDetail : null,
                                binId: this.templates?.labels_table[11].isChecked ? (this.type == DialogType.CONVERT_FROM_RMA ? (kp.selectedBin ? kp.selectedBin?.id : 0) : kp.selectedBin ? kp.selectedBin?.binId : 0) : 0,
                                pickedQty: kp.pickedQty,
                                packedQty: kp.packedQty,
                                shippedQty: kp.shippedQty,
                                totalQty: kp.totalQuantity,
                                salesOrderBundleDetailSubTax: this.footerTaxEnabled ? product.typeId == TypeIds.KitTypeId ? this.prepareProductsSubtaxCode(product.productSubTax, product.ordQty, product.price, product) : this.prepareProductsSubtaxCode(kp.bundleDetailSubTax, kp.ordQty, kp.price, e, kp) : [],
                                description: kp?.description ?? "",
                                isPicked: false,
                                isPacked: false,
                                backOrderQty: 0,
                                isCopied: kp.isDuplicatedProduct ?? false,
                                additionalFeesId: this.templates?.labels_table[15]?.isChecked ? (kp?.additionalFeeType?.id ?? 0) : 0,
                                additionalRate: this.templates?.labels_table[15]?.isChecked ? (kp?.additionalFee ?? 0) : 0,
                                additionalAmount: this.templates?.labels_table[15]?.isChecked ? (kp?.additionalFeeAmount ?? 0) : 0,
                                additionalFeesFinancialId: this.templates?.labels_table[15]?.isChecked ? (kp?.additionalFeeType?.incomeAccount ?? 0) : 0,
                                costPrice: kp.costPrice ?? 0,
                                totalCostPrice: kp.totalCostPrice ?? 0,
                            };
                            bundleItems.push(soKitProduct);
                        }
                    });

                    /** product */
                    let subTotal = Number(wq) * Number(uomValue) * Number(product.price);
                    const baseSubTotal = subTotal;
                    let applicableDiscount = product.discountAmount;
                    let applicableTax = product.taxAmount;
                    let additionalFeeAmount = product.additionalFeeAmount;

                    /** Tax and Discount */
                    let appliedDiscount = this.discountOptions?.find((discount) => discount.id == product?.discountType?.id);
                    if (appliedDiscount && appliedDiscount.isTaxable) {
                        if (this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked) {
                            subTotal -= applicableDiscount;
                        }
                        if (this.soForm?.controls["additionalFeeType"]?.value?.isTaxable && this.templates?.labels_table[15]?.isChecked) {
                            subTotal += additionalFeeAmount;
                        }
                        if (this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked) {
                            subTotal += applicableTax;
                        }
                        if (!this.soForm?.controls["additionalFeeType"]?.value?.isTaxable && this.templates?.labels_table[15]?.isChecked) {
                            subTotal += additionalFeeAmount;
                        }
                    } else {
                        if (this.soForm?.controls["additionalFeeType"]?.value?.isTaxable && this.templates?.labels_table[15]?.isChecked) {
                            subTotal += additionalFeeAmount;
                        }
                        if (this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked) {
                            subTotal += applicableTax;
                        }
                        if (this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked) {
                            subTotal -= applicableDiscount;
                        }
                        if (!this.soForm?.controls["additionalFeeType"]?.value?.isTaxable && this.templates?.labels_table[15]?.isChecked) {
                            subTotal += additionalFeeAmount;
                        }
                    }

                    let pTotal = subTotal;
                    let productTotalAmount = product.typeId == TypeIds.BundleTypeId ? total : subTotal;
                    let productTotalAmountOfBaseSubTotal = product.typeId == TypeIds.BundleTypeId ? totalOfBaseSubTotal : baseSubTotal;
                    const soProduct: ISalesOrderProduct = {
                        id: 0,
                        createdSource: this.app.userIP,
                        updatedSource: this.app.userIP,
                        createdBy: this.app.user.userId,
                        updatedBy: this.app.user.userId,
                        createdDate: this.app._saveDateTimeWithZone(new Date()),
                        updatedDate: this.app._saveDateTimeWithZone(new Date()),
                        salesOrderId: 0,
                        productId: product.id,
                        productUOMId: product?.unit?.unitOfMeasureId || 0,
                        availableQuantity: wh.availQty ?? 0,
                        quantity: wq,
                        pricePerProduct: product.price,
                        totalAmount: product.typeId == TypeIds.BundleTypeId ? total : pTotal,
                        subTotal: productTotalAmountOfBaseSubTotal,
                        statusId: Status.Active,
                        pickedQty: product.pickedQty,
                        packedQty: product.packedQty,
                        shippedQty: product.shippedQty,
                        salesOrderBundleDetail: bundleItems && bundleItems?.length ? bundleItems : [],
                        discountTypeId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked && product.discountType ? (product.discountType?.discountBy ?? 0) : (this.soForm?.controls["discountType"]?.value?.discountBy ?? 0),
                        discountType: "",
                        discountAmount: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? applicableDiscount : this.utilityService.calculateDiscountPerProduct(productTotalAmount, this.sumTotal, this.discount),
                        discountFinancialId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked && product.discountType?.id ? this.discountOptions?.filter((discount) => discount.id == product.discountType?.id).map((value) => value.incomeAccount)[0] : this.discountOptions?.filter((discount) => discount.id == this.soForm?.controls["discountType"]?.value?.id).map((value) => value.incomeAccount)[0],
                        discountId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked && product.discountType?.id ? this.discountOptions?.filter((discount) => discount.id == product.discountType?.id).map((value) => value?.id)[0] : this.discountOptions?.filter((discount) => discount.id == this.soForm?.controls["discountType"]?.value?.id).map((value) => value?.id)[0],
                        discountRate: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? (product.discount ?? 0) : 0,
                        discountName: "",
                        taxId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && product.taxType ? product.taxType.id : 0,
                        taxAmount: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked ? applicableTax : 0,
                        taxRate: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked ? applicableTax : 0,
                        taxName: "",
                        taxRateTypeId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && product.taxType ? product.taxType.typeId : 0,
                        taxFinancialId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && product.taxType ? product.taxType.financialAccountId : 0,
                        totalQty: wq,
                        binId: this.templates?.labels_table[11].isChecked ? (this.type == DialogType.CONVERT_FROM_RMA ? (product.selectedBin ? product.selectedBin?.id : 0) : product.selectedBin ? product.selectedBin?.binId : 0) : 0,
                        salesOrderProductSubTax: this.footerTaxEnabled ? product.typeId != TypeIds.BundleTypeId ? this.prepareProductsSubtaxCode(product.productSubTax, wq, product.price, product) : [] : [],
                        description: product.description,
                        salesOrderSerialDetail: [],
                        isPicked: false,
                        isPacked: false,
                        backOrderQty: 0,
                        isCopied: product.isDuplicatedProduct ?? false,
                        additionalFeesId: this.templates?.labels_table[15]?.isChecked ? (product?.additionalFeeType?.id ?? 0) : 0,
                        additionalRate: this.templates?.labels_table[15]?.isChecked ? (product?.additionalFee ?? 0) : 0,
                        additionalAmount: this.templates?.labels_table[15]?.isChecked ? (product?.additionalFeeAmount ?? 0) : 0,
                        additionalFeesFinancialId: this.templates?.labels_table[15]?.isChecked ? (product?.additionalFeeType?.incomeAccount ?? 0) : 0,
                        costPrice: product.costPrice ?? 0,
                        totalCostPrice: product.totalCostPrice ?? 0,
                    };
                    const a = uniqueMap.get(wh.warehouseId);
                    a.push(soProduct);
                    uniqueMap.set(wh.warehouseId, a);
                    // subtract ordQty so that next time can pick a warehouse for remaining qty
                    if (wq <= q) {
                        q = q - wq;
                    }
                }
            });
        });
        return uniqueMap;
    }

    /** End Estimates To Sales Order */

    /** RMA To Sales Order */
    initConvertToSalesOrderFromRMA() {
        this.initForm();
        this.allProductsData = [];
        this.purchaseListTB = [];
        this.allPaymentTerms = [];
        this.allPaymentMethods = [];
        this.appMainService.isShowSpinner("loadReturn");
        this.salesOrderService
            .getCustomerReturnDetailsToConvert(this.selectedReturn.id)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(
                async (res) => {
                    this.returnDetails = res;
                    this.savedCurrencyExchangeRate = Number(this.returnDetails.exchangeRate);
                    this.appMainService.isHideSpinner("loadReturn");
                    const salesChannel = this.orderChannels?.filter((s) => s.name == this.soChannel.SALES_ORDER)[0];
                    this.allStages = salesChannel?.stages;
                    const selectedStageId = this.allStages[0]?.id;
                    this.allStatus = this.allStages.filter((s) => s.id == selectedStageId)[0].status;
                    this.combinedCustomFields = this.utilityService.getCustomAttributesForCommon(this.templates, this.allCustomAttributes);
                    this.getColsCount();

                    // account information
                    this.accountInfo = this.returnDetails?.account;
                    this.selectedAccountAddress = this.returnDetails?.account?.accountAddresses?.filter((d) => d.addressId == this.returnDetails.shippingAddressId)[0]; // billing address
                    this.accountAddressInfo = this.selectedAccountAddress;
                    this.billingAddressContact = this.returnDetails?.contact;
                    if (this.accountInfo) {
                        this.accountInfo["nameWithSequenceNumber"] = this.accountInfo?.["sequenceNumber"] + "-" + this.accountInfo?.["businessName"];
                    }
                    this.setPaymentTermAndPaymentMethodToConvertFromRma();
                    this.setSalesOrderFormValueToConvertFromRMA();
                    this.getcurrencyExchangeRate();

                    /**
                     * Return doesn't have billing address entry option.
                     * so that, if account has default billing addres that should populate
                     * else, shipping address should populate in billing address
                     */
                    const allShipAddress = this.returnDetails?.account?.accountAddresses?.filter((d) => d.address.addressTypeId == this.shippingAddressType?.id); // shipping address
                    this.shippingAddressInfo = allShipAddress ? allShipAddress.filter((s) => s.address?.isDefault == true)[0] : null;
                    this.selectedShippingAddress = this.shippingAddressInfo;
                    if (!this.selectedShippingAddress) {
                        this.shippingAddressInfo = this.accountAddressInfo;
                        this.selectedShippingAddress = this.shippingAddressInfo;
                    }
                    this.shippingAddressContact = this.returnDetails?.contact;
                    await this.getTaxByAddress(this.shippingAddressInfo?.address?.countryId, this.shippingAddressInfo?.address?.stateId);

                    this.discount = this.returnDetails?.discountAmount;
                    this.taxRate = this.returnDetails?.tax && this.returnDetails?.tax?.taxRate ? this.returnDetails.tax.taxRate : 0;
                    this.setDiscountValue(this.returnDetails);
                    this.setProductsListToConvertFromRMA();

                    Object.keys(this.combinedCustomFields).forEach((key) => {
                        const dataArr = this.combinedCustomFields[key];
                        dataArr?.forEach((element) => {
                            const filteredCustom = this.returnDetails.customAttributeValues.filter((c) => c.customAttributeId == element.id)[0];
                            if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "InputBox") {
                                element.value = filteredCustom.value;
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "Decimal") {
                                element.value = filteredCustom.value;
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "Number") {
                                element.value = filteredCustom.value;
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "DatePicker") {
                                element.value = this.datepipe.transform(filteredCustom.value, "MM/dd/yyyy");
                            } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == "FileUpload" || filteredCustom.customAttribute?.formControl?.name == "Picture")) {
                                element.customUploadedFiles = [];
                                filteredCustom.customeAttachement.forEach((el) => {
                                    element.customUploadedFiles.push(el);
                                });
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "Rating") {
                                element.value = filteredCustom.ratingId;
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "ToggleButton") {
                                element.value = filteredCustom.toggle;
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "DropDownList") {
                                element.value = filteredCustom.values;
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "RadioButton") {
                                element.value = filteredCustom.values.name;
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "CheckBox") {
                                element.value = [];
                                filteredCustom.multipleValues.forEach((el) => {
                                    element.value.push(el.name);
                                });
                            } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "MultipleDropDownList") {
                                element.value = [];
                                filteredCustom.multipleValues.forEach((el) => {
                                    element.value.push(el);
                                });
                            }
                        });
                    });
                },
                (err) => {
                    this.appMainService.isHideSpinner("loadReturn");
                    this.messageService.add({
                        severity: "error",
                        summary: "Error",
                        detail: "Error occurred...",
                    });
                },
            );
    }

    setPaymentTermAndPaymentMethodToConvertFromRma() {
        this.allPaymentTerms = this.returnDetails?.account?.accountPaymentTerms?.map((term) => term.paymentTerm) || [];
        const term = this.allPaymentTerms.filter((pt) => pt.id == this.returnDetails.paymentTermId)[0];
        if (!term && this.returnDetails.paymentTermId) {
            this.allPaymentTerms.push(this.returnDetails.paymentTerm);
        }
        const defaultTerm = this.returnDetails?.account?.accountPaymentTerms?.find((t) => t.isDefault == true && t.statusId == Status.Active)?.paymentTerm;
        if (defaultTerm) {
            this.soForm?.controls["paymentTerm"].setValue(defaultTerm);
        }

        this.allPaymentMethods = this.returnDetails?.account?.accountPaymentMethods?.map((method) => method.paymentMethod) || [];
        const method = this.allPaymentMethods.filter((pm) => pm.id == this.returnDetails.paymentMethodId)[0];
        if (!method && this.returnDetails.paymentMethodId) {
            this.allPaymentMethods.push(this.returnDetails.paymentMethod);
        }
        const defaultMethod = this.returnDetails?.account?.accountPaymentMethods?.find((m) => m.isDefault == true && m.statusId == Status.Active)?.paymentMethod; 
        if (defaultMethod) {
            this.soForm?.controls["paymentMethod"].setValue(defaultMethod);
        } 
    }

    setSalesOrderFormValueToConvertFromRMA() {
        // const discType = this.returnDetails?.discountTypeId ? this.discountOptions?.filter((v) => v.id == this.returnDetails?.discountTypeId)[0] : this.discountOptions[0];
        const user = this.allUser?.filter((u) => u.id == this.returnDetails?.userId)[0];
        const wh = this.allLocations?.filter((l) => l.id == this.returnDetails?.warehouseId)[0];
        this.soForm.patchValue({
            ...this.returnDetails,
            account: this.accountInfo,
            accountChannel: this.accountChannels?.filter((ac) => ac.id == this.returnDetails?.account?.typeId)[0],
            reference: this.returnDetails?.referenceNumber,
            salesOrderStage: this.allStages[0],
            salesOrderStatus: this.allStatus[0],
            //discountType: discType,
            vendorMessage: "",
            memo: "",
            salesRep: user,
            location: wh,
            statusId: this.returnDetails.statusId == 1 ? true : false,
            shippingChargeAmount: (Number(this.returnDetails?.shippingChargeAmount ?? 0) * this.savedCurrencyExchangeRate).toFixed(this.fractionDigits),
        });
        this.soForm?.controls?.salesOrderStage.disable();
        this.setContentInEditor("");
    }

    setProductsListToConvertFromRMA() {
        for (let l of this.returnDetails?.customerRMAProducts) {
            const uom = l.product.productUOM?.filter((po) => po.unitOfMeasureId == l.productUOMId)[0];
            const pDiscType = this.discountOptions?.filter((v) => v.id == l.discountId)[0];
            let totalAvailQty = 0;
            l.productWarehouseDetailDTO.forEach((e) => {
                totalAvailQty += e.availQty;
            });

            // bundle items
            const bundleDetail = [];
            l?.rmaBundleDetails?.forEach((b) => {
                /**kit under kit items**/
                const kitDetail = [];
                b?.childRMABundleDto?.forEach((kp) => {
                    const ku = kp.product.productUOM?.filter((o) => o.unitOfMeasureId == kp.productUOMId)[0];
                    const kDiscType = this.discountOptions?.filter((v) => v.id == kp.discountId)[0];
                    const obj = {
                        id: kp.subProductId,
                        rowId: kp.id,
                        typeId: kp.product.typeId,
                        itemNo: kp.product.itemNo,
                        description: kp.description ? kp.description : "",
                        uom: kp.product.productUOM,
                        unit: ku,
                        currentVal: kp.quantity,
                        availabel: kp.availableQuantity ?? 0,
                        ordQty: kp.returnQuantity,
                        originalQty: kp.originalQty,
                        bundleQty: kp.quantity,
                        cost: Number(kp?.product?.productPrice?.buyPrice ?? 0) * this.savedCurrencyExchangeRate,
                        price: Number(kp?.pricePerProduct ?? 0) * this.savedCurrencyExchangeRate,
                        originalprice: Number(kp.product?.accountProductPriceTiers?.filter((tier) => tier.tierId == kp.product?.selectedtierId).map((data) => data.calculatedPricePerQty)[0]),
                        accountPriceTier: kp.product?.accountProductPriceTiers,
                        isCustom: kp.product?.isCustom,
                        discountTypeName: kp.product?.tierTypeName,
                        selectedTierId: kp.product?.selectedtierId,
                        salesOrderBundleProductSerialDetail: kp.salesOrderBundleProductSerialDetail,
                        discountType: kDiscType,
                        taxType: b.tax,
                        discount: 0, //this.getDiscountAmount(b, u?.uomDetail?.value || 1),
                        discountAmount: 0, //b.discountAmount,
                        taxAmount: 0,
                        subTotal: Number(kp.totalAmount) * this.savedCurrencyExchangeRate,
                        baseSubTotal: Number(kp.totalAmount) * this.savedCurrencyExchangeRate,
                        totalQuantity: kp.totalQty,
                        isTrackingRequired: kp.product?.isTrackingRequired ? kp.product.isTrackingRequired : false,
                        serialSettings: kp.product?.serialSettings ? JSON.parse(kp.product?.serialSettings) : null,
                        bundleDetailSubTax: kp?.estimateBundleDetailSubTax ?? [],
                        productCategory: kp?.product?.productCategories || [],
                        binDetails: kp?.bins,
                        selectedBin: kp.bins?.length > 0 ? (kp.bins?.find((bin) => bin.id == kp.binId) ? b.bins?.find((bin) => bin.id == kp.binId) : kp.bins[0]) : 0,
                        isDuplicatedProduct: kp?.isCopied ?? false,
                        costPrice: Number(kp.costPrice ?? 0) * this.savedCurrencyExchangeRate,
                        totalCostPrice: Number(kp.totalCostPrice ?? 0) * this.savedCurrencyExchangeRate,
                        additionalFeeType: this.additionalFees?.find((af) => af.id == kp?.additionalFeesId),
                        additionalFee: kp?.additionalRate ?? 0,
                        additionalFeeAmount: Number(kp?.additionalAmount ?? 0) * this.savedCurrencyExchangeRate,
                    };
                    kitDetail.push(obj);
                });
                const u = b.product.productUOM?.filter((o) => o.unitOfMeasureId == b.productUOMId)[0];
                const bDiscType = this.discountOptions?.filter((v) => v.id == b.discountId)[0];
                const obj = {
                    id: b.subProductId,
                    rowId: b.id,
                    typeId: b.product.typeId,
                    itemNo: b.product.itemNo,
                    description: b.description ? b.description : "",
                    uom: b.product.productUOM,
                    unit: u,
                    currentVal: b.quantity,
                    availabel: b.availableQuantity ?? 0,
                    ordQty: b.returnQuantity,
                    originalQty: b.originalQty,
                    bundleQty: b.quantity,
                    cost: Number(b?.product?.productPrice?.buyPrice ?? 0) * this.savedCurrencyExchangeRate,
                    price: Number(b?.pricePerProduct ?? 0) * this.savedCurrencyExchangeRate,
                    originalprice: Number(b.product?.accountProductPriceTiers?.filter((tier) => tier.tierId == b.product?.selectedtierId).map((data) => data.calculatedPricePerQty)[0]),
                    accountPriceTier: b.product?.accountProductPriceTiers,
                    isCustom: b.product?.isCustom,
                    discountTypeName: b.product?.tierTypeName,
                    selectedTierId: b.product?.selectedtierId,
                    salesOrderBundleProductSerialDetail: b.salesOrderBundleProductSerialDetail,
                    discountType: bDiscType,
                    taxType: b.tax,
                    discount: 0, //this.getDiscountAmount(b, u?.uomDetail?.value || 1),
                    discountAmount: 0, //b.discountAmount,
                    taxAmount: 0, //b.taxRate,
                    subTotal: Number(b.totalAmount) * this.savedCurrencyExchangeRate,
                    baseSubTotal: Number(b.totalAmount) * this.savedCurrencyExchangeRate,
                    totalQuantity: b.totalQty,
                    isTrackingRequired: b.product?.isTrackingRequired ? b.product.isTrackingRequired : false,
                    serialSettings: b.product?.serialSettings ? JSON.parse(b.product?.serialSettings) : null,
                    bundleDetailSubTax: b?.estimateBundleDetailSubTax ?? [],
                    productCategory: b?.product?.productCategories || [],
                    binDetails: b?.bins,
                    bundleDetails: kitDetail,
                    selectedBin: b.bins?.length > 0 ? (b.bins?.find((bin) => bin.id == b.binId) ? b.bins?.find((bin) => bin.id == b.binId) : b.bins[0]) : 0,
                    isDuplicatedProduct: b?.isCopied ?? false,
                    additionalFeeType: this.additionalFees?.find((af) => af.id == b?.additionalFeesId),
                    additionalFee: b?.additionalRate ?? 0,
                    additionalFeeAmount: Number(b?.additionalAmount ?? 0) * this.savedCurrencyExchangeRate,
                    costPrice: Number(b.costPrice ?? 0) * this.savedCurrencyExchangeRate,
                    totalCostPrice: Number(b.totalCostPrice ?? 0) * this.savedCurrencyExchangeRate,
                };
                bundleDetail.push(obj);
            });

            const eachProduct = {
                id: l.productId,
                itemNo: l.product.itemNo,
                description: l.description ? l.description : "",
                uom: l.product.productUOM,
                unit: uom,
                availabel: totalAvailQty,
                ordQty: l.returnQuantity,
                cost: Number(l?.product?.productPrice?.buyPrice ?? 0) * this.savedCurrencyExchangeRate,
                price: Number(l?.pricePerProduct ?? 0) * this.savedCurrencyExchangeRate,
                originalprice: Number(l.product?.accountProductPriceTiers?.filter((tier) => tier.tierId == l.product?.selectedtierId).map((data) => data.calculatedPricePerQty)[0]),
                accountPriceTier: l.product?.accountProductPriceTiers,
                isCustom: l.product?.isCustom,
                discountTypeName: l.product?.tierTypeName,
                selectedTierId: l.product?.selectedtierId,
                currentVal: l.returnQuantity,
                warehouseList: l.productWarehouseDetailDTO,
                selectedWarehouseList: l.productWarehouseDetailDTO?.length > 1 ? [] : l.productWarehouseDetailDTO,
                selectedWarehouseCode: l.productWarehouseDetailDTO?.length > 1 ? "" : l.productWarehouseDetailDTO?.[0].warehouseName,
                totalQohInSelectedWareHouse: l.productWarehouseDetailDTO?.length > 1 ? 0 : l.productWarehouseDetailDTO?.[0].qtyOnHand,
                totalAvailInSelectedWareHouse: l.productWarehouseDetailDTO?.length > 1 ? 0 : l.productWarehouseDetailDTO?.[0].availQty,
                typeId: l.product.typeId,
                bundleDetails: bundleDetail,
                discountType: pDiscType,
                taxType: l.tax,
                discount: 0, //this.getDiscountAmount(l, uom?.uomDetail?.value),
                discountAmount: 0, //l.discountAmount,
                taxAmount: 0, //l.taxRate,
                subTotal: Number(l.totalAmount) * this.savedCurrencyExchangeRate,
                baseSubTotal: Number(l.totalAmount) * this.savedCurrencyExchangeRate,
                totalQuantity: l.totalQty,
                isTrackingRequired: l.product?.isTrackingRequired ? l.product.isTrackingRequired : false,
                serialSettings: l.product?.serialSettings ? JSON.parse(l.product?.serialSettings) : null,
                productSubTax: l?.estimateProductSubTax ?? [],
                productCategory: l?.product?.productCategories || [],
                binDetails: l?.bins,
                selectedBin: l.bins?.length > 0 ? (l.bins?.find((bin) => bin.id == l.binId) ? l.bins?.find((bin) => bin.id == l.binId) : l.bins[0]) : 0,
                isDuplicatedProduct: l?.isCopied ?? false,
                additionalFeeType: this.additionalFees?.find((af) => af.id == l?.additionalFeesId),
                additionalFee: l?.additionalRate ?? 0,
                additionalFeeAmount: Number(l?.additionalAmount ?? 0) * this.savedCurrencyExchangeRate,
                costPrice: Number(l.costPrice ?? 0) * this.savedCurrencyExchangeRate,
                totalCostPrice: Number(l.totalCostPrice ?? 0) * this.savedCurrencyExchangeRate,
            };
            this.allProductsData.push(eachProduct);
        }
        this.purchaseListTB = this.allProductsData;
        this.selectedProductsList = this.purchaseListTB;
        this.purchaseListTB.forEach((element) => {
            if (element.typeId == this.typeIds.BundleTypeId) {
                let total = 0;
                if (element.bundleDetails && element.bundleDetails.length) {
                    element.bundleDetails.forEach((e) => {
                        total += e.subTotal;
                    });
                }
                element.subTotal = total;
            }
        });
        this.calculateOrderTotal();
    }

    convertToSalesOrderFromRma() {
        const isValid = this.utilityService.checkvalidation(this.combinedCustomFields);
        const customattributeList = this.utilityService.getCustomAttributesForAddEdit(this.combinedCustomFields);
        if (isValid) {
            const reqArr = [];

            /**
             * Unique warehouse
             */
            const warehouseSet = new Set();
            let hasWh = true;
            this.purchaseListTB.forEach((product) => {
                if (product.selectedWarehouseList.length > 0) {
                    product.selectedWarehouseList.forEach((e) => {
                        warehouseSet.add(e.warehouseId);
                    });
                } else {
                    hasWh = false;
                }
            });

            /**
             * User must have to select at least an warehouse for each product
             * if not then user will get an error msg
             */
            if (warehouseSet && warehouseSet.size > 0 && hasWh) {
                this.isDisabledSaveBtn = true;
                this.appMainService.isShowSpinner("loadSO");
                const uniqueArr = [...warehouseSet];
                const uniqueMap: Map<any, any> = this.prepareProductsListForConvert(uniqueArr);

                for (const [key, value] of uniqueMap.entries()) {
                    if (value && value?.length > 0) {
                        let sumTotal = 0;
                        value?.forEach((v) => {
                            sumTotal += v.subTotal;
                        });
                        const discName = this.soForm?.controls["discountType"].value ? this.soForm?.controls["discountType"]?.value?.name : "";
                        const discValue = this.soForm?.controls["discountValue"]?.value ? this.soForm?.controls["discountValue"]?.value : 0;
                        let dis = this.utilityService.calculateOrderTotalDiscount(discName, discValue, sumTotal, this.purchaseListTB, this.isVisibleRowDiscount, this.footerDiscountEnabled, this.isVisibleFooterDiscount);
                        let tax = this.utilityService.calculateOrderTotalTax(this.purchaseListTB, this.sumTotal, this.isVisibleRowTax, this.footerTaxEnabled, this.isVisibleFooterTax, this.allTaxRates);
                        let orderTotal = 0;
                        orderTotal += sumTotal + Number(this.soForm?.controls["shippingChargeAmount"].value);
                        if (!this.footerTaxEnabled) {
                            orderTotal += tax;
                        }
                        if (this.footerDiscountEnabled) {
                            orderTotal -= dis;
                        }
                        const salesOrderAudit = this.prepareSalesOrderAudit();
                        const salesOrderNote = this.prepareSalesOrderNote();
                        const req = {
                            id: 0,
                            createdSource: this.app.userIP,
                            updatedSource: this.app.userIP,
                            createdBy: this.app.user.userId,
                            updatedBy: this.app.companyId,
                            createdDate: this.app._saveDateTimeWithZone(new Date()),
                            updatedDate: this.app._saveDateTimeWithZone(new Date()),
                            number: "",
                            name: "",
                            description: "",
                            contactId: this.billingAddressContact ? this.billingAddressContact.id : 0,
                            shipContactId: this.shippingAddressContact ? this.shippingAddressContact.id : 0,
                            salesOrderDate: this.app._saveDateTimeWithZone(this.soForm?.controls["estimateDate"].value),
                            organizationId: this.app.companyId,
                            accountId: this.soForm?.controls["account"].value?.id,
                            account: null,
                            warehouseId: this.soForm?.controls["location"].value?.id,
                            warehouse: null,
                            userId: this.soForm?.controls["salesRep"].value && this.soForm?.controls["salesRep"].value?.id ? this.soForm?.controls["salesRep"].value?.id : 0,
                            user: null,
                            shippingAddressId: this.selectedShippingAddress && this.selectedShippingAddress?.addressId ? this.selectedShippingAddress?.addressId : 0,
                            billingAddressId: this.selectedAccountAddress && this.selectedAccountAddress?.addressId ? this.selectedAccountAddress?.addressId : 0,
                            shippingAddress: null,
                            totalAmount: sumTotal,
                            currencyUnitId: 0,
                            discountTypeId: this.footerDiscountEnabled && this.templates?.labels_footer[1]?.isChecked && this.soForm?.controls["discountType"].value ? (this.soForm?.controls["discountType"]?.value?.discountBy ?? 0) : 0,
                            discountType: "",
                            discountAmount: this.footerDiscountEnabled && this.templates?.labels_footer[1]?.isChecked ? this.discount : 0,
                            discountFinancialId: this.footerDiscountEnabled && this.templates?.labels_footer[1]?.isChecked ? this.discountOptions?.filter((discount) => discount.id == this.soForm?.controls["discountType"]?.value?.id).map((value) => value.incomeAccount)[0] : 0,
                            discountId: this.footerDiscountEnabled && this.templates?.labels_footer[1]?.isChecked ? this.discountOptions?.filter((discount) => discount.id == this.soForm?.controls["discountType"]?.value?.id).map((value) => value?.id)[0] : 0,
                            discountName: "",
                            taxId: 0,
                            tax: null,
                            taxAmount: this.footerTaxEnabled && this.templates?.labels_footer[2]?.isChecked ? this.tax : 0,
                            taxRate: this.footerTaxEnabled && this.templates?.labels_footer[2]?.isChecked ? this.tax : 0,
                            taxName: "",
                            taxRateTypeId: 0,
                            taxFinancialId: 0,
                            shippingChargeAmount: this.soForm?.controls["shippingChargeAmount"].value ? this.soForm?.controls["shippingChargeAmount"].value : 0,
                            netAmount: orderTotal,
                            salesOrderStageId: this.soForm?.controls["salesOrderStage"].value?.id,
                            salesOrderStage: "",
                            paymentMethodId: this.soForm?.controls["paymentMethod"].value ? this.soForm?.controls["paymentMethod"].value?.id : 0,
                            paymentMethod: null,
                            paymentTermId: this.soForm?.controls["paymentTerm"].value ? this.soForm?.controls["paymentTerm"].value?.id : 0,
                            paymentTerm: null,
                            sourceId: 0,
                            defaultPriceListId: 0,
                            termsAndCondition: "",
                            reference: this.soForm?.controls["reference"].value,
                            saleCommission: 0,
                            holdOrderProcessedDate: new Date().toISOString(),
                            isBackOrder: false,
                            backOrderInvoiceId: 0,
                            shippingMethodId: this.soForm?.controls?.shippingMethod?.value?.id ?? 0,
                            shippingFinancialId: this.soForm?.controls?.shippingMethod?.value?.financialAccountId ?? 0,
                            shippingMethod: null,
                            shippingTermId: this.soForm?.controls["shippingTerm"].value ? this.soForm?.controls["shippingTerm"].value?.id : 0,
                            shippingTerm: null,
                            salesOrderStatusId: this.soForm?.controls["salesOrderStatus"].value?.id,
                            salesOrderStatus: "",
                            typeId: 0,
                            type: null,
                            groupId: 0,
                            group: null,
                            statusId: this.soForm?.controls["statusId"].value ? 1 : 2,
                            status: null,
                            isValid: true,
                            validFromDate: new Date().toISOString(),
                            validToDate: new Date().toISOString(),
                            salesOrderNote: salesOrderNote,
                            salesOrderAudit: salesOrderAudit,
                            salesOrderProducts: value,
                            exchangeRate: this.savedCurrencyExchangeRate,
                            customAttributeValues: this.setCustomAttributes(customattributeList),
                            // configJson: JSON.stringify(this.templates),
                            configJson: "",
                            createdByUser: "",
                            customerRmaId: this.returnDetails.id,
                            // estimateId: this.returnDetails.id,
                            // estimateNo: this.returnDetails.number,
                            // estimateObjectId: this.customerRmaObjectId,
                            salesObjectId: this.salesObjectId,
                            businessName: this.accountInfo?.businessName,
                            isFreeShipping: false,
                            freeShippingDiscountName: "",
                            freeShippingDiscountAccountId: 0,
                            freeShippingDiscountId: 0,
                            approvalStatusId: ApprovalStatus.Default,
                        };
                        reqArr.push(req);
                    }
                }
                this.salesOrderService
                    .convertToSalesOrderFromRma(reqArr, this.isBaseCurrency())
                    .then(() => {
                        this.messageService.add({
                            severity: "success",
                            summary: "Success",
                            detail: "Converted to Sales Order successfully...",
                        });
                        this.salesOrderService.rmaConverted(this.selectedReturn.id);
                        this.appMainService.isHideSpinner("loadSO");
                        this.displayConvertToSalesOrder = false;
                        this.onSaveComplete.emit(false);
                    })
                    .catch(() => {
                        this.isDisabledSaveBtn = false;
                        this.appMainService.isHideSpinner("loadSO");
                        this.messageService.add({
                            severity: "error",
                            summary: "Error",
                            detail: "Error occurred while converting data...",
                        });
                    });
            } else {
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Please select warehouse to continue...",
                });
            }
        } else {
            this.messageService.add({
                severity: "error",
                summary: "Error",
                detail: "Please fill up all required field...",
            });
        }
    }

    /** End RMA To Sales Order */

    /** Product add and remove */

    openProductsDialog() {
        this.moduleName = "SalesOrder";
        this.displayProductSelectionModal = true;
        this.selectedProductsList = this.purchaseListTB;
        this.selectedLocationId = this.soForm?.controls?.location.value ? this.soForm?.controls?.location.value?.id : 0;
    }
    openProductsDialogForBundle(bundle) {
        this.moduleName = "Bundle";
        this.selectedBundle = bundle;
        this.displayProductSelectionModal = true;
        this.selectedProductsList = bundle.bundleDetails;
        this.selectedLocationId = this.soForm?.controls?.location.value ? this.soForm?.controls?.location.value?.id : 0;
    }

    removeProduct(i) {
        this.purchaseListTB.splice(i, 1);
        if (this.type == DialogType.CREATE && this.purchaseListTB && this.purchaseListTB.length == 0) {
            this.soForm?.controls?.location.enable();
        }
        this.calculateOrderTotal();
    }

    removeBundleProduct(bundle, i) {
        this.purchaseListTB.forEach((e) => {
            if (e.id == bundle.id) {
                e.bundleDetails.splice(i, 1);
                if (e.typeId == this.typeIds.BundleTypeId) {
                    let total = 0;
                    e.bundleDetails.forEach((ib) => {
                        total += ib.subTotal;
                    });
                    e.price = total;
                    e.subTotal = total;
                } else if (e.typeId == this.typeIds.KitTypeId) {
                    let kitQty = 0;
                    let kitCount = 0;
                    let count = 0;
                    e.bundleDetails?.forEach((element) => {
                        if (element.typeId == TypeIds.InventoryTypeId) {
                            if (count == 0) {
                                kitQty = Math.floor(element.availabel / (element.ordQty * (element?.unit?.uomDetail?.value || 1)));
                                kitCount = isNaN(kitCount) ? 0 : kitCount;
                                kitCount = kitQty < 0 ? 0 : kitQty;
                                count++;
                            } else if (count > 0) {
                                kitQty = Math.floor(element.availabel / (element.ordQty * (element?.unit?.uomDetail?.value || 1)));
                                kitCount = isNaN(kitCount) ? 0 : kitCount;
                                kitCount = kitQty <= kitCount && kitQty >= 0 ? kitQty : kitCount;
                                count++;
                            }
                        }
                    });
                    e.totalAvailInSelectedWareHouse = kitCount;
                    e.availabel = kitCount;
                }
            }
        });
        this.calculateOrderTotal();
    }
    onProductCancelClicked(e) {
        this.displayProductSelectionModal = false;
    }
    onProductAddComplete(event) {
        this.displayProductSelectionModal = false;
        if ((this.stageId == SoStageId.Pick || this.stageId == SoStageId.Pack) && event && event.length) {
            event.forEach((e) => {
                if (!e.pickedQty && !e.packedQty) {
                    e.pickedQty = e.ordQty;
                    e.packedQty = e.ordQty;
                }
            });
        }
        const updatedProducts = this.utilityService.convertProductPriceByExchangeRate(event, this.currencyExchangeRate ?? this.baseCurrency?.exchangeRate);
        this.purchaseListTB = this.productCalculationUtilityService.onProductSelectionComplete(this.moduleName, this.purchaseListTB, this.selectedBundle, updatedProducts, this.allTaxRates, this.footerTaxEnabled, this.isVisibleRowTax, this.shippingAddressInfo?.address?.zipCode, this.shippingAddressInfo?.address?.stateId, this.taxSettings, this.taxConfig);
        this.reCalculateProductsTotal("productAdd");
        if (this.purchaseListTB && this.purchaseListTB.length && this.type !== DialogType.COPY) {
            this.soForm?.controls?.location.disable();
        }
        this.calculateOrderTotal();
    }
    reCalculateProductsTotal(type?){
        const allTaxes = this.purchaseListTB?.flatMap((product) => {
            return product.typeId === this.typeIds.BundleTypeId
                ? product.bundleDetails.flatMap((bundle) => bundle.bundleDetailSubTax || [])
                : product.productSubTax || [];
        });
        const uniqueTaxIds = Array.from(
            new Set(
                allTaxes?.map((tax) => tax.taxId || tax.id)
            )
        );
        const taxRates = this.allTaxRates.filter((taxRate) =>
            uniqueTaxIds.includes(taxRate.id)
        );
        const filteredTaxRates = taxRates?.map((taxRate) => ({ ...taxRate, taxId: taxRate.taxId || taxRate.id }));
        this.sumTotal = 0;

        for (let s of this.purchaseListTB) {
            if (s.typeId == TypeIds.BundleTypeId) {
                s?.bundleDetails?.forEach((bundleProduct) => {
                    if(!bundleProduct?.isManualTaxApplied && this.footerTaxEnabled){
                        const subTaxes = this.utilityService.getProductsApplicableSubTaxes(
                            bundleProduct, 
                            this.allTaxRates, 
                            this.shippingAddressInfo?.address?.zipCode, 
                            this.shippingAddressInfo?.address?.stateId, 
                            this.taxSettings, 
                            this.taxConfig);
                        bundleProduct.bundleDetailSubTax = subTaxes;

                        if(type && type == "productAdd"){
                            bundleProduct.bundleDetailSubTax = filteredTaxRates;
                        }
                    }
                    this.onChangeBundleProductTaxOrDiscount(s, bundleProduct, type ? type : "qty");
                });
            } else {
                if(!s?.isManualTaxApplied && this.footerTaxEnabled){
                    const subTaxes = this.utilityService.getProductsApplicableSubTaxes(
                        s, 
                        this.allTaxRates, 
                        this.shippingAddressInfo?.address?.zipCode, 
                        this.shippingAddressInfo?.address?.stateId, 
                        this.taxSettings, 
                        this.taxConfig);
                    if(type != "tax") {
                        s.productSubTax = subTaxes;
                    }

                    if(type && type == "productAdd"){
                        s.productSubTax = filteredTaxRates;
                    }
                }
                this.onChangeProductTaxOrDiscount(s, type ? type : "qty");
            }
            this.sumTotal = this.sumTotal + s.baseSubTotal;
            s.currentVal = s.availabel;
        }
    }
    getDecimalPlacesCached(categoryId: number): number {
        if (!(categoryId in this.decimalPlacesMap)) {
            this.decimalPlacesMap[categoryId] = this.getDecimalPlaces(categoryId);
        }
        return this.decimalPlacesMap[categoryId];
    }
    getDecimalPlaces(categoryId: number): number {
        return this.measurementUnits?.some((unit) => unit.id === categoryId && unit.name?.toLowerCase() === "count") ? 0 : this.qtyFractionDigits;
    }
    onChangeCurrencyRecalculateAmount() {
        this.purchaseListTB = this.utilityService.reConvertProductPriceByExchangeRate(this.purchaseListTB, this.currencyExchangeRate ?? this.baseCurrency?.exchangeRate, this.previousCurrencyExchangeRate);
        this.reCalculateProductsTotal();
        if (this.purchaseListTB && this.purchaseListTB.length && this.type !== DialogType.COPY) {
            this.soForm?.controls?.location.disable();
        }
        this.calculateOrderTotal();
        this.previousCurrencyExchangeRate = this.currencyExchangeRate;
    }

    onProductSearchComplete(e) {
        const updatedProducts = this.utilityService.convertProductPriceByExchangeRate(this.utilityService.setTotalCostPrice(e), this.currencyExchangeRate ?? this.baseCurrency?.exchangeRate);
        const data = {
            channelName: SOChannel.SALES_ORDER,
            products: this.purchaseListTB,
            newProducts: updatedProducts,
            salesOrderStageId: this.soDetails?.salesOrderStageId || 0,
            allTaxRates: this.allTaxRates,
            zipCode: this.shippingAddressInfo?.address?.zipCode,
            stateId: this.shippingAddressInfo?.address?.stateId,
            taxSettings: this.taxSettings,
            taxConfig: this.taxConfig,
            taxEnabled: this.footerTaxEnabled,
            isVisibleRowTax: this.isVisibleRowTax,
        };
        this.purchaseListTB = this.productCalculationUtilityService.onProductSearchCompleteByBarcode(data);
        this.sumTotal = 0;
        for (let s of this.purchaseListTB) {
            this.sumTotal = this.sumTotal + s.baseSubTotal;
            s.currentVal = s.availabel;
        }
        if (this.purchaseListTB && this.purchaseListTB.length) {
            this.soForm?.controls?.location.disable();
        }
        this.calculateOrderTotal();
    }

    /** End Product add and remove */

    onChangeAccountUpdateProducts() {
        const SelectedLocationId = this.soForm?.controls?.location.value?.id;
        const ProductIds = this.purchaseListTB.map((prod) => prod.id).join(",");
        this.appMainService.isShowSpinner("loadProducts");
        this.productsService
            .getProductList(this.accountInfo.id, ProductIds, SelectedLocationId)
            .pipe(
                takeUntil(this.ngUnsubscribe$),
                map((resp) => this.productDataService.prepareProductsList(resp)),
                tap((products) => this.updateProductQuantities(products)),
                finalize(() => this.appMainService.isHideSpinner("loadProducts")),
            )
            .subscribe(
                () => {},
                () => {},
            );
    }
    updateProductQuantities(products) {
        this.purchaseListTB?.forEach((product) => {
            const purchaseProduct = products?.find((p) => p.id === product.id);
            if (purchaseProduct) {
                product.price = purchaseProduct.price ?? 0;
                product.subTotal = 0;
                product.baseSubTotal = 0;
                product.accountPriceTier = [];
                if (purchaseProduct?.accountPriceTier && purchaseProduct?.accountPriceTier?.length > 0) {
                    product.accountPriceTier.push(purchaseProduct.accountPriceTier[0]);
                }
                if (product.bundleDetails && product.bundleDetails?.length > 0) {
                    product?.bundleDetails?.forEach((bundleProduct) => {
                        const bundleProductToUpdate = purchaseProduct?.bundleDetails?.find((bp) => bp.id === bundleProduct.id);
                        if (bundleProductToUpdate) {
                            bundleProductToUpdate.price = bundleProduct.price ?? 0;
                            bundleProductToUpdate.subTotal = 0;
                            bundleProductToUpdate.baseSubTotal = 0;
                        }
                    });
                }
            }
            this.calculateProductsSubTotal(product, product.ordQty, "discount");
            if (this.type == DialogType.COPY) {
                this.calculateSubTotal(product, product.ordQty, "qty");
            }
        });
        this.calculateOrderTotal();
    }
    setProductsInitialQtyForCopy() {
        this.purchaseListTB?.forEach((product) => {
            product.ordQty = product.totalQuantity;
            if (product.bundleDetails && product.bundleDetails?.length > 0) {
                product?.bundleDetails?.forEach((bundleProduct) => {
                    bundleProduct.ordQty = bundleProduct.totalQuantity;
                });
            }
        });
        this.calculateOrderTotal();
    }

    calculateProductsSubTotal(item, qty, type) {
        if (type == "discounttype") {
            // item.discount = 0;
            item.discount = item?.discountType?.discountValue ?? 0;
        } else if (type == "additionalFeeType") {
            item.additionalFee = item?.additionalFeeType?.discountValue ?? 0;
        }else if(type == "price" && item.price == 0){
            item.discount = 0;
            item.additionalFee = 0;
            item.discountType = null;
            item.additionalFeeType = null;
        }
        /**
         * If type is bundle, then first calculate ordQty & totalQuantity of a product inside bundle.
         * then calculate subtotal of a product and total of bundle
         */
        if (item.typeId == TypeIds.BundleTypeId) {
            // const data = { aggregateDiscount: this.aggregateDiscount };
            const data = {
                aggregateDiscount: this.aggregateDiscount,
                zipCode: this.shippingAddressInfo?.address?.zipCode,
                stateId: this.shippingAddressInfo?.address?.stateId,
                taxSettings: this.taxSettings,
                taxConfig: this.taxConfig,
                allDiscounts: this.discountOptions,
                discountTypeId: this.soForm?.controls["discountType"]?.value?.id,
                allTaxRates: this.allTaxRates,
                channelName: SOChannel.ESTIMATES,
                isEnabledRowTax: this.isVisibleRowTax,
                taxEnabled: this.footerTaxEnabled,
                isRowWiseAdditionalFeeEnabled: this.templates?.labels_table[10]?.isChecked ?? false,
                isRowWiseDiscountEnabled: this.templates?.labels_table[6]?.isChecked ?? false,
            };
            this.productCalculationUtilityService.calculateQtyAndBundleProductsSubTotal(item, qty, this.allTaxRates, this.soChannel.SALES_ORDER, this.type, this.footerTaxEnabled, this.isVisibleRowTax, data);
            this.calculateOrderTotal();
        } else {
            this.onChangeProductTaxOrDiscount(item, type);
            this.calculateOrderTotal();
        }
    }
    onChangeUom(product, event) {
        product.subTotal = 0;
        if (product.typeId != this.typeIds.BundleTypeId) {
            product.totalQuantity = Number(product.ordQty) * Number(event?.uomDetail?.value || 1);
            if (product.accountPriceTier?.length > 0) {
                product.price = this.utilityService.applyPriceBook(this.aggregateDiscount, product, product.totalQuantity);
                product.price = product.price * (this.currencyExchangeRate ?? this.baseCurrency?.exchangeRate);
            }
            this.onChangeProductTaxOrDiscount(product, "");
            // this.utilityService.calculateProductsSubTotal(product, this.type, this.allTaxRates, SOChannel.SALES_ORDER, this.aggregateDiscount, this.isVisibleRowTax, this.footerTaxEnabled);
        }
        this.calculateOrderTotal();
    }
    /** Account and address */
    checkHoldEligibility() {
        this.isAvailableEnoughAccCredit = this.utilityService.checkAvailabilityOfAccountCredit(this.soDetails?.account?.availableCredit, this.soDetails?.netAmount, this.soDetails?.account?.accountCreditEnabled, this.accountInfo?.accountCreditControlId);
        this.accHoldMsg = !this.isAvailableEnoughAccCredit ? accHoldMsg : "";
    }

    async selectAccount(c) {
        this.accountInfo = null;
        this.accHoldMsg = "";
        this.billingAddressContact = null;
        this.shippingAddressContact = null;
        this.shippingAddressInfo = null;
        this.accountAddressInfo = null;
        if (this.type !== DialogType.COPY) {
            this.purchaseListTB = [];
        }
        this.appMainService.isShowSpinner("loadOrderAccountsAddress");
        if (this.accountInfo?.id !== c?.value?.id) {
            this.accountAddressInfo = null;
        }
        this.accountInfo = await this.salesOrderService.getAccountDetailsById(c.value?.id);
        this.getcurrencyExchangeRate();
        // this.soForm?.controls["account"].patchValue(this.accountInfo);
        this.appMainService.isHideSpinner("loadOrderAccountsAddress");
        if (this.accountInfo?.accountCreditControlId == CreditControlEnum.Hold) {
            return this.checkHoldEligibility();
        }
        if (this.type == DialogType.COPY) {
            this.onChangeAccountUpdateProducts();
        }

        /** default billing and shipping address */
        if (this.accountInfo && this.accountInfo.accountAddresses && this.accountInfo.accountAddresses.length > 0) {
            const allBillAddress = this.accountInfo.accountAddresses.filter((a) => a.address?.addressTypeId == this.billingAddressType?.id);
            const allShipAddress = this.accountInfo.accountAddresses.filter((a) => a.address?.addressTypeId == this.shippingAddressType?.id);
            this.accountAddressInfo = allBillAddress ? allBillAddress.filter((b) => b.address?.isDefault == true)[0] : null;
            this.selectedAccountAddress = this.accountAddressInfo;
            this.shippingAddressInfo = allShipAddress ? allShipAddress.filter((s) => s.address?.isDefault == true)[0] : null;
        }
        if (this.shippingAddressInfo) {
            this.selectedShippingAddress = this.shippingAddressInfo;
        } else {
            this.shippingAddressInfo = this.accountAddressInfo;
            this.selectedShippingAddress = this.shippingAddressInfo;
        }

        this.getTaxByAddress(this.shippingAddressInfo?.address?.countryId, this.shippingAddressInfo?.address?.stateId);

        /** billing contact */
        if (this.accountAddressInfo) {
            if (this.accountAddressInfo.address && this.accountAddressInfo.address.attnContactId) {
                this.billingAddressContact = this.accountAddressInfo.address.attnContact;
            } else {
                if (this.accountInfo && this.accountInfo.accountContacts) {
                    this.accountInfo.accountContacts.forEach((e) => {
                        if (e.isPrimaryContact) {
                            this.billingAddressContact = e?.contact;
                        }
                    });
                }
            }
        }

        /** shipping contact */
        if (this.shippingAddressInfo) {
            if (this.shippingAddressInfo.address && this.shippingAddressInfo.address.attnContactId) {
                this.shippingAddressContact = this.shippingAddressInfo.address.attnContact;
            } else {
                if (this.accountInfo && this.accountInfo.accountContacts) {
                    this.accountInfo.accountContacts.forEach((e) => {
                        if (e.isPrimaryContact) {
                            this.shippingAddressContact = e?.contact;
                        }
                    });
                }
            }
        }
        this.displayAccountAddress = this.accountInfo && this.accountInfo.accountAddresses && this.accountInfo.accountAddresses.length > 0 && !this.accountAddressInfo ? true : false;

        /** set payment term associated with account */
        let defaultTerms;
        this.allPaymentTerms = [];
        if (this.accountInfo?.accountPaymentTerms) {
            this.accountInfo?.accountPaymentTerms.forEach((e) => {
                if (this.type == DialogType.CREATE && e.statusId == Status.Active) {
                    this.allPaymentTerms.push(e.paymentTerm);
                } else if (this.type == DialogType.EDIT || this.type == DialogType.COPY) {
                    this.allPaymentTerms.push(e.paymentTerm);
                }
                if (e.isDefault && e.statusId == Status.Active) {
                    defaultTerms = e.paymentTerm;
                }
            });
        }
        if (defaultTerms) {
            this.soForm?.controls["paymentTerm"].setValue(defaultTerms);
        }

        /** set payment method associated with account */
        let defaultMethods;
        this.allPaymentMethods = [];
        if (this.accountInfo?.accountPaymentMethods) {
            this.accountInfo?.accountPaymentMethods.forEach((e) => {
                if (this.type == DialogType.CREATE && e.statusId == Status.Active) {
                    this.allPaymentMethods.push(e.paymentMethod);
                } else if (this.type == DialogType.EDIT || this.type == DialogType.COPY) {
                    this.allPaymentMethods.push(e.paymentMethod);
                }
                if (e.isDefault && e.statusId == Status.Active) {
                    defaultMethods = e.paymentMethod;
                }
            });
        }
        if (defaultMethods) {
            this.soForm?.controls["paymentMethod"].setValue(defaultMethods);
        }

        /** Shipping method */
        if (this.accountInfo?.accountShippingMethods && this.accountInfo?.accountShippingMethods?.length > 0) {
            let defaultShippingMethod = this.accountInfo?.accountShippingMethods?.find((s) => s.isDefault == true);
            if (defaultShippingMethod) {
                this.setShippingMethodFormValue(defaultShippingMethod?.shippingMethodId);
            }
        }

        if (this.type == DialogType.CREATE || this.type == DialogType.EDIT || this.type == DialogType.COPY) {
            this.calculateOrderTotal();
        }
    }

    clearAccount(event) {
        this.soForm?.controls["account"].setValue("");
        this.soForm?.controls["paymentTerm"].setValue("");
        this.soForm?.controls["paymentMethod"].setValue("");
        if (this.type !== DialogType.COPY) {
            this.accountInfo = null;
            this.billingAddressContact = null;
            this.shippingAddressContact = null;
            this.shippingAddressInfo = null;
            this.accountAddressInfo = null;
            this.purchaseListTB = [];
        }
        this.setDefaultShippingMethod();
        if (this.type == DialogType.CREATE || this.type == DialogType.EDIT || this.type == DialogType.COPY) {
            this.calculateOrderTotal();
        }
    }

    onChangeAccountChannel() {
        this.soForm?.controls["account"].setValue("");
        this.soForm?.controls["paymentTerm"].setValue("");
        this.soForm?.controls["paymentMethod"].setValue("");
        this.accountInfo = null;
        this.billingAddressContact = null;
        this.shippingAddressContact = null;
        this.shippingAddressInfo = null;
        this.accountAddressInfo = null;
        this.purchaseListTB = [];
        this.setDefaultShippingMethod();
        if (this.type == DialogType.CREATE || this.type == DialogType.EDIT || this.type == DialogType.COPY) {
            this.calculateOrderTotal();
        }
    }
    filterAccount(event) {
        let query = event.query;
        query = event.query;
        const typeId = this.soForm?.controls["accountChannel"].value?.id;
        this.appMainService.isShowSpinner("getAccountList");
        this.accountServiceN
            .getAccountsByNameWithHierarchy(typeId, query)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (response) => {
                    if (response) {
                        this.allAccountsDD = this.accountFlatteningService.flattenAccounts(response);
                    } else {
                        this.allAccountsDD = [];
                    }
                    this.appMainService.isHideSpinner("getAccountList");
                },
                error: (error) => {
                    this.appMainService.isHideSpinner("getAccountList");
                },
                complete: () => {
                    this.appMainService.isHideSpinner("getAccountList");
                },
            });
    }
    setShippingMethodFormValue(id: number) {
        if (this.accountInfo && this.accountInfo?.accountShippingMethods && this.accountInfo?.accountShippingMethods?.length > 0) {
            this.soForm?.controls["shippingMethod"].setValue(this.utilityService.findShippingMethodById(this.shippingMethods, id));
        }
    }
    setDefaultShippingMethod() {
        if (this.shippingMethods && this.shippingMethods?.length > 0) {
            this.soForm?.controls["shippingMethod"].setValue(this.shippingMethods.filter((sm) => sm.isDefault == true)[0]);
        }
    }

    onRowSelectBillingAddress(e) {
        this.displayAccountAddress = false;
        this.accountAddressInfo = JSON.parse(JSON.stringify(this.selectedAccountAddress));
        if (this.accountAddressInfo && this.accountAddressInfo?.address && this.accountAddressInfo?.address?.attnContactId) {
            this.billingAddressContact = this.accountAddressInfo?.address?.attnContact;
        } else {
            if (this.accountInfo && this.accountInfo.accountContacts) {
                this.accountInfo.accountContacts.forEach((e) => {
                    if (e.isPrimaryContact) {
                        this.billingAddressContact = e?.contact;
                    }
                });
            }
        }
    }
    async onRowSelectShippingAddress(e) {
        this.displayShippingAddress = false;
        this.shippingAddressInfo = JSON.parse(JSON.stringify(this.selectedShippingAddress));
        if (this.shippingAddressInfo && this.shippingAddressInfo?.address && this.shippingAddressInfo?.address?.attnContactId) {
            this.shippingAddressContact = this.shippingAddressInfo?.address?.attnContact;
        } else {
            if (this.accountInfo && this.accountInfo.accountContacts) {
                this.accountInfo.accountContacts.forEach((e) => {
                    if (e.isPrimaryContact) {
                        this.shippingAddressContact = e?.contact;
                    }
                });
            }
        }

        await this.getTaxByAddress(this.shippingAddressInfo?.address?.countryId, this.shippingAddressInfo?.address?.stateId);
        if (this.purchaseListTB && this.purchaseListTB?.length > 0) {
            this.purchaseListTB?.forEach((product) => {
                if (product) {
                    product.subTotal = 0;
                    product.baseSubTotal = 0;
                    if (product.bundleDetails && product.bundleDetails?.length > 0) {
                        product?.bundleDetails?.forEach((bundleProduct) => {
                            if (bundleProduct) {
                                bundleProduct.subTotal = 0;
                                bundleProduct.baseSubTotal = 0;
                            }
                        });
                    }
                }
            });
            this.onProductAddComplete(this.purchaseListTB);
        }
    }
    openContactSelectionModal(e) {
        if (e == ContactSelectionType.BILLING) {
            this.selectedContact = this.billingAddressContact;
        } else if (e == ContactSelectionType.SHIPPING) {
            this.selectedContact = this.shippingAddressContact;
        }
        this.contactSelectionModalType = e;
        this.displayContactSelectionModal = true;
    }
    onContactSelectionComplete(e) {
        this.displayContactSelectionModal = false;
        if (this.contactSelectionModalType == ContactSelectionType.BILLING) {
            this.billingAddressContact = e?.contact;
        } else if (this.contactSelectionModalType == ContactSelectionType.SHIPPING) {
            this.shippingAddressContact = e?.contact;
        }
    }
    onContactSelectionCancel() {
        this.contactSelectionModalType = "";
        this.displayContactSelectionModal = false;
    }
    editAccountAddress() {
        this.displayAccountAddress = true;
    }

    editShippingAddress() {
        this.displayShippingAddress = true;
    }

    async getTaxByAddress(countryId: number, stateId: number) {
        const taxData: any = await this.utilityService.getTaxByCountryId(countryId);
        this.taxSettings = taxData.taxSettings ?? null;
        this.allTaxRates = taxData?.allTaxRates ?? [];
        this.taxConfig = taxData.taxConfig ?? null;
    }

    /** End Account and address */

    /** Save and Update Sales Order */

    save() {
        if (this.orderTotal < 0) {
            this.messageService.add({
                severity: "error",
                summary: "Error",
                detail: "Order total can not be negative...",
            });
        } else {
            if (this.type && this.type == DialogType.CONVERT) {
                if (this.accountInfo.accountCreditControlId === CreditControlEnum.Hold) {
                    this.messageService.add({
                        severity: "error",
                        summary: "Error",
                        detail: "You cannot create Sales Order due to account credit limit.",
                    });
                    return;
                } else {
                    this.convertToSalesOrder();
                }
            } else if (this.type && this.type == DialogType.CONVERT_FROM_RMA) {
                if (this.accountInfo.accountCreditControlId === CreditControlEnum.Hold) {
                    this.messageService.add({
                        severity: "error",
                        summary: "Error",
                        detail: "You cannot create Sales Order due to account credit limit.",
                    });
                    return;
                } else {
                    this.convertToSalesOrderFromRma();
                }
            } else {
                this.saveSalesOrder();
            }
        }
    }
    saveSalesOrder() {
        const isValid = this.utilityService.checkvalidation(this.combinedCustomFields);
        this.isAvailableEnoughAccCredit = this.utilityService.checkAvailabilityOfAccountCredit(this.accountInfo?.availableCredit, this.orderTotal, this.accountInfo?.accountCreditControlId === CreditControlEnum.On, this.accountInfo?.accountCreditControlId);
        if(this.isAvailableEnoughAccCredit) {
            if (this.type && (this.type == DialogType.CREATE || this.type == DialogType.COPY) && isValid) {
                this.addNewSalesOrder();
            } else if (this.type && this.type == DialogType.EDIT && isValid) {
                this.updateSalesOrder();
            } else {
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Please fill up all required field...",
                });
            }
        } else {
            this.messageService.add({
                severity: "error",
                summary: "Error",
                detail: "You cannot create Sales Order due to account credit limit.",
            });
        }
    }
    addNewSalesOrder() {
        this.isDisabledSaveBtn = true;
        let soObj = this.prepareSalesOrderDataToSave();
        this.appMainService.isShowSpinner("loadSO");
        this.salesOrderService
            .createSalesOrder(soObj, this.isBaseCurrency())
            .then((res) => {
                this.appMainService.isHideSpinner("loadSO");
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: this.type == DialogType.CREATE ? "Sales Order saved successfully..." : "Sales Order copied successfully...",
                });
                this.displayConvertToSalesOrder = false;
                this.applyCreditMemo(res);
                this.onSaveComplete.emit(false);
            })
            .catch(() => {
                this.isDisabledSaveBtn = false;
                this.appMainService.isHideSpinner("loadSO");
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred while saving data...",
                });
            });
    }
    updateSalesOrder() {
        this.isDisabledSaveBtn = true;
        let soObj = this.prepareSalesOrderDataToUpdate();
        this.appMainService.isShowSpinner("loadSO");
        this.salesOrderService
            .updateSalesOrder(soObj, this.isBaseCurrency())
            .then((res) => {
                this.appMainService.isHideSpinner("loadSO");
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Sales Order updated successfully...",
                });
                this.displayConvertToSalesOrder = false;
                this.applyCreditMemo(res);
                this.onSaveComplete.emit(false);
            })
            .catch(() => {
                this.isDisabledSaveBtn = false;
                this.appMainService.isHideSpinner("loadSO");
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred while updating data...",
                });
            });
    }
    applyCreditMemo(soDetails) {
        if (this.applyCreditMemoType == "apply") {
            let data = {
                app: this.app,
                detailsData: soDetails,
                selectedCredits: this.selectedCredits,
                channel: SOChannel.SALES_ORDER,
                receivedPayment: this.receivedPayment,
            };
            let receivedPaymentRequestData = this.receivedPaymentRequestBuilderService.prepareReceivedPaymentRequestData(data);
            if (this.receivedPayment && this.receivedPayment?.id) {
                this.updateReceivedPayment(receivedPaymentRequestData);
            } else {
                this.createReceivedPayment(receivedPaymentRequestData);
            }
        }
    }
    createReceivedPayment(receivedPaymentRequestData) {
        this.appMainService.isShowSpinner("payment");
        this.salesOrderService
            .createReceivedPAyment(receivedPaymentRequestData)
            .then(() => {
                this.appMainService.isHideSpinner("payment");
                // this.messageService.add({
                //     severity: "success",
                //     summary: "Success",
                //     detail: "Payment Received successfully...",
                // });
            })
            .catch((e) => {
                this.appMainService.isHideSpinner("payment");
                // this.messageService.add({
                //     severity: "error",
                //     summary: "Error",
                //     detail: "Error occurred while saving data...",
                // });
            });
    }
    updateReceivedPayment(receivedPaymentRequestData) {
        this.appMainService.isShowSpinner("payment");
        this.salesOrderService
            .updateReceivedPayment(receivedPaymentRequestData)
            .then(() => {
                this.appMainService.isHideSpinner("payment");
                // this.messageService.add({
                //     severity: "success",
                //     summary: "Success",
                //     detail: "Payment Received successfully...",
                // });
            })
            .catch((e) => {
                this.appMainService.isHideSpinner("payment");
                // this.messageService.add({
                //     severity: "error",
                //     summary: "Error",
                //     detail: "Error occurred while saving data...",
                // });
            });
    }

    prepareSalesOrderDataToSave(): ISalesOrder {
        const products = this.prepareProductsListForAddEdit();
        const salesOrder: ISalesOrder = {
            id: 0,
            createdSource: this.app.userIP,
            updatedSource: this.app.userIP,
            createdBy: this.app.user.userId,
            updatedBy: this.app.user.userId,
            createdDate: this.app._saveDateTimeWithZone(new Date()),
            updatedDate: this.app._saveDateTimeWithZone(new Date()),
            salesObjectId: this.salesObjectId,
            businessName: this.accountInfo?.businessName,
            number: "",
            name: "",
            description: "",
            organizationId: this.app.companyId,
            contactId: this.billingAddressContact ? this.billingAddressContact.id : 0,
            shipContactId: this.shippingAddressContact ? this.shippingAddressContact.id : 0,
            salesOrderDate: this.app._saveDateTimeWithZone(this.soForm?.controls["estimateDate"].value),
            reference: this.soForm?.controls["reference"].value,
            accountId: this.soForm?.controls["account"].value?.id,
            warehouseId: this.soForm?.controls["location"].value?.id,
            userId: this.soForm?.controls["salesRep"].value && this.soForm?.controls["salesRep"].value?.id ? this.soForm?.controls["salesRep"].value?.id : 0,
            shippingAddressId: this.selectedShippingAddress && this.selectedShippingAddress?.addressId ? this.selectedShippingAddress?.addressId : 0,
            billingAddressId: this.selectedAccountAddress && this.selectedAccountAddress?.addressId ? this.selectedAccountAddress?.addressId : 0,
            totalAmount: this.sumTotal,
            discountTypeId: this.footerDiscountEnabled && this.templates?.labels_footer[1]?.isChecked && this.soForm?.controls["discountType"].value ? (this.soForm?.controls["discountType"]?.value?.discountBy ?? 0) : 0,
            discountType: "",
            discountAmount: this.footerDiscountEnabled && this.templates?.labels_footer[1]?.isChecked ? this.discount : 0,
            discountFinancialId: this.footerDiscountEnabled && this.templates?.labels_footer[1]?.isChecked ? (this.soForm?.controls["discountType"]?.value?.incomeAccount ?? 0) : 0,
            discountId: this.footerDiscountEnabled && this.templates?.labels_footer[1]?.isChecked ? this.soForm?.controls["discountType"]?.value?.id : 0,
            discountRate: this.footerDiscountEnabled && this.templates?.labels_footer[1]?.isChecked ? (this.soForm?.controls["discountValue"]?.value ?? 0) : 0,
            discountName: "",
            taxId: this.footerTaxEnabled && this.templates?.labels_footer[2]?.isChecked ? this.allTaxRates?.[0]?.id || 0 : 0,
            taxAmount: this.tax,
            taxName: "",
            taxRateTypeId: this.footerTaxEnabled && this.templates?.labels_footer[2]?.isChecked ? this.allTaxRates?.[0]?.typeId || 0 : 0,
            taxFinancialId: this.footerTaxEnabled && this.templates?.labels_footer[2]?.isChecked ? this.allTaxRates?.[0]?.financialAccountId || 0 : 0,
            shippingChargeAmount: this.soForm?.controls["shippingChargeAmount"].value ? this.soForm?.controls["shippingChargeAmount"].value : 0,
            netAmount: this.orderTotal,
            balanceDue: this.orderTotal,
            salesOrderStageId: this.type == DialogType.COPY ? 1 : this.soForm?.controls["salesOrderStage"].value?.id,
            salesOrderStage: "",
            paymentMethodId: this.soForm?.controls["paymentMethod"].value ? this.soForm?.controls["paymentMethod"].value?.id : 0,
            paymentTermId: this.soForm?.controls["paymentTerm"].value ? this.soForm?.controls["paymentTerm"].value?.id : 0,
            sourceId: 0,
            defaultPriceListId: 0,
            termsAndCondition: "",
            saleCommission: 0,
            holdOrderProcessedDate: new Date(),
            isBackOrder: false,
            backOrderInvoiceId: 0,
            shippingMethodId: this.soForm?.controls?.shippingMethod?.value?.id ?? 0,
            shippingFinancialId: this.soForm?.controls?.shippingMethod?.value?.financialAccountId ?? 0,
            shippingTermId: this.soForm?.controls["shippingTerm"].value ? this.soForm?.controls["shippingTerm"].value?.id : 0,
            salesOrderStatusId: this.soForm?.controls["salesOrderStatus"].value?.id,
            salesOrderStatus: "",
            typeId: 0,
            groupId: 0,
            statusId: this.soForm?.controls["statusId"].value ? 1 : 2,
            isValid: true,
            validFromDate: new Date(),
            validToDate: new Date(),
            salesOrderNote: this.prepareSalesOrderNote(),
            salesOrderAudit: this.prepareSalesOrderAudit(),
            salesOrderProducts: products,
            createdByUser: "",
            configJson: "",
            customAttributeValues: this.setCustomAttributes(this.utilityService.getCustomAttributesForAddEdit(this.combinedCustomFields)),
            isFreeShipping: false,
            freeShippingDiscountName: "",
            freeShippingDiscountAccountId: 0,
            freeShippingDiscountId: 0,
            channelId: this.soForm?.controls?.accountChannel.value?.id,
            salesOrderPaymentStatusId: 1,
            additionalDiscount: Number(this.additionalDiscountAmount),
            salesOrderAddDiscount: this.prepareAdditionalDiscountsForNewSalesOrder(),
            additionalFeesId: this.templates?.labels_footer[10]?.isChecked ? (this.soForm?.controls["additionalFeeType"]?.value?.id ?? 0) : 0,
            additionalRate: this.templates?.labels_footer[10]?.isChecked ? (this.soForm?.controls["additionalFee"]?.value ?? 0) : 0,
            additionalAmount: this.templates?.labels_footer[10]?.isChecked ? this.totalAdditionalFee : 0,
            additionalFeesFinancialId: this.templates?.labels_footer[10]?.isChecked ? (this.soForm?.controls["additionalFeeType"]?.value?.incomeAccount ?? 0) : 0,
            approvalStatusId: ApprovalStatus.Default,
            currencyUnitId: this.accountInfo?.currencyId ?? 0,
            exchangeRate: this.currencyExchangeRate ?? this.baseCurrency?.exchangeRate,
            isProductLevelDiscount: this.templates?.labels_table[6]?.isChecked ?? false,
        };
        return salesOrder;
    }

    prepareSalesOrderDataToUpdate(type?) {
        const products = this.prepareProductsListForAddEdit(type);
        const salesOrderObj = _.cloneDeep(this.soDetails);
        salesOrderObj.updatedSource = this.app.userIP;
        salesOrderObj.updatedBy = this.app.user.userId;
        salesOrderObj.updatedDate = this.app._saveDateTimeWithZone(new Date());
        salesOrderObj.salesObjectId = this.salesObjectId;
        salesOrderObj.businessName = this.accountInfo?.businessName;
        salesOrderObj.contactId = this.billingAddressContact ? this.billingAddressContact.id : 0;
        salesOrderObj.shipContactId = this.shippingAddressContact ? this.shippingAddressContact.id : 0;
        salesOrderObj.salesOrderDate = this.app._saveDateTimeWithZone(this.soForm?.controls["estimateDate"].value);
        salesOrderObj.reference = this.soForm?.controls["reference"].value;
        salesOrderObj.accountId = this.soForm?.controls["account"].value?.id;
        salesOrderObj.warehouseId = this.soForm?.controls["location"].value?.id;
        salesOrderObj.userId = this.soForm?.controls["salesRep"].value && this.soForm?.controls["salesRep"].value?.id ? this.soForm?.controls["salesRep"].value?.id : 0;
        salesOrderObj.shippingAddressId = this.selectedShippingAddress && this.selectedShippingAddress?.addressId ? this.selectedShippingAddress?.addressId : 0;
        salesOrderObj.billingAddressId = this.selectedAccountAddress && this.selectedAccountAddress?.addressId ? this.selectedAccountAddress?.addressId : 0;
        salesOrderObj.totalAmount = this.sumTotal;
        salesOrderObj.discountTypeId = this.footerDiscountEnabled && this.templates?.labels_footer[1]?.isChecked && this.soForm?.controls["discountType"].value ? (this.soForm?.controls["discountType"]?.value?.discountBy ?? 0) : 0;
        salesOrderObj.discountType = "";
        salesOrderObj.discountAmount = this.footerDiscountEnabled && this.templates?.labels_footer[1]?.isChecked ? this.discount : 0;
        salesOrderObj.discountFinancialId = this.footerDiscountEnabled && this.templates?.labels_footer[1]?.isChecked ? this.discountOptions?.filter((discount) => discount.id == this.soForm?.controls["discountType"]?.value?.id).map((value) => value.incomeAccount)[0] : 0;
        salesOrderObj.discountId = this.footerDiscountEnabled && this.templates?.labels_footer[1]?.isChecked ? this.discountOptions?.filter((discount) => discount.id == this.soForm?.controls["discountType"]?.value?.id).map((value) => value?.id)[0] : 0;
        salesOrderObj.discountRate = this.footerDiscountEnabled && this.templates?.labels_footer[1]?.isChecked ? (this.soForm?.controls["discountValue"]?.value ?? 0) : 0;
        salesOrderObj.discountName = "";
        salesOrderObj.taxId = this.footerTaxEnabled && this.templates?.labels_footer[2]?.isChecked ? this.allTaxRates?.[0]?.id || 0 : 0;
        salesOrderObj.tax = null;
        salesOrderObj.taxAmount = this.tax;
        salesOrderObj.taxName = "";
        salesOrderObj.taxRateTypeId = this.footerTaxEnabled && this.templates?.labels_footer[2]?.isChecked ? this.allTaxRates?.[0]?.typeId || 0 : 0;
        salesOrderObj.taxFinancialId = this.footerTaxEnabled && this.templates?.labels_footer[2]?.isChecked ? this.allTaxRates?.[0]?.financialAccountId || 0 : 0;
        salesOrderObj.shippingChargeAmount = this.soForm?.controls["shippingChargeAmount"].value ? this.soForm?.controls["shippingChargeAmount"].value : 0;
        salesOrderObj.netAmount = this.orderTotal;
        salesOrderObj.salesOrderStageId = this.soForm?.controls["salesOrderStage"].value?.id;
        salesOrderObj.paymentMethodId = this.soForm?.controls["paymentMethod"].value ? this.soForm?.controls["paymentMethod"].value?.id : 0;
        salesOrderObj.paymentTermId = this.soForm?.controls["paymentTerm"].value ? this.soForm?.controls["paymentTerm"].value?.id : 0;
        salesOrderObj.shippingMethodId = this.soForm?.controls?.shippingMethod?.value?.id ?? 0;
        salesOrderObj.shippingFinancialId = this.soForm?.controls?.shippingMethod?.value?.financialAccountId ?? 0;
        salesOrderObj.shippingTermId = this.soForm?.controls["shippingTerm"].value ? this.soForm?.controls["shippingTerm"].value?.id : 0;
        salesOrderObj.salesOrderStatusId = this.soForm?.controls["salesOrderStatus"].value?.id;
        salesOrderObj.salesOrderNote = this.prepareSalesOrderNote();
        salesOrderObj.salesOrderAudit = this.prepareSalesOrderAudit();
        salesOrderObj.salesOrderProducts = products;
        salesOrderObj.configJson = "";
        salesOrderObj.customAttributeValues = this.setExistingCustomAttributes(this.utilityService.getCustomAttributesForAddEdit(this.combinedCustomFields));
        salesOrderObj.statusId = this.soForm?.controls["statusId"].value ? Status.Active : Status.InActive;
        salesOrderObj.backOrderTypeId = this.selectedBackOrderOption;
        salesOrderObj.channelId = this.soForm?.controls?.accountChannel.value?.id;
        salesOrderObj.additionalDiscount = Number(this.additionalDiscountAmount);
        salesOrderObj.salesOrderAddDiscount = this.prepareAdditionalDiscountsForUpdateSalesOrder();
        (salesOrderObj.additionalFeesId = this.templates?.labels_footer[10]?.isChecked ? (this.soForm?.controls["additionalFeeType"]?.value?.id ?? 0) : 0), (salesOrderObj.additionalRate = this.templates?.labels_footer[10]?.isChecked ? (this.soForm?.controls["additionalFee"]?.value ?? 0) : 0), (salesOrderObj.additionalAmount = this.templates?.labels_footer[10]?.isChecked ? this.totalAdditionalFee : 0), (salesOrderObj.additionalFeesFinancialId = this.templates?.labels_footer[10]?.isChecked ? (this.soForm?.controls["additionalFeeType"]?.value?.incomeAccount ?? 0) : 0), (salesOrderObj.isConvertToInvoice = type && type == "convertToInvoice" ? true : salesOrderObj.isConvertToInvoice), (salesOrderObj.account = null);
        (salesOrderObj.currencyUnitId = this.accountInfo?.currencyId ?? 0), (salesOrderObj.exchangeRate = this.currencyExchangeRate ?? this.baseCurrency?.exchangeRate), (salesOrderObj.warehouse = null);
        salesOrderObj.isProductLevelDiscount = this.templates?.labels_table[6]?.isChecked ?? false;
        salesOrderObj.user = null;
        salesOrderObj.shippingAddress = null;
        salesOrderObj.discountType = null;
        salesOrderObj.paymentMethod = null;
        salesOrderObj.paymentTerm = null;
        salesOrderObj.shippingMethod = null;
        salesOrderObj.shippingTerm = null;
        salesOrderObj.contact = null;
        salesOrderObj.shipContact = null;
        return salesOrderObj;
    }

    prepareProductsSubtaxCode(taxes: any[], qty: number, price: number, product, bundleProduct?): ISalesOrderProductSubTax[] {
        let salesOrderProductSubTaxes: ISalesOrderProductSubTax[] = [];
        const subTotal = product.typeId == TypeIds.BundleTypeId ? bundleProduct.baseSubTotal : product.baseSubTotal;
        taxes?.forEach((rate) => {
            let taxAmount = product.typeId == TypeIds.BundleTypeId ? this.calculateProductsTax(rate.taxRate, subTotal, bundleProduct) : this.calculateProductsTax(rate.taxRate, subTotal, product);
            
            // split footer tax 
            if(this.footerTaxEnabled && !this.templates?.labels_table[5]?.isChecked) {
                const productContribution = product.typeId == TypeIds.BundleTypeId ? Number(bundleProduct.subTotal) / Number(this.productsTotal) : Number(product.subTotal) / Number(this.productsTotal);
                const productTaxShare = Number(this.tax) * productContribution;
                const totalTaxRate = taxes?.reduce((sum, item) => sum + item.taxRate, 0);
                taxAmount = (Number(rate.taxRate) / Number(totalTaxRate)) * Number(productTaxShare);
            }
            
            const tax = this.type == DialogType.CREATE ? this.allTaxRates.find((tax) => tax.id == rate.id) : rate.taxId ? this.allTaxRates.find((tax) => tax.id == rate.taxId) : this.allTaxRates.find((tax) => tax.id == rate.id); // new product added while editing invoice
            const salesOrderProductSubTax: ISalesOrderProductSubTax = {
                id: this.type == DialogType.CREATE || this.type == DialogType.CONVERT || this.type == DialogType.COPY ? 0 : product?.isDuplicatedProduct ? 0 : rate.taxId == rate.id ? 0 : rate.taxId ? rate.id : 0,
                createdSource: this.type == DialogType.EDIT ? rate.createdSource : this.app.userIP,
                updatedSource: this.app.userIP,
                createdBy: this.type == DialogType.EDIT ? rate.createdBy : this.app.user.userId,
                updatedBy: this.app.user.userId,
                createdDate: this.type == DialogType.EDIT ? rate.createdDate : this.app._saveDateTimeWithZone(new Date()),
                updatedDate: this.app._saveDateTimeWithZone(new Date()),
                taxId: this.type == DialogType.EDIT || this.type == DialogType.COPY ? rate.taxId ? rate.taxId : tax?.id || 0 : tax?.id || 0,
                taxRate: rate.taxRate,
                taxAmount: taxAmount,
                taxFinancialId: tax?.financialAccountId || 0,
                taxName: tax?.name || "",
                ...(product.typeId != TypeIds.BundleTypeId && { salesOrderProductId: this.type == DialogType.CREATE || this.type == DialogType.COPY ? product?.id || 0 : product.rowId ? product.rowId : product?.id || 0 }),
                ...(product.typeId == TypeIds.BundleTypeId && { salesOrderBundleDetailId: this.type == DialogType.CREATE || this.type == DialogType.COPY ? 0 : bundleProduct?.rowId || 0 }),
                statusId: Status.Active,
            };
            this.orderTotalTax += taxAmount;
            salesOrderProductSubTaxes.push(salesOrderProductSubTax);
        });
        return salesOrderProductSubTaxes;
    }

    prepareBackOrderProductsSubtaxCode(taxes: any[], qty: number, price: number, product, bundleProduct?): ISalesOrderProductSubTax[] {
        let salesOrderProductSubTaxes: ISalesOrderProductSubTax[] = [];
        const subTotal = product.typeId == TypeIds.BundleTypeId ? bundleProduct.baseSubTotal : product.baseSubTotal;
        taxes?.forEach((rate) => {
            let taxAmount = product.typeId == TypeIds.BundleTypeId ? this.calculateProductsTax(rate.taxRate, subTotal, bundleProduct) : this.calculateProductsTax(rate.taxRate, subTotal, product);
            const tax = this.type == DialogType.CREATE ? this.allTaxRates.find((tax) => tax.id == rate.id) : rate.taxId ? this.allTaxRates.find((tax) => tax.id == rate.taxId) : this.allTaxRates.find((tax) => tax.id == rate.id); // new product added while editing invoice
            const salesOrderProductSubTax: ISalesOrderProductSubTax = {
                id: 0,
                createdSource: this.app.userIP,
                updatedSource: this.app.userIP,
                createdBy: this.app.user.userId,
                updatedBy: this.app.user.userId,
                createdDate: this.app._saveDateTimeWithZone(new Date()),
                updatedDate: this.app._saveDateTimeWithZone(new Date()),
                taxId: this.type == DialogType.EDIT ? rate.taxId : tax?.id || 0,
                taxRate: rate.taxRate,
                taxAmount: taxAmount,
                taxFinancialId: tax?.financialAccountId || 0,
                taxName: tax?.name || "",
                ...(product.typeId != TypeIds.BundleTypeId && { salesOrderProductId: this.type == DialogType.EDIT ? product.rowId : 0 }),
                ...(product.typeId == TypeIds.BundleTypeId && { salesOrderBundleDetailId: this.type == DialogType.EDIT ? bundleProduct?.rowId : 0 }),
                statusId: Status.Active,
            };
            this.orderTotalTax += taxAmount;
            salesOrderProductSubTaxes.push(salesOrderProductSubTax);
        });
        return salesOrderProductSubTaxes;
    }

    prepareProductsListForAddEdit(type?): ISalesOrderProduct[] {
        const products: ISalesOrderProduct[] = [];
        for (let product of this.purchaseListTB) {
            const existingProduct = this.type == DialogType.EDIT ? this.soDetails.salesOrderProducts.filter((s) => s.productId == product.id)[0] : null;

            /** bundle items */
            const bundleItems = [];
            let total = 0;
            let totalOfBaseSubTotal = 0;
            let bundleProductsTaxId = 0;
            for (let bProduct of product?.bundleDetails) {
                bundleProductsTaxId = product.typeId == TypeIds.KitTypeId ? product?.productSubTax?.[0]?.taxId || 0 : bProduct?.bundleDetailSubTax?.[0]?.taxId || 0; // for kit, tax id should be parent products tax id & for bundle inner products tax id
                const soBundleProduct: ISalesOrderBundleProduct = {
                    id: this.type == DialogType.EDIT && bProduct.rowId ? bProduct.rowId : 0,
                    createdSource: this.app.userIP,
                    updatedSource: this.app.userIP,
                    createdBy: this.app.user.userId,
                    updatedBy: this.app.user.userId,
                    createdDate: this.app._saveDateTimeWithZone(new Date()),
                    updatedDate: this.app._saveDateTimeWithZone(new Date()),
                    description: bProduct.description,
                    salesOrderId: this.type == DialogType.EDIT ? this.soDetails.id : 0,
                    productId: product.id,
                    subproductId: bProduct.id,
                    parentProductId: 0,
                    parentBundleId: 0,
                    productUOMId: bProduct?.unit?.unitOfMeasureId || 0,
                    availableQuantity: bProduct.availabel ?? 0,
                    quantity: bProduct.ordQty,
                    pricePerProduct: bProduct.price,
                    totalAmount: bProduct.subTotal,
                    subTotal: bProduct.baseSubTotal,
                    discountTypeId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked && bProduct.discountType ? (bProduct.discountType.discountBy ?? 0) : (this.soForm?.controls["discountType"]?.value?.discountBy ?? 0),
                    discountType: "",
                    discountAmount: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? bProduct.discountAmount : this.utilityService.calculateDiscountPerProduct(bProduct.subTotal, this.sumTotal, this.discount),
                    discountFinancialId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? (bProduct.discountType?.incomeAccount ?? 0) : (this.soForm?.controls["discountType"]?.value?.incomeAccount ?? 0),
                    discountId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? (bProduct.discountType?.id ?? 0) : (this.soForm?.controls["discountType"]?.value?.id ?? 0),
                    discountRate: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? (bProduct.discount ?? 0) : 0,
                    discountName: "",
                    taxId: bundleProductsTaxId,
                    taxAmount: bProduct.taxAmount,
                    taxRate: bProduct.taxAmount,
                    taxName: "",
                    taxRateTypeId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && bProduct.taxType ? bProduct.taxType.typeId : 0,
                    taxFinancialId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && bProduct.taxType ? bProduct.taxType.financialAccountId : 0,
                    statusId: Status.Active,
                    salesorderSerialNumber: null,
                    salesorderproductId: this.type == DialogType.EDIT && product.rowId ? product.rowId : 0,
                    salesOrderBundleProductSerialDetail: this.type == DialogType.COPY ? null : bProduct.salesOrderBundleProductSerialDetail && bProduct.salesOrderBundleProductSerialDetail.length > 0 ? bProduct.salesOrderBundleProductSerialDetail : null,
                    binId: this.templates?.labels_table[11].isChecked ? (bProduct.selectedBin ? bProduct.selectedBin?.binId : 0) : 0,
                    pickedQty: bProduct.pickedQty,
                    packedQty: bProduct.packedQty,
                    shippedQty: this.isOrderToBeShipped ? bProduct.packedQty : bProduct.shippedQty,
                    totalQty: bProduct.totalQuantity,
                    salesOrderBundleDetailSubTax: this.footerTaxEnabled ? product.typeId == TypeIds.KitTypeId ? this.prepareProductsSubtaxCode(bProduct.bundleDetailSubTax, product.ordQty, product.price, product, bProduct) : this.prepareProductsSubtaxCode(bProduct.bundleDetailSubTax, bProduct.ordQty, bProduct.price, product, bProduct) : [],
                    isPicked: this.type == DialogType.EDIT && this.stageId == SoStageId.Pick,
                    isPacked: this.type == DialogType.EDIT && this.stageId == SoStageId.Pack,
                    backOrderQty: this.isOrderToBeShipped ? bProduct.backOrderQty : 0,
                    isCopied: bProduct.isDuplicatedProduct ?? false,
                    additionalFeesId: this.templates?.labels_table[15]?.isChecked ? (bProduct?.additionalFeeType?.id ?? 0) : 0,
                    additionalRate: this.templates?.labels_table[15]?.isChecked ? (bProduct?.additionalFee ?? 0) : 0,
                    additionalAmount: this.templates?.labels_table[15]?.isChecked ? (bProduct?.additionalFeeAmount ?? 0) : 0,
                    additionalFeesFinancialId: this.templates?.labels_table[15]?.isChecked ? (bProduct?.additionalFeeType?.incomeAccount ?? 0) : 0,
                    costPrice: bProduct.costPrice ?? 0,
                    totalCostPrice: bProduct.totalCostPrice ?? 0,
                };
                total += Number(bProduct.subTotal);
                totalOfBaseSubTotal += Number(bProduct.baseSubTotal);
                bundleItems.push(soBundleProduct);
                for (let kp of bProduct.bundleDetails) {
                    /** kit/bundle under kit */
                    const soKitProduct: ISalesOrderBundleProduct = {
                        id: this.type == DialogType.EDIT && kp.rowId ? kp.rowId : 0,
                        createdSource: this.app.userIP,
                        updatedSource: this.app.userIP,
                        createdBy: this.app.user.userId,
                        updatedBy: this.app.user.userId,
                        createdDate: this.app._saveDateTimeWithZone(new Date()),
                        updatedDate: this.app._saveDateTimeWithZone(new Date()),
                        description: kp.description,
                        salesOrderId: this.type == DialogType.EDIT ? this.soDetails.id : 0,
                        productId: product.id,
                        subproductId: kp.id,
                        parentProductId: bProduct.id,
                        parentBundleId: this.type == DialogType.CREATE ? 0 : kp.parentBundleId,
                        productUOMId: kp?.unit?.unitOfMeasureId || 0,
                        availableQuantity: kp.availabel ?? 0,
                        quantity: kp.ordQty,
                        pricePerProduct: kp.price,
                        totalAmount: kp.subTotal,
                        subTotal: kp.baseSubTotal,
                        discountTypeId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked && kp.discountType ? (kp.discountType.discountBy ?? 0) : (this.soForm?.controls["discountType"]?.value?.discountBy ?? 0),
                        discountType: "",
                        discountAmount: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? kp.discountAmount : this.utilityService.calculateDiscountPerProduct(kp.subTotal, this.sumTotal, this.discount),
                        discountFinancialId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? (kp.discountType?.incomeAccount ?? 0) : (this.soForm?.controls["discountType"]?.value?.incomeAccount ?? 0),
                        discountId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? (kp.discountType?.id ?? 0) : (this.soForm?.controls["discountType"]?.value?.id ?? 0),
                        discountRate: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? (kp.discount ?? 0) : 0,
                        discountName: "",
                        taxId: 0,
                        taxAmount: kp.taxAmount,
                        taxRate: kp.taxAmount,
                        taxName: "",
                        taxRateTypeId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && kp.taxType ? kp.taxType.typeId : 0,
                        taxFinancialId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && kp.taxType ? kp.taxType.financialAccountId : 0,
                        statusId: Status.Active,
                        salesorderSerialNumber: null,
                        salesorderproductId: this.type == DialogType.EDIT && product.rowId ? product.rowId : 0,
                        salesOrderBundleProductSerialDetail: kp.salesOrderBundleProductSerialDetail && kp.salesOrderBundleProductSerialDetail.length > 0 ? kp.salesOrderBundleProductSerialDetail : null,
                        binId: this.templates?.labels_table[11].isChecked ? (kp.selectedBin ? kp.selectedBin?.binId : 0) : 0,
                        pickedQty: kp.pickedQty,
                        packedQty: kp.packedQty,
                        shippedQty: this.isOrderToBeShipped ? kp.packedQty : kp.shippedQty,
                        totalQty: kp.totalQuantity,
                        salesOrderBundleDetailSubTax: this.footerTaxEnabled ? product.typeId == TypeIds.KitTypeId ? this.prepareProductsSubtaxCode(kp.bundleDetailSubTax, bProduct.ordQty, bProduct.price, bProduct, kp) : this.prepareProductsSubtaxCode(kp.bundleDetailSubTax, kp.ordQty, kp.price, bProduct, kp) : [],
                        isPicked: this.type == DialogType.EDIT && this.stageId == SoStageId.Pick,
                        isPacked: this.type == DialogType.EDIT && this.stageId == SoStageId.Pack,
                        backOrderQty: this.isOrderToBeShipped ? kp.backOrderQty : 0,
                        isCopied: kp.isDuplicatedProduct ?? false,
                        additionalFeesId: this.templates?.labels_table[15]?.isChecked ? (kp?.additionalFeeType?.id ?? 0) : 0,
                        additionalRate: this.templates?.labels_table[15]?.isChecked ? (kp?.additionalFee ?? 0) : 0,
                        additionalAmount: this.templates?.labels_table[15]?.isChecked ? (kp?.additionalFeeAmount ?? 0) : 0,
                        additionalFeesFinancialId: this.templates?.labels_table[15]?.isChecked ? (kp?.additionalFeeType?.incomeAccount ?? 0) : 0,
                        costPrice: kp.costPrice ?? 0,
                        totalCostPrice: kp.totalCostPrice ?? 0,
                    };
                    bundleItems.push(soKitProduct);
                }
            }

            /** product */
            let productTotalAmount = product.typeId == TypeIds.BundleTypeId ? total : product.subTotal;
            let productTotalAmountOfBaseSubTotal = product.typeId == TypeIds.BundleTypeId ? totalOfBaseSubTotal : product.baseSubTotal;
            const productObj: ISalesOrderProduct = {
                id: this.type == DialogType.EDIT ? product?.rowId || 0 : 0,
                createdSource: this.app.userIP,
                updatedSource: this.app.userIP,
                createdBy: this.app.user.userId,
                updatedBy: this.app.user.userId,
                createdDate: this.app._saveDateTimeWithZone(new Date()),
                updatedDate: this.app._saveDateTimeWithZone(new Date()),
                description: product.description,
                salesOrderId: this.type == DialogType.EDIT ? this.soDetails.id : 0,
                productId: product.id,
                productUOMId: product.unit && product.unit.unitOfMeasureId ? product.unit.unitOfMeasureId : 0,
                availableQuantity: product.availabel ?? 0,
                quantity: product.ordQty,
                pricePerProduct: product.price,
                totalAmount: productTotalAmount,
                subTotal: productTotalAmountOfBaseSubTotal,
                statusId: Status.Active,
                pickedQty: product.pickedQty,
                packedQty: product.packedQty,
                shippedQty: this.isOrderToBeShipped ? type && type == 'convertToInvoice' ? this.getSelectedProductQuantity(product) : product.packedQty : product.shippedQty,
                salesOrderSerialDetail: product.salesOrderSerialDetails && product.salesOrderSerialDetails.length > 0 ? product.salesOrderSerialDetails : null,
                salesOrderBundleDetail: bundleItems && bundleItems?.length > 0 ? bundleItems : [],

                discountTypeId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked && product.discountType ? (product.discountType.discountBy ?? 0) : (this.soForm?.controls["discountType"]?.value?.discountBy ?? 0),
                discountType: "",
                discountAmount: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? product.discountAmount : this.utilityService.calculateDiscountPerProduct(productTotalAmount, this.sumTotal, this.discount),
                discountFinancialId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked && product.discountType?.id ? (product.discountType?.incomeAccount ?? 0) : (this.soForm?.controls["discountType"]?.value?.incomeAccount ?? 0),
                discountId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked && product.discountType?.id ? this.discountOptions?.filter((discount) => discount.id == product.discountType?.id).map((value) => value?.id)[0] : this.discountOptions?.filter((discount) => discount.id == this.soForm?.controls["discountType"]?.value?.id).map((value) => value?.id)[0],
                discountRate: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? (product.discount ?? 0) : 0,
                discountName: "",

                taxId: product?.typeId == TypeIds.BundleTypeId ? bundleProductsTaxId : product?.productSubTax?.[0]?.taxId || 0,
                taxAmount: product.taxAmount,
                taxRate: product.taxAmount,
                taxName: "",
                taxRateTypeId: product.tax && product.tax.length ? product.tax[0].typeId : 0,
                taxFinancialId: product.tax && product.tax.length ? product.tax[0].financialAccountId : 0,
                totalQty: product.totalQuantity,
                binId: this.templates?.labels_table[11].isChecked ? (product.selectedBin ? product.selectedBin?.binId : 0) : 0,
                // salesOrderProductSubTax: product.typeId != TypeIds.BundleTypeId && product.typeId != TypeIds.KitTypeId ? this.prepareProductsSubtaxCode(product.productSubTax, product.ordQty, product.price, product) : [],
                salesOrderProductSubTax: this.footerTaxEnabled ? product.typeId != TypeIds.BundleTypeId ? this.prepareProductsSubtaxCode(product.productSubTax, product.ordQty, product.price, product) : [] : [],
                isPicked: this.type == DialogType.EDIT && this.stageId == SoStageId.Pick,
                isPacked: this.type == DialogType.EDIT && this.stageId == SoStageId.Pack,
                backOrderQty: this.isOrderToBeShipped ? product.backOrderQty : 0,
                isCopied: product?.isDuplicatedProduct ?? false,
                additionalFeesId: this.templates?.labels_table[15]?.isChecked ? (product?.additionalFeeType?.id ?? 0) : 0,
                additionalRate: this.templates?.labels_table[15]?.isChecked ? (product?.additionalFee ?? 0) : 0,
                additionalAmount: this.templates?.labels_table[15]?.isChecked ? (product?.additionalFeeAmount ?? 0) : 0,
                additionalFeesFinancialId: this.templates?.labels_table[15]?.isChecked ? (product?.additionalFeeType?.incomeAccount ?? 0) : 0,
                costPrice: product.costPrice ?? 0,
                totalCostPrice: product.totalCostPrice ?? 0,
            };
            products.push(productObj);
        }
        return products;
    }

    prepareAdditionalDiscountsForNewSalesOrder(adddiscount?): ISalesOrderAddDiscount[] {
        if (this.soForm?.controls?.additionalDiscountTypeName?.value?.id && this.soForm?.controls?.additionalDiscountRate?.value > 0) {
            const additionalDiscount: ISalesOrderAddDiscount = {
                id: 0,
                createdSource: this.app.userIP,
                updatedSource: this.app.userIP,
                createdBy: this.app.user.userId,
                updatedBy: this.app.user.userId,
                createdDate: this.app._saveDateTimeWithZone(new Date()),
                updatedDate: this.app._saveDateTimeWithZone(new Date()),
                salesOrderId: 0,
                discountId: this.soForm?.controls?.additionalDiscountTypeName?.value?.id ?? 0,
                discountTypeId: this.soForm?.controls?.additionalDiscountTypeName?.value?.type?.id ?? 0,
                discountRate: this.soForm?.controls?.additionalDiscountRate?.value ?? 0,
                discountAmount: adddiscount && adddiscount > 0 ? Number(adddiscount) : Number(this.additionalDiscountAmount),
                statusId: Status.Active,
            };
            return [additionalDiscount];
        }
        return [];
    }
    prepareAdditionalDiscountsForUpdateSalesOrder(): ISalesOrderAddDiscount[] {
        if (this.soForm?.controls?.additionalDiscountTypeName?.value?.id && this.soForm?.controls?.additionalDiscountRate?.value > 0) {
            let addDiscount = this.soDetails?.salesOrderAddDiscount && this.soDetails.salesOrderAddDiscount.length > 0 ? this.soDetails.salesOrderAddDiscount[0] : null;
            const additionalDiscount: ISalesOrderAddDiscount = {
                id: addDiscount ? addDiscount.id : 0,
                createdSource: addDiscount ? addDiscount.createdSource : this.app.userIP,
                updatedSource: this.app.userIP,
                createdBy: addDiscount ? addDiscount.createdBy : this.app.user.userId,
                updatedBy: this.app.user.userId,
                createdDate: addDiscount ? addDiscount.createdDate : this.app._saveDateTimeWithZone(new Date()),
                updatedDate: this.app._saveDateTimeWithZone(new Date()),
                salesOrderId: addDiscount ? addDiscount.salesOrderId : 0,
                discountId: this.soForm?.controls?.additionalDiscountTypeName?.value?.id ?? 0,
                discountTypeId: this.soForm?.controls?.additionalDiscountTypeName?.value?.type?.id ?? 0,
                discountRate: this.soForm?.controls?.additionalDiscountRate?.value ?? 0,
                discountAmount: Number(this.additionalDiscountAmount),
                statusId: Status.Active,
            };
            return [additionalDiscount];
        }
        return [];
    }
    prepareSalesOrderNote() {
        let salesOrderNote = null;
        if (this.soForm?.controls["memo"]?.value && this.soForm?.controls["memo"]?.value != "") {
            salesOrderNote = [
                {
                    id: 0,
                    createdSource: this.app.userIP,
                    updatedSource: this.app.userIP,
                    createdBy: this.app.user.userId,
                    updatedBy: this.app.user.userId,
                    createdDate: this.app._saveDateTimeWithZone(new Date()),
                    updatedDate: this.app._saveDateTimeWithZone(new Date()),
                    salesOrderId: 0,
                    salesOrder: null,
                    noteId: 0,
                    note: {
                        id: 0,
                        createdSource: this.app.userIP,
                        updatedSource: this.app.userIP,
                        createdBy: this.app.user.userId,
                        updatedBy: this.app.user.userId,
                        createdDate: this.app._saveDateTimeWithZone(new Date()),
                        updatedDate: this.app._saveDateTimeWithZone(new Date()),
                        comment: this.soForm?.controls["memo"].value,
                        isImportant: true,
                        organizationId: this.app.companyId,
                        description: "",
                        statusId: Status.Active,
                        isValid: true,
                        validFromDate: new Date().toISOString(),
                        validToDate: new Date().toISOString(),
                        noteComments: null,
                        noteAttachments: null,
                        createdByName: "",
                    },
                },
            ];
        }
        return salesOrderNote;
    }

    prepareSalesOrderAudit() {
        let salesOrderAudit = null;
        let note = null;
        if (this.soForm?.controls["vendorMessage"]?.value && this.soForm?.controls["vendorMessage"]?.value != "") {
            note = {
                id: 0,
                createdSource: this.app.userIP,
                updatedSource: this.app.userIP,
                createdBy: this.app.user.userId,
                updatedBy: this.app.user.userId,
                createdDate: this.app._saveDateTimeWithZone(new Date()),
                updatedDate: this.app._saveDateTimeWithZone(new Date()),
                comment: this.soForm?.controls["vendorMessage"]?.value,
                isImportant: true,
                organizationId: this.app.companyId,
                description: "",
                statusId: Status.Active,
                isValid: true,
                validFromDate: new Date().toISOString(),
                validToDate: new Date().toISOString(),
                noteComments: null,
                noteAttachments: null,
                createdByName: "",
            };
        }
        salesOrderAudit = [
            {
                id: 0,
                createdSource: this.app.userIP,
                updatedSource: this.app.userIP,
                createdBy: this.app.user.userId,
                updatedBy: this.app.user.userId,
                createdDate: this.app._saveDateTimeWithZone(new Date()),
                updatedDate: this.app._saveDateTimeWithZone(new Date()),
                salesOrderId: 0,
                salesOrder: null,
                userId: this.app.user.userId,
                user: null,
                noteId: 0,
                note: note,
                salesOrderStageId: this.soForm?.controls["salesOrderStage"]?.value?.id ?? 0,
                salesOrderStage: "",
                salesOrderStatusId: this.soForm?.controls["salesOrderStatus"]?.value?.id ?? 0,
                salesOrderStatus: "",
            },
        ];
        return salesOrderAudit;
    }

    setExistingCustomAttributes(value) {
        const custom = [];
        if (value.length > 0) {
            value.forEach((element) => {
                const customEach = {
                    id: this.soDetails.customAttributeValues.filter((custom) => custom.customAttributeId == element.id)[0] ? this.soDetails.customAttributeValues.filter((custom) => custom.customAttributeId == element.id)[0]?.id : 0,
                    createdSource: this.app.userIP,
                    updatedSource: this.app.userIP,
                    createdBy: this.app.userId,
                    updatedBy: this.app.userId,
                    createdDate: this.app._saveDateTimeWithZone(new Date()),
                    updatedDate: this.app._saveDateTimeWithZone(new Date()),
                    objectId: this.app.preLoadedObjects.find((obj) => obj.name == "Orders").id,
                    objectValue: this.soDetails.id,
                    customAttributeId: element.id,
                    customAttribute: this.modifyCustumAttributes(element),
                    value: element.formControl?.name == "InputBox" || element.formControl?.name == "DatePicker" || element.formControl?.name == "Decimal" || element.formControl?.name == "Number" ? element.value : null,
                    statusId: Status.Active,
                    values: element.formControl?.name == "DropDownList" ? element.value : element.formControl?.name == "RadioButton" ? { name: element.value } : null,
                    multipleValues: element.formControl?.name == "MultipleDropDownList" ? element.value : element.formControl?.name == "CheckBox" ? this.setCheckBoxValue(element.value) : null,
                    ratingId: element.formControl?.name == "Rating" ? element.value : 0,
                    toggle: element.formControl?.name == "ToggleButton" ? element.value : false,
                    customeAttachement: element.formControl?.name == "FileUpload" || element.formControl?.name == "Picture" ? element.customUploadedFiles : null,
                };
                custom.push(customEach);
            });
        }
        return custom;
    }
    setCustomAttributes(value) {
        const custom = [];
        if (value.length > 0) {
            value.forEach((element) => {
                const customEach = {
                    id: 0,
                    createdSource: this.app.userIP,
                    updatedSource: this.app.userIP,
                    createdBy: this.app.userId,
                    updatedBy: this.app.userId,
                    createdDate: this.app._saveDateTimeWithZone(new Date()),
                    updatedDate: this.app._saveDateTimeWithZone(new Date()),
                    objectId: this.app.preLoadedObjects.find((obj) => obj.name == "Orders").id,
                    objectValue: 0,
                    customAttributeId: element.id,
                    customAttribute: this.modifyCustumAttributes(element),
                    value: element.formControl?.name == "InputBox" || element.formControl?.name == "DatePicker" || element.formControl?.name == "Decimal" || element.formControl?.name == "Number" ? element.value : null,
                    statusId: Status.Active,
                    values: element.formControl?.name == "DropDownList" ? element.value : element.formControl?.name == "RadioButton" ? { name: element.value } : null,
                    multipleValues: element.formControl?.name == "MultipleDropDownList" ? element.value : element.formControl?.name == "CheckBox" ? this.setCheckBoxValue(element.value) : null,
                    ratingId: element.formControl?.name == "Rating" ? element.value : 0,
                    toggle: element.formControl?.name == "ToggleButton" ? element.value : false,
                    customeAttachement: element.formControl?.name == "FileUpload" || element.formControl?.name == "Picture" ? element.customUploadedFiles : null,
                };
                custom.push(customEach);
            });
        }
        return custom;
    }
    modifyCustumAttributes(data) {
        if (data.pickListValues) {
            data.pickListValues = JSON.stringify(data.pickListValues);
        }
        return data;
    }

    /** End Save and update Sales Order */

    /** Sales Order To Invoice and backorder */

    prepareInvoiceProductsSubtaxCode(taxes: any[], qty: number, price: number, product, bundleProduct?) {
        let invoiceProductSubTaxes: IInvoiceProductSubTax[] = [];
        const subTotal = product.typeId == TypeIds.BundleTypeId ? bundleProduct.baseSubTotal : product.baseSubTotal;
        taxes?.forEach((rate) => {
            let taxAmount = product.typeId == TypeIds.BundleTypeId ? this.calculateProductsTax(rate.taxRate, subTotal, bundleProduct) : this.calculateProductsTax(rate.taxRate, subTotal, product);
            
            // split footer tax 
            if(this.footerTaxEnabled && !this.templates?.labels_table[5]?.isChecked) {
                const productContribution = product.typeId == TypeIds.BundleTypeId ? Number(bundleProduct.subTotal) / Number(this.productsTotal) : Number(product.subTotal) / Number(this.productsTotal);
                const productTaxShare = Number(this.tax) * productContribution;
                const totalTaxRate = taxes?.reduce((sum, item) => sum + item.taxRate, 0);
                taxAmount = (Number(rate.taxRate) / Number(totalTaxRate)) * Number(productTaxShare);
            }
            
            const tax = this.allTaxRates.find((tax) => tax.id == rate.taxId);
            const invoiceProductSubTax: IInvoiceProductSubTax = {
                id: 0,
                createdSource: this.type == DialogType.CREATE ? this.app.userIP : rate.createdSource,
                updatedSource: this.app.userIP,
                createdBy: this.type == DialogType.CREATE ? this.app.user.userId : rate.createdBy,
                updatedBy: this.app.user.userId,
                createdDate: this.type == DialogType.CREATE ? this.app._saveDateTimeWithZone(new Date()) : rate.createdDate,
                updatedDate: this.app._saveDateTimeWithZone(new Date()),
                taxId: tax?.id || 0,
                taxRate: tax?.taxRate || 0,
                taxAmount: taxAmount,
                taxFinancialId: tax?.financialAccountId || 0,
                taxName: tax?.name || "",
                ...(product.typeId != TypeIds.BundleTypeId && { invoiceProductId: product?.id || 0 }),
                ...(product.typeId == TypeIds.BundleTypeId && { invoiceBundleDetailId: bundleProduct?.id || 0 }),
                statusId: Status.Active,
            };
            this.orderTotalTax += taxAmount;
            invoiceProductSubTaxes.push(invoiceProductSubTax);
        });
        return invoiceProductSubTaxes;
    }

    getBackOrderedSOUpdateObj(soProducts) {
        const soObj = _.cloneDeep(this.soDetails);
        let discount = 0;
        let bundleTotal = 0;
        let productTotal = 0;
        let productTaxTotal = 0;
        let bundleProductTaxTotal = 0;

        if (soObj?.discountAmount) {
            if (soObj?.discountType?.name == "$" || soObj?.discountType?.name == "Amount") {
                discount = soObj?.discountAmount;
            } else if (soObj?.discountType?.name == "%" || soObj?.discountType?.name == "Percentage") {
                let num = soObj?.discountAmount ? (Number(soObj.discountAmount) * 100) / Number(soObj.totalAmount) : 0;
                discount = num ? Math.round(num * 100) / 100 : 0;
            }
        }
        if (soProducts?.length) {
            for (let l of soProducts) {
                const bundleDetail = [];
                if (l?.salesOrderBundleDetail && l?.salesOrderBundleDetail?.length && l.typeId == TypeIds.BundleTypeId) {
                    l?.salesOrderBundleDetail?.forEach((b) => {
                        bundleDetail.push(b);
                        bundleTotal += Number(b.totalAmount);
                        bundleProductTaxTotal += Number(b.taxAmount);
                    });
                }
                l.bundleDetails = bundleDetail;
                l.totalAmount = l.typeId == TypeIds.BundleTypeId && l.salesOrderBundleDetail?.length ? bundleTotal : Number(l.totalAmount);
                l.discount = this.getPackQtyDiscountAmount(l);
                l.discountAmount = l.discount;
                l.taxAmount = l.typeId == TypeIds.BundleTypeId && l.salesOrderBundleDetail?.length ? bundleProductTaxTotal : l.taxAmount;
                productTotal += Number(l.totalAmount);
                productTaxTotal += Number(l.taxAmount);
            }
            const isVisibleRowTax = this.templates["labels_table"] && this.templates["labels_table"].length >= 5 ? this.templates["labels_table"][5]?.isChecked : false;
            const isVisibleRowDiscount = this.templates["labels_table"] && this.templates["labels_table"].length >= 6 ? this.templates["labels_table"][6]?.isChecked : false;
            const disName = this.soForm?.controls["discountType"].value ? this.soForm?.controls["discountType"]?.value?.name : "";
            const disValue = this.soForm?.controls["discountValue"]?.value ? this.soForm?.controls["discountValue"]?.value : 0;
            let dis = this.utilityService.calculateOrderTotalDiscount(disName, disValue, productTotal, soProducts, this.isVisibleRowDiscount, this.footerDiscountEnabled, this.isVisibleFooterDiscount);
            let tax = this.utilityService.calculateOrderTotalTax(soProducts, productTotal, this.isVisibleRowTax, this.footerTaxEnabled, this.isVisibleFooterTax, this.allTaxRates);
            let orderTotal = 0;
            orderTotal = productTotal + Number(soObj?.shippingChargeAmount);
            if (!isVisibleRowTax) {
                orderTotal += tax;
            }
            if (!isVisibleRowDiscount) {
                orderTotal -= dis;
            }
            soObj.salesOrderProducts = soProducts;
            soObj.totalAmount = productTotal;
            soObj.discountAmount = dis;
            soObj.taxAmount = isNaN(tax) ? 0 : tax;
            soObj.netAmount = orderTotal;
            soObj.salesOrderNote = null;
            soObj.salesOrderAudit = null;
            soObj.account = null;
            soObj.warehouse = null;
            soObj.user = null;
            soObj.shippingAddress = null;
            soObj.discountType = null;
            soObj.paymentMethod = null;
            soObj.paymentTerm = null;
            soObj.shippingMethod = null;
            soObj.shippingTerm = null;
            soObj.contact = null;
            soObj.shipContact = null;
        }
        return soObj;
    }
    prepareInvoiceProductsSerialDetails(product): IInvoiceSerialDetail[] {
        const invoiceSerialDetailsArr: IInvoiceSerialDetail[] = product?.salesOrderSerialDetails?.map((nl) => ({
            id: 0,
            createdSource: this.app.userIP,
            updatedSource: this.app.userIP,
            createdBy: this.app.userId,
            updatedBy: this.app.userId,
            createdDate: this.app._saveDateTimeWithZone(new Date()),
            updatedDate: this.app._saveDateTimeWithZone(new Date()),
            invoiceId: 0,
            invoiceProductId: 0,
            barcode: nl.barcode,
            lotNumber: nl.lotNumber,
            revisionNumber: nl.revisionNumber,
            expirationDate: nl.expirationDate,
            statusId: Status.Active,
            shipped: true,
        }));
        return invoiceSerialDetailsArr;
    }
    prepareInvoiceBundleProductsSerialDetails(product): IInvoiceSerialDetail[] {
        const invoiceSerialDetailsArr: IInvoiceSerialDetail[] = product?.salesOrderBundleProductSerialDetail?.map((nl) => ({
            id: 0,
            createdSource: this.app.userIP,
            updatedSource: this.app.userIP,
            createdBy: this.app.userId,
            updatedBy: this.app.userId,
            createdDate: this.app._saveDateTimeWithZone(new Date()),
            updatedDate: this.app._saveDateTimeWithZone(new Date()),
            invoiceId: 0,
            invoiceProductId: 0,
            barcode: nl.barcode,
            lotNumber: nl.lotNumber,
            revisionNumber: nl.revisionNumber,
            expirationDate: nl.expirationDate,
            statusId: Status.Active,
            shipped: true,
        }));
        return invoiceSerialDetailsArr;
    }

    prepareAdditionalDiscountsForNewInvoice(discount): IInvoiceAddDiscount[] {
        if (this.soForm?.controls?.additionalDiscountTypeName?.value?.id && this.soForm?.controls?.additionalDiscountRate?.value > 0) {
            const additionalDiscount: IInvoiceAddDiscount = {
                id: 0,
                createdSource: this.app.userIP,
                updatedSource: this.app.userIP,
                createdBy: this.app.user.userId,
                updatedBy: this.app.user.userId,
                createdDate: this.app._saveDateTimeWithZone(new Date()),
                updatedDate: this.app._saveDateTimeWithZone(new Date()),
                invoiceId: 0,
                discountId: this.soForm?.controls?.additionalDiscountTypeName?.value?.id ?? 0,
                discountTypeId: this.soForm?.controls?.additionalDiscountTypeName?.value?.type?.id ?? 0,
                discountRate: this.soForm?.controls?.additionalDiscountRate?.value ?? 0,
                discountAmount: Number(discount),
                statusId: Status.Active,
            };
            return [additionalDiscount];
        }
        return [];
    }
    createInvoice() {
        const isValid = this.utilityService.checkvalidation(this.combinedCustomFields);
        const customattributeList = this.utilityService.getCustomAttributesForAddEdit(this.combinedCustomFields);
        if (isValid && this.selectedShippingAddress) {
            this.isDisabledSaveBtn = true;
            const products: IInvoiceProduct[] = [];
            let subTotal = 0;
            let totalAdditionalAmount = 0;
            this.selectedPL?.forEach((p) => {
                const product = this.purchaseListTB.filter((s) => s.rowId == p.rowId)[0];
                const invoiceSerialDetailsArr: IInvoiceSerialDetail[] = this.prepareInvoiceProductsSerialDetails(product);
                /** Bundle Products */
                const bundleItems: IInvoiceBundleProduct[] = [];
                for (let e of product?.bundleDetails) {
                    const bundleObj: IInvoiceBundleProduct = {
                        id: 0,
                        createdSource: this.app.userIP,
                        updatedSource: this.app.userIP,
                        createdBy: this.app.user.userId,
                        updatedBy: this.app.user.userId,
                        createdDate: this.app._saveDateTimeWithZone(new Date()),
                        updatedDate: this.app._saveDateTimeWithZone(new Date()),
                        description: e.description,
                        invoiceId: 0,
                        productId: product.id,
                        subproductId: e.id,
                        parentProductId: 0,
                        parentBundleId: 0,
                        productUOMId: e.unit && e.unit.unitOfMeasureId ? e.unit.unitOfMeasureId : 0,
                        availableQuantity: e.availabel ?? 0,
                        quantity: e.packedQty ?? 0,
                        shippedQty: e.packedQty ?? 0,
                        pricePerProduct: e["price"],
                        totalAmount: e.subTotal,
                        subTotal: e.baseSubTotal,
                        discountTypeId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked && e.discountType ? (e.discountType.discountBy ?? 0) : 0,
                        discountType: "",
                        discountAmount: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? e.discountAmount : this.utilityService.calculateDiscountPerProduct(e.subTotal, this.sumTotal, this.discount),
                        discountFinancialId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? this.discountOptions?.filter((discount) => discount.id == e.discountType?.id).map((value) => value.incomeAccount)[0] : this.discountOptions?.filter((discount) => discount.id == this.soForm?.controls["discountType"]?.value?.id).map((value) => value.incomeAccount)[0],
                        discountId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? this.discountOptions?.filter((discount) => discount.id == e.discountType?.id).map((value) => value?.id)[0] : this.discountOptions?.filter((discount) => discount.id == this.soForm?.controls["discountType"]?.value?.id).map((value) => value?.id)[0],
                        discountRate: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? (e.discount ?? 0) : 0,
                        discountName: "",
                        taxId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && e.taxType ? e.taxType.id : 0,
                        taxAmount: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked ? e.taxAmount : 0,
                        taxRate: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked ? e.taxAmount : 0,
                        taxName: "",
                        taxRateTypeId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && e.taxType ? e.taxType.typeId : 0,
                        taxFinancialId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && e.taxType ? e.taxType.financialAccountId : 0,
                        statusId: Status.Active,
                        invoiceproductId: 0,
                        invoiceBundleProductSerialDetail: this.prepareInvoiceBundleProductsSerialDetails(e),
                        binId: this.templates?.labels_table[11].isChecked ? (e.selectedBin ? e.selectedBin?.binId : 0) : 0,
                        totalQty: e.totalQuantity,
                        itemNo: e?.itemNo ?? "",
                        invoiceBundleDetailSubTax: product.typeId == TypeIds.KitTypeId ? this.prepareInvoiceProductsSubtaxCode(product.productSubTax, product.ordQty, product.price, product) : this.prepareInvoiceProductsSubtaxCode(e.bundleDetailSubTax, e.ordQty, e.price, product, e),
                        isCopied: e?.isDuplicatedProduct ?? false,
                        returnedQty: 0,
                        additionalFeesId: this.templates?.labels_table[15]?.isChecked ? (e?.additionalFeeType?.id ?? 0) : 0,
                        additionalRate: this.templates?.labels_table[15]?.isChecked ? (e?.additionalFee ?? 0) : 0,
                        additionalAmount: this.templates?.labels_table[15]?.isChecked ? (e?.additionalFeeAmount ?? 0) : 0,
                        additionalFeesFinancialId: this.templates?.labels_table[15]?.isChecked ? (e?.additionalFeeType?.incomeAccount ?? 0) : 0,
                        costPrice: e.costPrice ?? 0,
                        totalCostPrice: e.totalCostPrice ?? 0,
                    };
                    bundleItems.push(bundleObj);
                    /** Kit under kit Products */
                    for (let kp of e.bundleDetails) {
                        const kitObj: IInvoiceBundleProduct = {
                            id: 0,
                            createdSource: this.app.userIP,
                            updatedSource: this.app.userIP,
                            createdBy: this.app.user.userId,
                            updatedBy: this.app.user.userId,
                            createdDate: this.app._saveDateTimeWithZone(new Date()),
                            updatedDate: this.app._saveDateTimeWithZone(new Date()),
                            description: e.description,
                            invoiceId: 0,
                            productId: product.id,
                            subproductId: kp.id,
                            parentProductId: e.id,
                            parentBundleId: 0,
                            productUOMId: kp.unit && kp.unit.unitOfMeasureId ? kp.unit.unitOfMeasureId : 0,
                            availableQuantity: kp.avalabel ?? 0,
                            quantity: kp.packedQty ?? 0,
                            shippedQty: kp.packedQty ?? 0,
                            pricePerProduct: kp["price"],
                            totalAmount: kp.subTotal,
                            subTotal: kp.baseSubTotal,
                            discountTypeId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked && kp.discountType ? (kp.discountType.discountBy ?? 0) : 0,
                            discountType: "",
                            discountAmount: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? kp.discountAmount : this.utilityService.calculateDiscountPerProduct(kp.subTotal, this.sumTotal, this.discount),
                            discountFinancialId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? this.discountOptions?.filter((discount) => discount.id == kp.discountType?.id).map((value) => value.incomeAccount)[0] : this.discountOptions?.filter((discount) => discount.id == this.soForm?.controls["discountType"]?.value?.id).map((value) => value.incomeAccount)[0],
                            discountId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? this.discountOptions?.filter((discount) => discount.id == kp.discountType?.id).map((value) => value?.id)[0] : this.discountOptions?.filter((discount) => discount.id == this.soForm?.controls["discountType"]?.value?.id).map((value) => value?.id)[0],
                            discountRate: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? (kp.discount ?? 0) : 0,
                            discountName: "",
                            taxId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && kp.taxType ? kp.taxType.id : 0,
                            taxAmount: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked ? kp.taxAmount : 0,
                            taxRate: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked ? kp.taxAmount : 0,
                            taxName: "",
                            taxRateTypeId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && kp.taxType ? kp.taxType.typeId : 0,
                            taxFinancialId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && kp.taxType ? kp.taxType.financialAccountId : 0,
                            statusId: Status.Active,
                            invoiceproductId: 0,
                            invoiceBundleProductSerialDetail: this.prepareInvoiceBundleProductsSerialDetails(kp),
                            binId: this.templates?.labels_table[11].isChecked ? (kp.selectedBin ? kp.selectedBin?.binId : 0) : 0,
                            totalQty: kp.totalQuantity,
                            itemNo: kp?.itemNo ?? "",
                            invoiceBundleDetailSubTax: product.typeId == TypeIds.KitTypeId ? this.prepareInvoiceProductsSubtaxCode(product.productSubTax, product.ordQty, product.price, product) : this.prepareInvoiceProductsSubtaxCode(e.bundleDetailSubTax, e.ordQty, e.price, product, e),
                            isCopied: kp?.isDuplicatedProduct ?? false,
                            returnedQty: 0,
                            additionalFeesId: this.templates?.labels_table[15]?.isChecked ? (kp?.additionalFeeType?.id ?? 0) : 0,
                            additionalRate: this.templates?.labels_table[15]?.isChecked ? (kp?.additionalFee ?? 0) : 0,
                            additionalAmount: this.templates?.labels_table[15]?.isChecked ? (kp?.additionalFeeAmount ?? 0) : 0,
                            additionalFeesFinancialId: this.templates?.labels_table[15]?.isChecked ? (kp?.additionalFeeType?.incomeAccount ?? 0) : 0,
                            costPrice: kp.costPrice ?? 0,
                            totalCostPrice: kp.totalCostPrice ?? 0,
                        };
                        bundleItems.push(kitObj);
                    }
                }
                const total = bundleItems.reduce((acc, item) => acc + Number(item.totalAmount), 0);
                const totalOfBaseSubTotal = bundleItems.reduce((acc, item) => acc + Number(item.subTotal), 0);
                const totalAdditionalAmountOfBundleItems = bundleItems.reduce((acc, item) => acc + Number(item.additionalAmount), 0);
                let productTotalAmount = product.typeId == TypeIds.BundleTypeId ? total : product.subTotal;
                let productTotalAmountOfBaseSubTotal = product.typeId == TypeIds.BundleTypeId ? totalOfBaseSubTotal : product.baseSubTotal;
                const invProduct: IInvoiceProduct = {
                    id: 0,
                    createdSource: this.app.userIP,
                    updatedSource: this.app.userIP,
                    createdBy: this.app.user.userId,
                    updatedBy: this.app.user.userId,
                    createdDate: this.app._saveDateTimeWithZone(new Date()),
                    updatedDate: this.app._saveDateTimeWithZone(new Date()),
                    description: product.description,
                    invoiceId: 0,
                    productId: product.id,
                    productUOMId: product.unit && product.unit.unitOfMeasureId ? product.unit.unitOfMeasureId : 0,
                    availableQuantity: product.availabel ?? 0,
                    quantity: product.packedQty ?? 0,
                    shippedQty: product.packedQty ?? 0,
                    pricePerProduct: product["price"],
                    totalAmount: productTotalAmount,
                    subTotal: productTotalAmountOfBaseSubTotal,
                    statusId: Status.Active,
                    invoiceProductSerialDetail: invoiceSerialDetailsArr && invoiceSerialDetailsArr.length > 0 ? invoiceSerialDetailsArr : null,
                    binId: this.templates?.labels_table[11].isChecked ? (product.selectedBin ? product.selectedBin?.binId : 0) : 0,
                    invoiceBundleDetail: bundleItems && bundleItems.length > 0 ? bundleItems : [],
                    discountTypeId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked && product.discountType ? (product.discountType.discountBy ?? 0) : 0,
                    discountType: "",
                    discountAmount: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? product.discountAmount : this.utilityService.calculateDiscountPerProduct(productTotalAmount, this.sumTotal, this.discount),
                    discountFinancialId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked && product.discountType?.id ? this.discountOptions?.filter((discount) => discount.id == product.discountType?.id).map((value) => value.incomeAccount)[0] : this.discountOptions?.filter((discount) => discount.id == this.soForm?.controls["discountType"]?.value?.id).map((value) => value.incomeAccount)[0],
                    discountId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked && product.discountType?.id ? this.discountOptions?.filter((discount) => discount.id == product.discountType?.id).map((value) => value?.id)[0] : this.discountOptions?.filter((discount) => discount.id == this.soForm?.controls["discountType"]?.value?.id).map((value) => value?.id)[0],
                    discountRate: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? (product.discount ?? 0) : 0,
                    discountName: "",
                    taxId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && product.taxType ? product.taxType.id : 0,
                    taxAmount: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked ? product.taxAmount : 0,
                    taxRate: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked ? product.taxAmount : 0,
                    taxName: "",
                    taxRateTypeId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && product.taxType ? product.taxType.typeId : 0,
                    taxFinancialId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && product.taxType ? product.taxType.financialAccountId : 0,
                    totalQty: product.totalQuantity,
                    itemNo: product?.itemNo ?? "",
                    invoiceProductSubTax: this.footerTaxEnabled ? (product.typeId != TypeIds.BundleTypeId ? this.prepareInvoiceProductsSubtaxCode(product.productSubTax, product.ordQty, product.price, product) : []) : [],
                    typeId: product.typeId,
                    isCopied: product?.isDuplicatedProduct ?? false,
                    returnedQty: 0,
                    additionalFeesId: this.templates?.labels_table[15]?.isChecked ? (product?.additionalFeeType?.id ?? 0) : 0,
                    additionalRate: this.templates?.labels_table[15]?.isChecked ? (product?.additionalFee ?? 0) : 0,
                    additionalAmount: this.templates?.labels_table[15]?.isChecked ? (product.typeId == TypeIds.BundleTypeId ? totalAdditionalAmountOfBundleItems : (product?.additionalFeeAmount ?? 0)) : 0,
                    additionalFeesFinancialId: this.templates?.labels_table[15]?.isChecked ? (product?.additionalFeeType?.incomeAccount ?? 0) : 0,
                    costPrice: product.costPrice ?? 0,
                    totalCostPrice: product.totalCostPrice ?? 0,
                };
                subTotal += product.typeId == TypeIds.BundleTypeId ? totalOfBaseSubTotal : product.baseSubTotal;
                totalAdditionalAmount += product.typeId == TypeIds.BundleTypeId ? totalAdditionalAmountOfBundleItems : product.additionalFeeAmount;
                products.push(invProduct);
            });

            const disName = this.soForm?.controls["discountType"].value ? this.soForm?.controls["discountType"]?.value?.name : "";
            const disValue = this.soForm?.controls["discountValue"]?.value ? this.soForm?.controls["discountValue"]?.value : 0;
            let orderTotal: number = subTotal + totalAdditionalAmount;
            let applicableDiscount = 0;
            let applicableTax = 0;

            applicableDiscount = this.utilityService.calculateConvertedInvoiceTotalDiscount(disName, disValue, subTotal, products, this.isVisibleRowDiscount, this.footerDiscountEnabled, this.isVisibleFooterDiscount);
            if (this.footerDiscountEnabled) {
                orderTotal -= applicableDiscount;
            }
            applicableTax = this.utilityService.calculateConvertedInvoiceTotalTax(products, orderTotal, this.isVisibleRowTax, this.footerTaxEnabled, this.isVisibleFooterTax, this.allTaxRates, false);
            if (this.footerTaxEnabled) {
                orderTotal += applicableTax;
            }
            this.totalAdditionalFee = this.utilityService.calculateOrderTotalAdditionalFee(this.soForm?.controls["additionalFeeType"]?.value?.type?.name, this.soForm?.controls["additionalFee"]?.value, orderTotal, this.purchaseListTB, this.templates?.labels_table[15]?.isChecked, this.templates?.labels_footer[10]?.isChecked);
            orderTotal += this.totalAdditionalFee;

            /** Additional discount */
            let addDiscount: number = 0;
            if (this.soForm?.controls?.additionalDiscountTypeName?.value && this.soForm?.controls?.additionalDiscountType?.value) {
                if (this.soForm?.controls?.additionalDiscountType.value.type.description == "%" || this.soForm?.controls?.additionalDiscountType.value.type.description == "Percentage") {
                    addDiscount = this.soForm?.controls?.additionalDiscountRate.value > 0 ? orderTotal * (Number(this.soForm?.controls?.additionalDiscountRate.value) / 100) : addDiscount;
                } else {
                    addDiscount = Number(this.soForm?.controls?.additionalDiscountRate.value);
                }
            }
            orderTotal = Number(orderTotal) - Number(addDiscount);

            /** Shipment */
            orderTotal = orderTotal + Number(this.soForm?.controls["shippingChargeAmount"].value);
            if (this.soDetails?.isFreeShipping) {
                orderTotal = Number(orderTotal) - Number(this.soForm?.controls["shippingChargeAmount"].value);
            }

            const invoice: IInvoice = {
                id: 0,
                createdSource: this.app.userIP,
                updatedSource: this.app.userIP,
                createdBy: this.app.user.userId,
                updatedBy: this.app.user.userId,
                createdDate: this.app._saveDateTimeWithZone(new Date()),
                updatedDate: this.app._saveDateTimeWithZone(new Date()),
                contactId: this.billingAddressContact ? this.billingAddressContact.id : 0,
                shipContactId: this.shippingAddressContact ? this.shippingAddressContact.id : 0,
                invoiceDate: this.app._saveDateTimeWithZone(new Date()),
                invoiceDueDate: this.app._saveDateTimeWithZone(this.getInvoiceDueDate(this.soForm?.controls["paymentTerm"].value, new Date())),
                number: "",
                description: "",
                organizationId: this.app.companyId,
                accountId: this.soForm?.controls["account"].value ? this.soForm?.controls["account"].value?.id : 0,
                billingAddressId: this.selectedAccountAddress && this.selectedAccountAddress?.addressId ? this.selectedAccountAddress?.addressId : 0,
                shippingAddressId: this.selectedShippingAddress && this.selectedShippingAddress?.addressId ? this.selectedShippingAddress?.addressId : this.selectedAccountAddress && this.selectedAccountAddress?.addressId ? this.selectedAccountAddress?.addressId : 0,
                warehouseId: this.soForm?.controls["location"].value ? this.soForm?.controls["location"].value?.id : 0,
                userId: this.soForm?.controls["salesRep"].value && this.soForm?.controls["salesRep"].value?.id ? this.soForm?.controls["salesRep"].value?.id : 0,
                paymentMethodId: this.soForm?.controls["paymentMethod"].value ? this.soForm?.controls["paymentMethod"].value?.id : 0,
                paymentTermId: this.soForm?.controls["paymentTerm"].value ? this.soForm?.controls["paymentTerm"].value?.id : 0,
                totalAmount: subTotal,
                discountTypeId: this.footerDiscountEnabled && this.templates?.labels_footer[1]?.isChecked && this.soForm?.controls["discountType"].value ? (this.soForm?.controls["discountType"]?.value?.discountBy ?? 0) : 0,
                discountType: "",
                discount: this.footerDiscountEnabled && this.templates?.labels_footer[1]?.isChecked ? applicableDiscount : 0,
                discountFinancialId: this.footerDiscountEnabled && this.templates?.labels_footer[1]?.isChecked ? this.discountOptions?.filter((discount) => discount.id == this.soForm?.controls["discountType"]?.value?.id).map((value) => value.incomeAccount)[0] : 0,
                discountId: this.footerDiscountEnabled && this.templates?.labels_footer[1]?.isChecked ? this.discountOptions?.filter((discount) => discount.id == this.soForm?.controls["discountType"]?.value?.id).map((value) => value?.id)[0] : 0,
                discountRate: this.footerDiscountEnabled && this.templates?.labels_footer[1]?.isChecked ? (this.soForm?.controls["discountValue"]?.value ?? 0) : 0,
                discountName: "",
                taxId: this.footerTaxEnabled && this.templates?.labels_footer[2]?.isChecked ? this.allTaxRates?.[0]?.id || 0 : 0,
                taxAmount: this.footerTaxEnabled && this.templates?.labels_footer[2]?.isChecked ? applicableTax : 0,
                taxRate: this.footerTaxEnabled && this.templates?.labels_footer[2]?.isChecked ? applicableTax : 0,
                taxName: "",
                taxRateTypeId: this.footerTaxEnabled && this.templates?.labels_footer[2]?.isChecked ? this.allTaxRates?.[0]?.typeId || 0 : 0,
                taxFinancialId: this.footerTaxEnabled && this.templates?.labels_footer[2]?.isChecked ? this.allTaxRates?.[0]?.financialAccountId || 0 : 0,
                shippingCharge: this.soForm?.controls["shippingChargeAmount"].value ? this.soForm?.controls["shippingChargeAmount"].value : 0,
                netAmount: orderTotal,
                referenceNumber: this.soForm?.controls["reference"].value,
                invoiceStatusId: 2,
                invoicePaymentStatusId: 1,
                sourceId: 0,
                statusId: this.soForm?.controls["statusId"].value ? 1 : 2,
                shippingMethodId: this.soForm?.controls?.shippingMethod?.value?.id ?? 0,
                shippingTermId: this.soForm?.controls["shippingTerm"].value ? this.soForm?.controls["shippingTerm"].value?.id : 0,
                termsAndCondition: "",
                signatureFileId: 0,
                authorityUserId: 0,
                invoiceNotes: this.getInvoiceNotes(),
                invoiceAudits: this.getInvoiceAudits(),
                invoiceProducts: products,
                customAttributeValues: this.getCustomAttributesForNewInvoice(customattributeList),
                // configJson: JSON.stringify(invTemplate),
                configJson: "",
                createdByUser: "",
                dueAmount: orderTotal,
                salesOrderId: this.soDetails.id,
                salesOrderNo: this.soDetails.number,
                salesObjectId: this.salesObjectId,
                invoiceObjectId: this.invoiceObjectId,
                businessName: this.accountInfo?.businessName,
                channelId: this.soForm?.controls?.accountChannel.value?.id,
                invoiceShipment: this.soShipmentService.prepareSalesOrderToInvoiceShipmentObj(this.soDetails?.shipment),
                shippingFinancialId: this.soForm?.controls?.shippingMethod?.value?.financialAccountId ?? 0,
                isFreeShipping: this.soDetails?.isFreeShipping,
                freeShippingDiscountName: this.soDetails?.freeShippingDiscountName || "",
                freeShippingDiscountAccountId: this.soDetails?.freeShippingDiscountAccountId || 0,
                freeShippingDiscountId: this.soDetails?.freeShippingDiscountId || 0,
                estimateId: 0,
                estimateNo: "",
                additionalDiscount: Number(addDiscount),
                invoiceAddDiscount: this.prepareAdditionalDiscountsForNewInvoice(addDiscount),
                additionalFeesId: this.templates?.labels_footer[10]?.isChecked ? (this.soForm?.controls["additionalFeeType"]?.value?.id ?? 0) : 0,
                additionalRate: this.templates?.labels_footer[10]?.isChecked ? (this.soForm?.controls["additionalFee"]?.value ?? 0) : 0,
                additionalAmount: this.templates?.labels_footer[10]?.isChecked ? this.totalAdditionalFee : 0,
                additionalFeesFinancialId: this.templates?.labels_footer[10]?.isChecked ? (this.soForm?.controls["additionalFeeType"]?.value?.incomeAccount ?? 0) : 0,
                approvalStatusId: ApprovalStatus.Default,
                currencyUnitId: this.accountInfo?.currencyId ?? 0,
                exchangeRate: this.currencyExchangeRate ?? this.baseCurrency?.exchangeRate,
                postingDate: this.isAllowPostingPeriod ? this.app._saveDateTimeWithZone(this.updatedPostingPeriodInfo?.postingDate) : this.app._saveDateTimeWithZone(this.soForm.controls["estimateDate"].value),
                postingMonth: this.isAllowPostingPeriod ? this.updatedPostingPeriodInfo?.postingMonth : new Date(this.soForm.controls["estimateDate"].value).getMonth() + 1,
                postingYear: this.isAllowPostingPeriod ? this.updatedPostingPeriodInfo?.postingYear : new Date(this.soForm.controls["estimateDate"].value).getFullYear(),
                isProductLevelDiscount: this.templates?.labels_table[6]?.isChecked ?? false
            };

            this.appMainService.isShowSpinner("loadSO");
            this.salesOrderService
                .createInvoice(invoice, this.isBaseCurrency())
                .then(() => {
                    this.appMainService.isHideSpinner("loadSO");
                    this.messageService.add({
                        severity: "success",
                        summary: "Success",
                        detail: "Invoice created successfully...",
                    });
                    this.displayConvertToSalesOrder = false;
                    this.onSaveComplete.emit(false);
                })
                .catch(() => {
                    this.isDisabledSaveBtn = false;
                    this.appMainService.isHideSpinner("loadSO");
                    this.messageService.add({
                        severity: "error",
                        summary: "Error",
                        detail: "Error occurred while saving data 123...",
                    });
                });
        } else {
            this.isDisabledSaveBtn = false;
            this.messageService.add({
                severity: "error",
                summary: "Error",
                detail: "Please fill up all required field & Shipping address",
            });
        }
    }

    createBackOrder() {
        const invoiceProducts: any[] = []; // for creating new invoice
        const backorderProducts: any[] = []; // for creating backorder
        let subTotal = 0;
        let remainingProductsSubTotal = 0;
        this.selectedPL.forEach((p) => {
            const product = this.purchaseListTB.filter((s) => s.id == p.id)[0];
            let pPackedQty = Number(p.packedQty);
            let pShippedQty = pPackedQty;
            let pBackOrderQty = Number(p.ordQty) - Number(pShippedQty);
            if (pBackOrderQty < 0) {
                pBackOrderQty = 0;
            }

            /** service & non-inventory items */
            if (p.typeId == TypeIds.ServiceTypeId || p.typeId == TypeIds.NonInventoryTypeId) {
                const pickQty = Number(p.packedQty);
                const invObj = this.prepareInvoiceProductsList(product, pickQty);
                subTotal += Number(invObj.subTotal);
                invoiceProducts.push(invObj);
            } else if (p.typeId == TypeIds.InventoryTypeId) {
                /** inventory items */
                const uomValue = p && p.unit && p.unit.uomDetail && p.unit.uomDetail.value ? p.unit.uomDetail.value : 1;
                if (pBackOrderQty == p.ordQty) {
                    const obj = this.prepareSalesOrderProductsListForBackorder(product, p);
                    remainingProductsSubTotal += obj.subTotal;
                    backorderProducts.push(obj);
                } else {
                    if (pBackOrderQty) {
                        const soObj = this.prepareSalesOrderProductsListForBackorder(product, p, pBackOrderQty);
                        backorderProducts.push(soObj);
                        remainingProductsSubTotal += Number(soObj.subTotal);
                    }
                    if (pShippedQty) {
                        const invObj = this.prepareInvoiceProductsList(product, pShippedQty);
                        invoiceProducts.push(invObj);
                        subTotal += Number(invObj.subTotal);
                    }
                }
            } else if (p.typeId == TypeIds.KitTypeId) {
                /** kit items */
                const soBundleDetails: any[] = [];
                const invBundledetails: any[] = [];
                let soBundleTotal = 0;
                let invBundleTotal = 0;
                if (pBackOrderQty == p.ordQty) {
                    for (let e of product.bundleDetails) {
                        const uomValue = e?.unit?.uomDetail?.value || 1;
                        const soObj = this.prepareSalesOrderBundleProductListForBackorder(e, product, e.ordQty);
                        soBundleTotal += Number(product.ordQty) * Number(uomValue) * Number(product.price);
                        soBundleDetails.push(soObj);
                        /** kit under kit items */
                        if (e.bundleDetails?.length > 0) {
                            for (let kp of e.bundleDetails) {
                                const uomValue = kp?.unit?.uomDetail?.value || 1;
                                const soObj = this.prepareSalesOrderBundleProductListForBackorder(kp, e, kp.ordQty);
                                soObj.parentProductId = e.id;
                                soBundleTotal += Number(e.ordQty) * Number(uomValue) * Number(e.price);
                                soBundleDetails.push(soObj);
                            }
                        }
                    }
                } else {
                    if (pBackOrderQty) {
                        for (let e of product.bundleDetails) {
                            let qty = Number(e.originalQty) * Number(pBackOrderQty);
                            const soObj = this.prepareSalesOrderBundleProductListForBackorder(e, product, qty);
                            soBundleDetails.push(soObj);
                            /** kit under kit items */
                            if (e.bundleDetails?.length > 0) {
                                for (let kp of e.bundleDetails) {
                                    let qty = Number(kp.originalQty) * Number(pBackOrderQty);
                                    const soObj = this.prepareSalesOrderBundleProductListForBackorder(kp, e, qty);
                                    soObj.parentProductId = e.id;
                                    soBundleDetails.push(soObj);
                                }
                            }
                        }
                        const uomValue = p?.unit?.uomDetail?.value || 1;
                        soBundleTotal = Number(pBackOrderQty) * Number(uomValue) * Number(product.price);
                    }
                    if (pShippedQty) {
                        for (let e of product.bundleDetails) {
                            let qty = Number(e.originalQty) * Number(pShippedQty);
                            const invObj = this.prepareInvoiceBundleProductsList(e, product, qty);
                            invBundledetails.push(invObj);
                            /** kit under kit items */
                            if (e.bundleDetails?.length > 0) {
                                for (let kp of e.bundleDetails) {
                                    let qty = Number(kp.originalQty) * Number(pShippedQty);
                                    const invObj = this.prepareInvoiceBundleProductsList(kp, e, qty);
                                    invObj.parentProductId = e.id;
                                    invBundledetails.push(invObj);
                                }
                            }
                        }
                        const uomValue = p?.unit?.uomDetail?.value || 1;
                        invBundleTotal = Number(pShippedQty) * Number(uomValue) * Number(product.price);
                    }
                }
                if (soBundleDetails.length) {
                    const obj = this.prepareSalesOrderProductsListForBackorder(product, p, pBackOrderQty, soBundleDetails);
                    obj.totalAmount = soBundleTotal;
                    backorderProducts.push(obj);
                }
                if (invBundledetails.length) {
                    const obj = this.prepareInvoiceProductsList(product, pShippedQty, invBundledetails);
                    obj.totalAmount = invBundleTotal;
                    invoiceProducts.push(obj);
                }
                subTotal += invBundleTotal;
                remainingProductsSubTotal += soBundleTotal;
            } else {
                /** bundle items */
                const soBundleDetails: any[] = [];
                const invBundledetails: any[] = [];
                let soBundleTotal = 0;
                let invBundleTotal = 0;
                for (let e of product.bundleDetails) {
                    const uomValue = e?.unit?.uomDetail?.value || 1;
                    const bpPickQty = this.soDetails.salesOrderStageId == SoStageId.Entered ? Number(e.ordQty) : this.soDetails.salesOrderStageId == SoStageId.Pick ? Number(e.pickedQty) : Number(e.packedQty);
                    const soQty = Number(e.ordQty) - Number(bpPickQty);

                    if (soQty == p.ordQty) {
                        const obj = this.prepareSalesOrderBundleProductListForBackorder(e, product);
                        soBundleTotal += Number(e.subTotal);
                        soBundleDetails.push(obj);
                    } else {
                        if (soQty) {
                            const soObj = this.prepareSalesOrderBundleProductListForBackorder(e, product, soQty);
                            soBundleTotal += Number(soQty) * Number(uomValue) * Number(e.price); //todo
                            soBundleDetails.push(soObj);
                        }
                        if (bpPickQty) {
                            const invObj = this.prepareInvoiceBundleProductsList(e, product, bpPickQty);
                            invBundleTotal += Number(e.subTotal); //todo
                            invBundledetails.push(invObj);
                        }
                    }
                }
                if (soBundleDetails.length) {
                    const obj = this.prepareSalesOrderProductsListForBackorder(product, p, 0, soBundleDetails);
                    obj.totalAmount = soBundleTotal;
                    backorderProducts.push(obj);
                }
                if (invBundledetails.length) {
                    const obj = this.prepareInvoiceProductsList(product, 0, invBundledetails);
                    obj.totalAmount = invBundleTotal;
                    invoiceProducts.push(obj);
                }
                subTotal += invBundleTotal;
                remainingProductsSubTotal += soBundleTotal;
            }
        });

        if (this.selectedPL.length == backorderProducts.length && !invoiceProducts.length) {
            this.updateSalesOrderStatus("BackOrder");
        } else {
            if (invoiceProducts.length) {
                this.createInvoiceWithProductsPartialQty(invoiceProducts, subTotal);
            }
            if (backorderProducts.length > 0) {
                this.createSalesOrderWithProductsPartialQty(backorderProducts, remainingProductsSubTotal);
            }
        }
    }

    createInvoiceWithProductsPartialQty(invoiceProducts, subTotal): void {
        this.isDisabledSaveBtn = true;
        const invoiceNotes = this.getInvoiceNotes();
        const invoiceAudits = this.getInvoiceAudits();
        const customattributeList = this.utilityService.getCustomAttributesForAddEdit(this.combinedCustomFields);
        const disName = this.soForm?.controls["discountType"].value ? this.soForm?.controls["discountType"]?.value?.name : "";
        const disValue = this.soForm?.controls["discountValue"]?.value ? this.soForm?.controls["discountValue"]?.value : 0;
        let orderTotal = subTotal;
        let applicableDiscount = 0;
        let applicableTax = 0;
        let additionalFee = 0;

        /** Tax and Discount */
        applicableDiscount = this.utilityService.calculateConvertedInvoiceTotalDiscount(disName, disValue, subTotal, invoiceProducts, this.isVisibleRowDiscount, this.footerDiscountEnabled, this.isVisibleFooterDiscount);
        if (this.footerDiscountEnabled) {
            orderTotal -= applicableDiscount;
        }
        applicableTax = this.utilityService.calculateConvertedInvoiceTotalTax(invoiceProducts, orderTotal, this.isVisibleRowTax, this.footerTaxEnabled, this.isVisibleFooterTax, this.allTaxRates, true);
        if (this.footerTaxEnabled) {
            orderTotal += applicableTax;
        }
        additionalFee = this.utilityService.calculateOrderTotalAdditionalFeeForPartialQty(this.soForm?.controls["additionalFeeType"]?.value?.type?.name, this.soForm?.controls["additionalFee"]?.value, orderTotal, invoiceProducts, this.templates?.labels_table[15]?.isChecked, this.templates?.labels_footer[10]?.isChecked);
        orderTotal += additionalFee;

        /** Additional discount */
        let addDiscount = 0;
        if (this.soForm?.controls?.additionalDiscountTypeName?.value && this.soForm?.controls?.additionalDiscountType?.value) {
            if (this.soForm?.controls?.additionalDiscountType.value.type.description == "%" || this.soForm?.controls?.additionalDiscountType.value.type.description == "Percentage") {
                addDiscount = this.soForm?.controls?.additionalDiscountRate.value > 0 ? orderTotal * (Number(this.soForm?.controls?.additionalDiscountRate.value) / 100) : addDiscount;
            } else {
                addDiscount = Number(this.soForm?.controls?.additionalDiscountRate.value);
            }
        }
        orderTotal = Number(orderTotal) - Number(addDiscount);
        orderTotal = orderTotal + Number(this.soForm?.controls["shippingChargeAmount"].value);
        
        const invoice: IInvoice = {
            id: 0,
            createdSource: this.app.userIP,
            updatedSource: this.app.userIP,
            createdBy: this.app.user.userId,
            updatedBy: this.app.user.userId,
            createdDate: this.app._saveDateTimeWithZone(new Date()),
            updatedDate: this.app._saveDateTimeWithZone(new Date()),
            contactId: this.billingAddressContact ? this.billingAddressContact.id : 0,
            shipContactId: this.shippingAddressContact ? this.shippingAddressContact.id : 0,
            invoiceDate: this.app._saveDateTimeWithZone(new Date()),
            invoiceDueDate: this.app._saveDateTimeWithZone(this.getInvoiceDueDate(this.soForm?.controls["paymentTerm"].value, new Date())),
            number: "",
            description: "",
            organizationId: this.app.companyId,
            accountId: this.soForm?.controls["account"].value ? this.soForm?.controls["account"].value?.id : 0,
            billingAddressId: this.selectedAccountAddress && this.selectedAccountAddress?.addressId ? this.selectedAccountAddress?.addressId : 0,
            shippingAddressId: this.selectedShippingAddress && this.selectedShippingAddress?.addressId ? this.selectedShippingAddress?.addressId : this.selectedAccountAddress && this.selectedAccountAddress?.addressId ? this.selectedAccountAddress?.addressId : 0,
            warehouseId: this.soForm?.controls["location"].value ? this.soForm?.controls["location"].value?.id : 0,
            userId: this.soForm?.controls["salesRep"].value && this.soForm?.controls["salesRep"].value?.id ? this.soForm?.controls["salesRep"].value?.id : 0,
            paymentMethodId: this.soForm?.controls["paymentMethod"].value ? this.soForm?.controls["paymentMethod"].value?.id : 0,
            paymentTermId: this.soForm?.controls["paymentTerm"].value ? this.soForm?.controls["paymentTerm"].value?.id : 0,
            totalAmount: subTotal,
            discountTypeId: this.footerDiscountEnabled && this.templates?.labels_footer[1]?.isChecked && this.soForm?.controls["discountType"].value ? (this.soForm?.controls["discountType"]?.value?.discountBy ?? 0) : 0,
            discountType: "",
            discount: this.footerDiscountEnabled && this.templates?.labels_footer[1]?.isChecked ? applicableDiscount : 0,
            discountFinancialId: this.footerDiscountEnabled && this.templates?.labels_footer[1]?.isChecked ? this.discountOptions?.filter((discount) => discount.id == this.soForm?.controls["discountType"]?.value?.id).map((value) => value.incomeAccount)[0] : 0,
            discountId: this.footerDiscountEnabled && this.templates?.labels_footer[1]?.isChecked ? this.discountOptions?.filter((discount) => discount.id == this.soForm?.controls["discountType"]?.value?.id).map((value) => value?.id)[0] : 0,
            discountRate: this.footerDiscountEnabled && this.templates?.labels_footer[1]?.isChecked ? (this.soForm?.controls["discountValue"]?.value ?? 0) : 0,
            discountName: "",
            taxId: this.footerTaxEnabled && this.templates?.labels_footer[2]?.isChecked ? this.allTaxRates?.[0]?.id || 0 : 0,
            taxAmount: this.footerTaxEnabled && this.templates?.labels_footer[2]?.isChecked ? applicableTax : 0,
            taxName: "",
            taxRateTypeId: this.footerTaxEnabled && this.templates?.labels_footer[2]?.isChecked ? this.allTaxRates?.[0]?.typeId || 0 : 0,
            taxFinancialId: this.footerTaxEnabled && this.templates?.labels_footer[2]?.isChecked ? this.allTaxRates?.[0]?.financialAccountId || 0 : 0,
            shippingCharge: this.soForm?.controls["shippingChargeAmount"].value ? this.soForm?.controls["shippingChargeAmount"].value : 0,
            netAmount: orderTotal,
            referenceNumber: this.soForm?.controls["reference"].value,
            invoiceStatusId: 2,
            invoicePaymentStatusId: 1,
            sourceId: 0,
            statusId: this.soForm?.controls["statusId"].value ? 1 : 2,
            shippingMethodId: this.soForm?.controls?.shippingMethod?.value?.id ?? 0,
            shippingTermId: this.soForm?.controls["shippingTerm"].value ? this.soForm?.controls["shippingTerm"].value?.id : 0,
            termsAndCondition: "",
            signatureFileId: 0,
            authorityUserId: 0,
            invoiceNotes: invoiceNotes,
            invoiceAudits: invoiceAudits,
            invoiceProducts: invoiceProducts,
            customAttributeValues: this.getCustomAttributesForNewInvoice(customattributeList),
            // configJson: JSON.stringify(invTemplate),
            configJson: "",
            createdByUser: "",
            dueAmount: orderTotal,
            salesOrderId: this.soDetails.id,
            salesOrderNo: this.soDetails.number,
            salesObjectId: this.salesObjectId,
            invoiceObjectId: this.invoiceObjectId,
            businessName: this.accountInfo?.businessName,
            channelId: this.soForm?.controls?.accountChannel.value?.id,
            estimateId: 0,
            estimateNo: "",
            invoiceShipment: this.soShipmentService.prepareSalesOrderToInvoiceShipmentObj(this.soDetails?.shipment),
            shippingFinancialId: this.soDetails?.shippingMethod?.financialAccountId || 0,
            isFreeShipping: this.soDetails?.isFreeShipping,
            freeShippingDiscountName: this.soDetails?.freeShippingDiscountName || "",
            freeShippingDiscountAccountId: this.soDetails?.freeShippingDiscountAccountId || 0,
            freeShippingDiscountId: this.soDetails?.freeShippingDiscountId || 0,
            additionalDiscount: Number(addDiscount),
            invoiceAddDiscount: this.prepareAdditionalDiscountsForNewInvoice(addDiscount),
            additionalFeesId: this.templates?.labels_footer[10]?.isChecked ? (this.soForm?.controls["additionalFeeType"]?.value?.id ?? 0) : 0,
            additionalRate: this.templates?.labels_footer[10]?.isChecked ? (this.soForm?.controls["additionalFee"]?.value ?? 0) : 0,
            additionalAmount: this.templates?.labels_footer[10]?.isChecked ? additionalFee : 0,
            additionalFeesFinancialId: this.templates?.labels_footer[10]?.isChecked ? (this.soForm?.controls["additionalFeeType"]?.value?.incomeAccount ?? 0) : 0,
            approvalStatusId: ApprovalStatus.Default,
            currencyUnitId: this.accountInfo?.currencyId ?? 0,
            exchangeRate: this.currencyExchangeRate ?? this.baseCurrency?.exchangeRate,
            postingDate: this.isAllowPostingPeriod ? this.app._saveDateTimeWithZone(this.updatedPostingPeriodInfo?.postingDate) : this.app._saveDateTimeWithZone(this.soForm.controls["estimateDate"].value),
            postingMonth: this.isAllowPostingPeriod ? this.updatedPostingPeriodInfo?.postingMonth : new Date(this.soForm.controls["estimateDate"].value).getMonth() + 1,
            postingYear: this.isAllowPostingPeriod ? this.updatedPostingPeriodInfo?.postingYear : new Date(this.soForm.controls["estimateDate"].value).getFullYear(),
            isProductLevelDiscount: this.templates?.labels_table[6]?.isChecked ?? false
        };
        this.appMainService.isShowSpinner("loadINV");
        this.salesOrderService
            .createInvoice(invoice, this.isBaseCurrency())
            .then(() => {
                this.appMainService.isHideSpinner("loadINV");
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Invoice created successfully...",
                });
                this.displayConvertToSalesOrder = false;
                this.onSaveComplete.emit(false);
            })
            .catch(() => {
                this.isDisabledSaveBtn = false;
                this.appMainService.isHideSpinner("loadINV");
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred while saving data...",
                });
            });
    }

    createSalesOrderWithProductsPartialQty(backorderProducts, remainingProductsSubTotal) {
        this.isDisabledSaveBtn = true;
        const customattributeList = this.utilityService.getCustomAttributesForAddEdit(this.combinedCustomFields);
        const disName = this.soForm?.controls["discountType"].value ? this.soForm?.controls["discountType"]?.value?.name : "";
        const disValue = this.soForm?.controls["discountValue"]?.value ? this.soForm?.controls["discountValue"]?.value : 0;
        let remainingOrderTotal = remainingProductsSubTotal;

        let applicableDiscount = 0;
        let applicableTax = 0;
        let additionalFee = 0;
        
        applicableDiscount = this.utilityService.calculateOrderTotalDiscount(disName, disValue, remainingProductsSubTotal, backorderProducts, this.isVisibleRowDiscount, this.footerDiscountEnabled, this.isVisibleFooterDiscount);
        if (this.footerDiscountEnabled) {
            remainingOrderTotal -= applicableDiscount;
        }
        applicableTax = this.utilityService.calculateOrderTotalTax(backorderProducts, remainingOrderTotal, this.isVisibleRowTax, this.footerTaxEnabled, this.isVisibleFooterTax, this.allTaxRates);
        if (this.footerTaxEnabled) {
            remainingOrderTotal += applicableTax;
        }
        additionalFee = this.utilityService.calculateOrderTotalAdditionalFeeForPartialQty(this.soForm?.controls["additionalFeeType"]?.value?.type?.name, this.soForm?.controls["additionalFee"]?.value, remainingOrderTotal, backorderProducts, this.templates?.labels_table[15]?.isChecked, this.templates?.labels_footer[10]?.isChecked);
        remainingOrderTotal += additionalFee;

        /** Additional Discount */
        let addDiscount = 0;
        if (this.soForm?.controls?.additionalDiscountTypeName?.value && this.soForm?.controls?.additionalDiscountType?.value) {
            if (this.soForm?.controls?.additionalDiscountType.value.type.description == "%" || this.soForm?.controls?.additionalDiscountType.value.type.description == "Percentage") {
                addDiscount = this.soForm?.controls?.additionalDiscountRate.value > 0 ? remainingOrderTotal * (Number(this.soForm?.controls?.additionalDiscountRate.value) / 100) : addDiscount;
            } else {
                addDiscount = Number(this.soForm?.controls?.additionalDiscountRate.value);
            }
        }
        remainingOrderTotal = Number(remainingOrderTotal) - Number(addDiscount);
        remainingOrderTotal = remainingOrderTotal + Number(this.soForm?.controls["shippingChargeAmount"].value);

        const salesOrder: ISalesOrder = {
            id: 0,
            createdSource: this.app.userIP,
            updatedSource: this.app.userIP,
            createdBy: this.app.user.userId,
            updatedBy: this.app.user.userId,
            backOrderSalesOrderId: this.soDetails.id,
            contactId: this.billingAddressContact ? this.billingAddressContact.id : 0,
            shipContactId: this.shippingAddressContact ? this.shippingAddressContact.id : 0,
            createdDate: this.app._saveDateTimeWithZone(new Date()),
            updatedDate: this.app._saveDateTimeWithZone(new Date()),
            number: "",
            name: "",
            description: "",
            organizationId: this.app.companyId,
            salesOrderDate: this.app._saveDateTimeWithZone(this.soForm?.controls["estimateDate"].value),
            accountId: this.soForm?.controls["account"].value?.id,
            warehouseId: this.soForm?.controls["location"].value?.id,
            userId: this.soForm?.controls["salesRep"].value && this.soForm?.controls["salesRep"].value?.id ? this.soForm?.controls["salesRep"].value?.id : 0,
            shippingAddressId: this.selectedShippingAddress && this.selectedShippingAddress?.addressId ? this.selectedShippingAddress?.addressId : 0,
            billingAddressId: this.selectedAccountAddress && this.selectedAccountAddress?.addressId ? this.selectedAccountAddress?.addressId : 0,
            totalAmount: remainingProductsSubTotal,
            discountTypeId: this.footerDiscountEnabled && this.templates?.labels_footer[1]?.isChecked && this.soForm?.controls["discountType"].value ? (this.soForm?.controls["discountType"]?.value?.discountBy ?? 0) : 0,
            discountType: "",
            discountAmount: this.footerDiscountEnabled && this.templates?.labels_footer[1]?.isChecked ? applicableDiscount : 0,
            discountFinancialId: this.footerDiscountEnabled && this.templates?.labels_footer[1]?.isChecked ? this.discountOptions?.filter((discount) => discount.id == this.soForm?.controls["discountType"]?.value?.id).map((value) => value.incomeAccount)[0] : 0,
            discountId: this.footerDiscountEnabled && this.templates?.labels_footer[1]?.isChecked ? this.discountOptions?.filter((discount) => discount.id == this.soForm?.controls["discountType"]?.value?.id).map((value) => value?.id)[0] : 0,
            discountRate: this.footerDiscountEnabled && this.templates?.labels_footer[1]?.isChecked ? (this.soForm?.controls["discountValue"]?.value ?? 0) : 0,
            discountName: "",
            taxId: this.footerTaxEnabled && this.templates?.labels_footer[2]?.isChecked ? this.allTaxRates?.[0]?.id || 0 : 0,
            taxAmount: this.footerTaxEnabled && this.templates?.labels_footer[2]?.isChecked ? applicableTax : 0,
            taxName: "",
            taxRateTypeId: this.footerTaxEnabled && this.templates?.labels_footer[2]?.isChecked ? this.allTaxRates?.[0]?.typeId || 0 : 0,
            taxFinancialId: this.footerTaxEnabled && this.templates?.labels_footer[2]?.isChecked ? this.allTaxRates?.[0]?.financialAccountId || 0 : 0,
            shippingChargeAmount: 0,
            netAmount: remainingOrderTotal,
            balanceDue: remainingOrderTotal,
            salesOrderStageId: 1, // todo entered filter
            salesOrderStage: "",
            paymentMethodId: this.soForm?.controls["paymentMethod"].value ? this.soForm?.controls["paymentMethod"].value?.id : 0,
            paymentTermId: this.soForm?.controls["paymentTerm"].value ? this.soForm?.controls["paymentTerm"].value?.id : 0,
            sourceId: 0,
            defaultPriceListId: 0,
            termsAndCondition: "",
            reference: this.soForm?.controls["reference"].value,
            saleCommission: 0,
            holdOrderProcessedDate: this.app._saveDateTimeWithZone(new Date()),
            isBackOrder: true,
            backOrderInvoiceId: 0,
            shippingMethodId: this.soForm?.controls?.shippingMethod?.value?.id ?? 0,
            shippingFinancialId: this.soForm?.controls?.shippingMethod?.value?.financialAccountId ?? 0,
            shippingTermId: this.soForm?.controls["shippingTerm"].value ? this.soForm?.controls["shippingTerm"].value?.id : 0,
            salesOrderStatusId: this.soForm?.controls["salesOrderStatus"].value?.id,
            salesOrderStatus: "",
            typeId: 0,
            groupId: 0,
            statusId: this.soForm?.controls["statusId"].value ? 1 : 2,
            isValid: true,
            validFromDate: this.app._saveDateTimeWithZone(new Date()),
            validToDate: this.app._saveDateTimeWithZone(new Date()),
            salesOrderNote: this.prepareSalesOrderNote(),
            salesOrderAudit: this.prepareSalesOrderAudit(),
            salesOrderProducts: backorderProducts,
            createdByUser: "",
            customAttributeValues: this.setCustomAttributes(customattributeList),
            configJson: "",
            salesObjectId: this.salesObjectId,
            businessName: this.accountInfo?.businessName,
            isFreeShipping: false,
            freeShippingDiscountName: "",
            freeShippingDiscountAccountId: 0,
            freeShippingDiscountId: 0,
            channelId: this.soForm?.controls?.accountChannel.value?.id,
            salesOrderPaymentStatusId: 1,
            additionalDiscount: Number(addDiscount),
            salesOrderAddDiscount: this.prepareAdditionalDiscountsForNewSalesOrder(addDiscount),
            additionalFeesId: this.templates?.labels_footer[10]?.isChecked ? (this.soForm?.controls["additionalFeeType"]?.value?.id ?? 0) : 0,
            additionalRate: this.templates?.labels_footer[10]?.isChecked ? (this.soForm?.controls["additionalFee"]?.value ?? 0) : 0,
            additionalAmount: this.templates?.labels_footer[10]?.isChecked ? additionalFee : 0,
            additionalFeesFinancialId: this.templates?.labels_footer[10]?.isChecked ? (this.soForm?.controls["additionalFeeType"]?.value?.incomeAccount ?? 0) : 0,
            approvalStatusId: ApprovalStatus.Default,
            currencyUnitId: this.accountInfo?.currencyId ?? 0,
            exchangeRate: this.currencyExchangeRate ?? this.baseCurrency?.exchangeRate,
            isProductLevelDiscount: this.templates?.labels_table[6]?.isChecked ?? false
        };
        this.appMainService.isShowSpinner("loadSO");
        this.salesOrderService
            .createSalesOrder(salesOrder, this.isBaseCurrency())
            .then(() => {
                this.appMainService.isHideSpinner("loadSO");
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Sales Order saved successfully...",
                });
                this.displayConvertToSalesOrder = false;
            })
            .catch(() => {
                this.isDisabledSaveBtn = false;
                this.appMainService.isHideSpinner("loadSO");
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred while saving data...",
                });
            });
    }

    updateSalesOrderStatus(status) {
        this.isDisabledSaveBtn = true;
        this.appMainService.isShowSpinner("loadSO");
        const req = _.cloneDeep(this.soDetails);
        const statusId = this.allStatus.filter((s) => s.name == status)[0].id;
        if (status == "BackOrder" && req.number && !req.number.endsWith("BK1")) {
            req.number = req.number + "BK1";
        }
        req.salesOrderStatusId = statusId;
        req.isBackOrder = true;
        req.backOrderSalesOrderId = this.soDetails.id;
        req.isFreeShipping = false;
        req.freeShippingDiscountName = "";
        req.freeShippingDiscountAccountId = 0;
        req.freeShippingDiscountId = 0;
        req.account = null;
        req.warehouse = null;
        req.user = null;
        req.shippingAddress = null;
        req.discountType = null;
        req.paymentMethod = null;
        req.paymentTerm = null;
        req.shippingMethod = null;
        req.shippingTerm = null;
        req.contact = null;
        req.shipContact = null;
        if (req.salesOrderProducts && req.salesOrderProducts.length) {
            req.salesOrderProducts.forEach((e) => {
                e.product = null;
            });
        }
        this.salesOrderService
            .updateSalesOrder(req, this.isBaseCurrency())
            .then(() => {
                this.appMainService.isHideSpinner("loadSO");
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Sales Order updated successfully...",
                });
                this.displayConvertToSalesOrder = false;
                this.onSaveComplete.emit(false);
            })
            .catch(() => {
                this.isDisabledSaveBtn = false;
                this.appMainService.isHideSpinner("loadSO");
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred while updating data...",
                });
            });
    }

    createInvoiceFromSalesOrder() {
        if (this.utilityService.hasProdutsSerialTrackingToCreateInvoice(this.purchaseListTB, this.soDetails, SOChannel.SALES_ORDER)) {
            this.isDisabledSaveBtn = true;
            this.invoiceToBeCreated = true;
            this.salesOrderService
                .updateSalesOrder(this.prepareSalesOrderDataToUpdate("convertToInvoice"), this.isBaseCurrency())
                .then(() => {
                    this.salesOrderService
                        .getSalesOrderDetailsById(this.selectedOrder.id)
                        .pipe(takeUntil(this.ngUnsubscribe$))
                        .subscribe(async (res) => {
                            await this.prepareSalesOrderDetailsData(res);

                            /** If backorder is false, then invoice will be created with the pick/pack qty */
                            if (!this.isEnabledBackOrder) {
                                const isValid = this.utilityService.checkvalidation(this.combinedCustomFields);
                                if (this.type && this.type == DialogType.EDIT && isValid) {
                                    this.createInvoice();
                                }
                            } else {
                                this.isVisibleBackOrderSelectionDialog();
                            }
                        });
                })
                .catch(() => {
                    this.isDisabledSaveBtn = false;
                    this.invoiceToBeCreated = false;
                    this.appMainService.isHideSpinner("loadSO");
                    this.messageService.add({
                        severity: "error",
                        summary: "Error",
                        detail: "Error occurred while updating data...",
                    });
                });
            this.isOrderVoid = false;
        } else {
            this.messageService.add({
                severity: "error",
                summary: "Error",
                detail: "Please add serial no",
            });
        }
    }

    getCustomAttributesForNewInvoice(value) {
        const custom: any[] = [];
        if (value.length > 0) {
            value.forEach((element) => {
                const customEach = {
                    id: 0,
                    createdSource: this.app.userIP,
                    updatedSource: this.app.userIP,
                    createdBy: this.app.userId,
                    updatedBy: this.app.userId,
                    createdDate: this.app._saveDateTimeWithZone(new Date()),
                    updatedDate: this.app._saveDateTimeWithZone(new Date()),
                    objectId: this.app.preLoadedObjects.find((obj) => obj.name == "Orders").id,
                    objectValue: 0,
                    customAttributeId: element.id,
                    customAttribute: this.modifyCustumAttributes(element),
                    value: element.formControl?.name == "InputBox" || element.formControl?.name == "DatePicker" || element.formControl?.name == "Decimal" || element.formControl?.name == "Number" ? element.value : null,
                    statusId: Status.Active,
                    values: element.formControl?.name == "DropDownList" ? element.value : element.formControl?.name == "RadioButton" ? { name: element.value } : null,
                    multipleValues: element.formControl?.name == "MultipleDropDownList" ? element.value : element.formControl?.name == "CheckBox" ? this.setCheckBoxValue(element.value) : null,
                    ratingId: element.formControl?.name == "Rating" ? element.value : 0,
                    toggle: element.formControl?.name == "ToggleButton" ? element.value : false,
                    customeAttachement: element.formControl?.name == "FileUpload" || element.formControl?.name == "Picture" ? element.customUploadedFiles : null,
                };
                custom.push(customEach);
            });
        }
        return custom;
    }

    getInvoiceDueDate(paymentTerm, date) {
        let result = null;
        if (paymentTerm && paymentTerm.type && paymentTerm.type.name == "NET") {
            if (paymentTerm.netDueDay) {
                result = moment(new Date(date)).add(paymentTerm.netDueDay, "days").toDate();
            }
        } else if (paymentTerm && paymentTerm.type && paymentTerm.type.name == "Date Driven") {
            const dateOfTheMonth = new Date(moment(date).year(), moment(date).month(), paymentTerm.netDueDay);
            const firstDayOfThatMonth = new Date(moment(date).year(), moment(date).month(), 1);
            const lastDueDateOfThatMonth = moment(new Date(dateOfTheMonth)).subtract(paymentTerm.nextMonthBeforeDue, "days");
            const isBeforeDueDate = moment(new Date(date)).isBetween(firstDayOfThatMonth, moment(lastDueDateOfThatMonth).add(1, "days").toDate());
            if (isBeforeDueDate) {
                result = dateOfTheMonth;
            } else {
                result = moment(new Date(dateOfTheMonth)).add(1, "months").toDate();
            }
        }
        if(result == null) {
            result = date;
        }
        return result;
    }
    getInvoiceNotes() {
        let invoiceNotes = null;
        if (this.soForm?.controls["vendorMessage"].value && this.soForm?.controls["vendorMessage"].value != "") {
            invoiceNotes = [
                {
                    id: 0,
                    createdSource: this.app.userIP,
                    updatedSource: this.app.userIP,
                    createdBy: this.app.user.userId,
                    updatedBy: this.app.user.userId,
                    createdDate: this.app._saveDateTimeWithZone(new Date()),
                    updatedDate: this.app._saveDateTimeWithZone(new Date()),
                    invoiceId: 0,
                    userId: this.app.user.userId,
                    user: null,
                    noteId: 0,
                    note: {
                        id: 0,
                        createdSource: this.app.userIP,
                        updatedSource: this.app.userIP,
                        createdBy: this.app.user.userId,
                        updatedBy: this.app.user.userId,
                        createdDate: this.app._saveDateTimeWithZone(new Date()),
                        updatedDate: this.app._saveDateTimeWithZone(new Date()),
                        comment: this.soForm?.controls["vendorMessage"].value,
                        isImportant: true,
                        organizationId: this.app.companyId,
                        description: "",
                        statusId: Status.Active,
                        isValid: true,
                        validFromDate: new Date().toISOString(),
                        validToDate: new Date().toISOString(),
                        noteComments: null,
                        noteAttachments: null,
                        createdByName: null,
                    },
                    invoiceStatusId: this.soForm?.controls["salesOrderStatus"].value ? this.soForm?.controls["salesOrderStatus"].value?.id : 0,
                    invoiceStatus: null,
                },
            ];
        }
        return invoiceNotes;
    }

    getInvoiceAudits() {
        let invoiceAudits = null;
        if (this.soForm?.controls["memo"].value && this.soForm?.controls["memo"].value != "") {
            invoiceAudits = [
                {
                    id: 0,
                    createdSource: this.app.userIP,
                    updatedSource: this.app.userIP,
                    createdBy: this.app.user.userId,
                    updatedBy: this.app.user.userId,
                    createdDate: this.app._saveDateTimeWithZone(new Date()),
                    updatedDate: this.app._saveDateTimeWithZone(new Date()),
                    invoiceId: 0,
                    description: "",
                    noteId: 0,
                    note: {
                        id: 0,
                        createdSource: this.app.userIP,
                        updatedSource: this.app.userIP,
                        createdBy: this.app.user.userId,
                        updatedBy: this.app.user.userId,
                        createdDate: this.app._saveDateTimeWithZone(new Date()),
                        updatedDate: this.app._saveDateTimeWithZone(new Date()),
                        comment: this.soForm?.controls["memo"].value,
                        isImportant: true,
                        organizationId: this.app.companyId,
                        description: "",
                        statusId: Status.Active,
                        isValid: true,
                        validFromDate: new Date().toISOString(),
                        validToDate: new Date().toISOString(),
                        noteComments: null,
                        noteAttachments: null,
                        createdByName: "",
                    },
                },
            ];
        }
        return invoiceAudits;
    }

    prepareSalesOrderBundleProductListForBackorder(e, product, qty = 0): ISalesOrderBundleProduct {
        const uomValue = e?.unit?.uomDetail?.value || 1;
        const soBundleProduct: ISalesOrderBundleProduct = {
            id: 0,
            createdSource: this.app.userIP,
            updatedSource: this.app.userIP,
            createdBy: this.app.user.userId,
            updatedBy: this.app.user.userId,
            createdDate: this.app._saveDateTimeWithZone(new Date()),
            updatedDate: this.app._saveDateTimeWithZone(new Date()),
            description: e.description,
            salesOrderId: 0,
            productId: product.id,
            subproductId: e.id,
            parentProductId: 0,
            parentBundleId: 0,
            productUOMId: e.unit && e.unit.unitOfMeasureId ? e.unit.unitOfMeasureId : 0,
            availableQuantity: e.availabel ?? 0,
            quantity: qty ? qty : e.ordQty,
            pricePerProduct: e.price,
            totalAmount: qty ? qty * Number(uomValue) * e.price : e.ordQty * Number(uomValue) * e.price,
            subTotal: qty * Number(uomValue) * e.price,
            discountTypeId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked && e.discountType ? (e.discountType.discountBy ?? 0) : 0,
            discountType: "",
            discountAmount: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? e.discountAmount : 0,
            discountFinancialId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? this.discountOptions?.filter((discount) => discount.id == e.discountType?.id).map((value) => value.incomeAccount)[0] : this.discountOptions?.filter((discount) => discount.id == this.soForm?.controls["discountType"]?.value?.id).map((value) => value.incomeAccount)[0],
            discountId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? this.discountOptions?.filter((discount) => discount.id == e.discountType?.id).map((value) => value?.id)[0] : this.discountOptions?.filter((discount) => discount.id == this.soForm?.controls["discountType"]?.value?.id).map((value) => value?.id)[0],
            discountRate: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? (e.discount ?? 0) : 0,
            discountName: "",
            taxId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && e.taxType ? e.taxType.id : 0,
            taxAmount: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked ? e.taxAmount : 0,
            taxRate: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked ? e.taxAmount : 0,
            taxName: "",
            taxRateTypeId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && e.taxType ? e.taxType.typeId : 0,
            taxFinancialId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && e.taxType ? e.taxType.financialAccountId : 0,
            statusId: Status.Active,
            salesorderSerialNumber: null,
            salesorderproductId: 0,
            salesOrderBundleProductSerialDetail: null,
            binId: this.templates?.labels_table[11].isChecked ? (e.selectedBin ? e.selectedBin?.binId : 0) : 0,
            pickedQty: qty ? qty : e.ordQty,
            packedQty: e.packedQty,
            shippedQty: e.shippedQty,
            totalQty: qty ? qty * Number(uomValue) : e.ordQty * Number(uomValue),
            salesOrderBundleDetailSubTax: this.footerTaxEnabled ? product.typeId == TypeIds.KitTypeId ? this.prepareBackOrderProductsSubtaxCode(product.productSubTax, product.ordQty, product.price, product) : this.prepareBackOrderProductsSubtaxCode(e.bundleDetailSubTax, e.ordQty, e.price, product, e) : [],
            isPicked: false,
            isPacked: false,
            backOrderQty: 0,
            isCopied: e.isDuplicatedProduct ?? false,
            additionalFeesId: this.templates?.labels_table[15]?.isChecked ? (e?.additionalFeeType?.id ?? 0) : 0,
            additionalRate: this.templates?.labels_table[15]?.isChecked ? (e?.additionalFee ?? 0) : 0,
            additionalAmount: this.templates?.labels_table[15]?.isChecked ? (e?.additionalFeeAmount ?? 0) : 0,
            additionalFeesFinancialId: this.templates?.labels_table[15]?.isChecked ? (e?.additionalFeeType?.incomeAccount ?? 0) : 0,
            costPrice: e.costPrice ?? 0,
            totalCostPrice: qty ? qty * Number(uomValue) * (e.costPrice ?? 0) : e.ordQty * Number(uomValue) * (e.costPrice ?? 0),
        };
        return soBundleProduct;
    }

    prepareSalesOrderProductsListForBackorder(product, p, soQty = 0, bundleItems = []): ISalesOrderProduct {
        const uomValue = product?.unit?.uomDetail?.value || 1;
        let qty = soQty ? soQty : product.pickedQty ? product.pickedQty : product.ordQty;
        qty = qty * Number(uomValue);
        let subTotal = Number(qty) * Number(uomValue) * Number(product.price);
        let baseSubTotal = subTotal;

        /** Tax and Discount */
        let applicableDiscount = 0;
        let applicableTax = 0;
        let appliedDiscount = this.discountOptions?.find((discount) => discount.id == product?.discountType?.id);
        /** If checked, sale tax will be calculated on the order total after discount has been applied. */
        if (appliedDiscount && appliedDiscount.isTaxable) {
            applicableDiscount = this.utilityService.calculateProductWiseDiscount(product?.discountType, subTotal, product.discount);
            if (this.footerDiscountEnabled) {
                subTotal -= applicableDiscount;
            }
            // additional fee
            if (this.templates?.labels_table[15]?.isChecked && product?.additionalFeeType?.isTaxable) {
                let addFee = this.utilityService.calculateProductWiseAdditionalFee(product?.additionalFeeType?.type?.name, subTotal, product.additionalFee);
                product.additionalFeeAmount = addFee;
                subTotal = subTotal + Number(addFee);
            }
            applicableTax = this.isVisibleRowTax ? this.utilityService.getProductsTotalTax(product, this.allTaxRates, subTotal, this.shippingAddressInfo?.address?.zipCode, this.shippingAddressInfo?.address?.stateId, this.taxSettings, this.taxConfig) : 0;
            if (this.footerTaxEnabled) {
                subTotal += applicableTax;
            }
            // additional fee
            if (this.templates?.labels_table[15]?.isChecked && !product?.additionalFeeType?.isTaxable) {
                let addFee = this.utilityService.calculateProductWiseAdditionalFee(product?.additionalFeeType?.type?.name, subTotal, product.additionalFee);
                product.additionalFeeAmount = addFee;
                subTotal = subTotal + Number(addFee);
            }
        } else {
            // additional fee
            if (this.templates?.labels_table[15]?.isChecked && product?.additionalFeeType?.isTaxable) {
                let addFee = this.utilityService.calculateProductWiseAdditionalFee(product?.additionalFeeType?.type?.name, subTotal, product.additionalFee);
                product.additionalFeeAmount = addFee;
                subTotal = subTotal + Number(addFee);
            }
            applicableTax = this.isVisibleRowTax ? this.utilityService.getProductsTotalTax(product, this.allTaxRates, subTotal, this.shippingAddressInfo?.address?.zipCode, this.shippingAddressInfo?.address?.stateId, this.taxSettings, this.taxConfig) : 0;
            if (this.footerTaxEnabled) {
                subTotal += applicableTax;
            }
            applicableDiscount = this.utilityService.calculateProductWiseDiscount(product?.discountType, subTotal, product.discount);
            if (this.footerDiscountEnabled) {
                subTotal -= applicableDiscount;
            }
            // additional fee
            if (this.templates?.labels_table[15]?.isChecked && !product?.additionalFeeType?.isTaxable) {
                let addFee = this.utilityService.calculateProductWiseAdditionalFee(product?.additionalFeeType?.type?.name, subTotal, product.additionalFee);
                product.additionalFeeAmount = addFee;
                subTotal = subTotal + Number(addFee);
            }
        }

        // let productsTotalTax = this.utilityService.getProductsTotalTax(product, this.allTaxRates, subTotal);
        // let discount = this.calculateProductsDiscount(product?.discountType, qty, product.price, product.discount);
        // let pTotal = subTotal + productsTotalTax - discount;

        const soProduct: ISalesOrderProduct = {
            id: 0,
            createdSource: this.app.userIP,
            updatedSource: this.app.userIP,
            createdBy: this.app.user.userId,
            updatedBy: this.app.user.userId,
            createdDate: this.app._saveDateTimeWithZone(new Date()),
            updatedDate: this.app._saveDateTimeWithZone(new Date()),
            description: product.description,
            salesOrderId: 0,
            productId: product.id,
            productUOMId: product.unit && product.unit.unitOfMeasureId ? product.unit.unitOfMeasureId : 0,
            availableQuantity: product.availabel ?? 0,
            quantity: soQty ? soQty : product.pickedQty ? product.pickedQty : product.ordQty,
            pricePerProduct: product.price,
            totalAmount: subTotal,
            statusId: Status.Active,
            pickedQty: soQty ? soQty : product.pickedQty ? product.pickedQty : product.ordQty,
            packedQty: soQty ? soQty : product.packedQty ? product.packedQty : product.ordQty,
            shippedQty: 0,
            salesOrderSerialDetail: null,
            salesOrderBundleDetail: bundleItems && bundleItems?.length > 0 ? bundleItems : [],
            taxAmount: applicableTax,
            taxRate: applicableTax,
            discountAmount: applicableDiscount,
            discountTypeId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked && product.discountType ? (product.discountType?.discountBy ?? 0) : 0,
            discountType: "",
            discountFinancialId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked && product.discountType?.id ? this.discountOptions?.filter((discount) => discount.id == product.discountType?.id).map((value) => value.incomeAccount)[0] : this.discountOptions?.filter((discount) => discount.id == this.soForm?.controls["discountType"]?.value?.id).map((value) => value.incomeAccount)[0],
            discountId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked && product.discountType?.id ? this.discountOptions?.filter((discount) => discount.id == product.discountType?.id).map((value) => value?.id)[0] : this.discountOptions?.filter((discount) => discount.id == this.soForm?.controls["discountType"]?.value?.id).map((value) => value?.id)[0],
            discountRate: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? (product.discount ?? 0) : 0,
            discountName: "",
            taxId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && product.taxType ? product.taxType.id : 0,
            taxName: "",
            taxRateTypeId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && product.taxType ? product.taxType.typeId : 0,
            taxFinancialId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && product.taxType ? product.taxType.financialAccountId : 0,
            totalQty: qty,
            binId: this.templates?.labels_table[11].isChecked ? (product.selectedBin ? product.selectedBin?.binId : 0) : 0,
            salesOrderProductSubTax: this.footerTaxEnabled ? product.typeId != TypeIds.BundleTypeId ? this.prepareBackOrderProductsSubtaxCode(product.productSubTax, product.ordQty, product.price, product) : [] : [],
            subTotal: baseSubTotal,
            isPicked: false,
            isPacked: false,
            backOrderQty: 0,
            isCopied: product.isDuplicatedProduct ?? false,
            additionalFeesId: this.templates?.labels_table[15]?.isChecked ? (product?.additionalFeeType?.id ?? 0) : 0,
            additionalRate: this.templates?.labels_table[15]?.isChecked ? (product?.additionalFee ?? 0) : 0,
            additionalAmount: this.templates?.labels_table[15]?.isChecked ? (product?.additionalFeeAmount ?? 0) : 0,
            additionalFeesFinancialId: this.templates?.labels_table[15]?.isChecked ? (product?.additionalFeeType?.incomeAccount ?? 0) : 0,
            costPrice: product.costPrice ?? 0,
            totalCostPrice: Number(qty) * Number(uomValue) * Number(product.costPrice ?? 0),
        };
        return soProduct;
    }

    prepareInvoiceProductsList(product, invQty = 0, bundleItems = []): IInvoiceProduct {
        const uomValue = product?.unit?.uomDetail?.value || 1;
        const invoiceSerialDetailsArr = this.prepareInvoiceProductsSerialDetails(product);
        let qty = invQty ? invQty : product.pickedQty ? product.pickedQty : product.ordQty;
        qty = qty * Number(uomValue);
        let subTotal = Number(qty) * Number(uomValue) * Number(product.price);
        let baseSubTotal = subTotal;

        /** Tax and Discount */
        let applicableDiscount = 0;
        let applicableTax = 0;
        let appliedDiscount = this.discountOptions?.find((discount) => discount.id == product?.discountType?.id);
        /** If checked, sale tax will be calculated on the order total after discount has been applied. */
        if (appliedDiscount && appliedDiscount.isTaxable) {
            applicableDiscount = this.utilityService.calculateProductWiseDiscount(product?.discountType, subTotal, product.discount);
            if (this.footerDiscountEnabled) {
                subTotal -= applicableDiscount;
            }
            // additional fee
            if (this.templates?.labels_table[15]?.isChecked && product?.additionalFeeType?.isTaxable) {
                let addFee = this.utilityService.calculateProductWiseAdditionalFee(product?.additionalFeeType?.type?.name, subTotal, product.additionalFee);
                product.additionalFeeAmount = addFee;
                subTotal = subTotal + Number(addFee);
            }
            applicableTax = this.isVisibleRowTax ? this.utilityService.getProductsTotalTax(product, this.allTaxRates, subTotal, this.shippingAddressInfo?.address?.zipCode, this.shippingAddressInfo?.address?.stateId, this.taxSettings, this.taxConfig) : 0;
            if (this.footerTaxEnabled) {
                subTotal += applicableTax;
            }
            // additional fee
            if (this.templates?.labels_table[15]?.isChecked && !product?.additionalFeeType?.isTaxable) {
                let addFee = this.utilityService.calculateProductWiseAdditionalFee(product?.additionalFeeType?.type?.name, subTotal, product.additionalFee);
                product.additionalFeeAmount = addFee;
                subTotal = subTotal + Number(addFee);
            }
        } else {
            // additional fee
            if (this.templates?.labels_table[15]?.isChecked && product?.additionalFeeType?.isTaxable) {
                let addFee = this.utilityService.calculateProductWiseAdditionalFee(product?.additionalFeeType?.type?.name, subTotal, product.additionalFee);
                product.additionalFeeAmount = addFee;
                subTotal = subTotal + Number(addFee);
            }
            applicableTax = this.isVisibleRowTax ? this.utilityService.getProductsTotalTax(product, this.allTaxRates, subTotal, this.shippingAddressInfo?.address?.zipCode, this.shippingAddressInfo?.address?.stateId, this.taxSettings, this.taxConfig) : 0;
            if (this.footerTaxEnabled) {
                subTotal += applicableTax;
            }
            applicableDiscount = this.utilityService.calculateProductWiseDiscount(product?.discountType, subTotal, product.discount);
            if (this.footerDiscountEnabled) {
                subTotal -= applicableDiscount;
            }
            // additional fee
            if (this.templates?.labels_table[15]?.isChecked && !product?.additionalFeeType?.isTaxable) {
                let addFee = this.utilityService.calculateProductWiseAdditionalFee(product?.additionalFeeType?.type?.name, subTotal, product.additionalFee);
                product.additionalFeeAmount = addFee;
                subTotal = subTotal + Number(addFee);
            }
        }

        // let productsTotalTax = this.utilityService.getProductsTotalTax(product, this.allTaxRates, subTotal);
        // let discount = this.calculateProductsDiscount(product?.discountType, qty, product.price, product.discount);
        // let pTotal = subTotal + productsTotalTax - discount;

        const invoiceProduct: IInvoiceProduct = {
            id: 0,
            createdSource: this.app.userIP,
            updatedSource: this.app.userIP,
            createdBy: this.app.user.userId,
            updatedBy: this.app.user.userId,
            createdDate: this.app._saveDateTimeWithZone(new Date()),
            updatedDate: this.app._saveDateTimeWithZone(new Date()),
            description: product.description,
            invoiceId: 0,
            productId: product.id,
            productUOMId: product.unit && product.unit.unitOfMeasureId ? product.unit.unitOfMeasureId : 0,
            availableQuantity: product.availabel ?? 0,
            quantity: invQty ? invQty : product.pickedQty ? product.pickedQty : product.ordQty,
            shippedQty: invQty ? invQty : product.pickedQty ? product.pickedQty : product.ordQty,
            pricePerProduct: product.price,
            totalAmount: subTotal,
            subTotal: baseSubTotal,
            statusId: Status.Active,
            invoiceProductSerialDetail: invoiceSerialDetailsArr && invoiceSerialDetailsArr.length > 0 ? invoiceSerialDetailsArr : null,
            binId: this.templates?.labels_table[11].isChecked ? (product.selectedBin ? product.selectedBin?.binId : 0) : 0,
            invoiceBundleDetail: bundleItems && bundleItems.length > 0 ? bundleItems : [],
            discountTypeId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked && product.discountType ? (product.discountType?.discountBy ?? 0) : 0,
            discountType: "",
            discountAmount: applicableDiscount,
            discountFinancialId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked && product.discountType?.id ? this.discountOptions?.filter((discount) => discount.id == product.discountType?.id).map((value) => value.incomeAccount)[0] : 0,
            discountId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked && product.discountType?.id ? this.discountOptions?.filter((discount) => discount.id == product.discountType?.id).map((value) => value?.id)[0] : 0,
            discountRate: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? (product.discount ?? 0) : 0,
            discountName: "",
            taxId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && product.taxType ? product.taxType.id : 0,
            taxAmount: applicableTax,
            taxRate: applicableTax,
            taxName: "",
            taxRateTypeId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && product.taxType ? product.taxType.typeId : 0,
            taxFinancialId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && product.taxType ? product.taxType.financialAccountId : 0,
            totalQty: qty,
            invoiceProductSubTax: this.footerTaxEnabled ? (product.typeId != TypeIds.BundleTypeId ? this.prepareInvoiceProductsSubtaxCode(product.productSubTax, product.ordQty, product.price, product) : []) : [],
            itemNo: product?.itemNo ?? "",
            isCopied: product?.isDuplicatedProduct ?? false,
            returnedQty: 0,
            additionalFeesId: this.templates?.labels_table[15]?.isChecked ? (product?.additionalFeeType?.id ?? 0) : 0,
            additionalRate: this.templates?.labels_table[15]?.isChecked ? (product?.additionalFee ?? 0) : 0,
            additionalAmount: this.templates?.labels_table[15]?.isChecked ? (product?.additionalFeeAmount ?? 0) : 0,
            additionalFeesFinancialId: this.templates?.labels_table[15]?.isChecked ? (product?.additionalFeeType?.incomeAccount ?? 0) : 0,
            costPrice: product.costPrice ?? 0,
            totalCostPrice: Number(qty) * Number(uomValue) * Number(product.costPrice ?? 0),
        };
        return invoiceProduct;
    }

    prepareInvoiceBundleProductsList(e, product, qty = 0): IInvoiceBundleProduct {
        const uomValue = e && e.unit && e.unit.uomDetail && e.unit.uomDetail.value ? e.unit.uomDetail.value : 1;
        const invoiceBundleProduct: IInvoiceBundleProduct = {
            id: 0,
            createdSource: this.app.userIP,
            updatedSource: this.app.userIP,
            createdBy: this.app.user.userId,
            updatedBy: this.app.user.userId,
            createdDate: this.app._saveDateTimeWithZone(new Date()),
            updatedDate: this.app._saveDateTimeWithZone(new Date()),
            description: e.description,
            invoiceId: 0,
            productId: product.id,
            subproductId: e.id,
            parentBundleId: 0,
            parentProductId: 0,
            productUOMId: e.unit && e.unit.unitOfMeasureId ? e.unit.unitOfMeasureId : 0,
            availableQuantity: e.availabel ?? 0,
            quantity: qty ? qty : e.ordQty,
            pricePerProduct: e["price"],
            totalAmount: qty ? qty * Number(uomValue) * e.price : e.ordQty * Number(uomValue) * e.price,
            subTotal: qty * Number(uomValue) * e.price,
            discountTypeId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked && e.discountType ? (e.discountType.discountBy ?? 0) : 0,
            discountType: "",
            discountAmount: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? e.discountAmount : 0,
            discountFinancialId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? this.discountOptions?.filter((discount) => discount.id == e.discountType?.id).map((value) => value.incomeAccount)[0] : this.discountOptions?.filter((discount) => discount.id == this.soForm?.controls["discountType"]?.value?.id).map((value) => value.incomeAccount)[0],
            discountId: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? this.discountOptions?.filter((discount) => discount.id == e.discountType?.id).map((value) => value?.id)[0] : this.discountOptions?.filter((discount) => discount.id == this.soForm?.controls["discountType"]?.value?.id).map((value) => value?.id)[0],
            discountRate: this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked ? (e.discount ?? 0) : 0,
            discountName: "",
            taxId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && e.taxType ? e.taxType.id : 0,
            taxAmount: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked ? e.taxAmount : 0,
            taxRate: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked ? e.taxAmount : 0,
            taxName: "",
            taxRateTypeId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && e.taxType ? e.taxType.typeId : 0,
            taxFinancialId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && e.taxType ? e.taxType.financialAccountId : 0,
            statusId: Status.Active,
            invoiceproductId: 0,
            invoiceBundleProductSerialDetail: e.invoiceBundleProductSerialDetail && e.invoiceBundleProductSerialDetail.length > 0 ? e.invoiceBundleProductSerialDetail : null,
            binId: this.templates?.labels_table[11].isChecked ? (e.selectedBin ? e.selectedBin?.binId : 0) : 0,
            totalQty: qty ? qty * Number(uomValue) : Number(e.ordQty) * Number(uomValue),
            shippedQty: qty ? qty * Number(uomValue) : Number(e.ordQty) * Number(uomValue),
            invoiceBundleDetailSubTax: product.typeId == TypeIds.KitTypeId ? this.prepareInvoiceProductsSubtaxCode(product.productSubTax, product.ordQty, product.price, product) : this.prepareInvoiceProductsSubtaxCode(e.bundleDetailSubTax, e.ordQty, e.price, product, e),
            itemNo: e?.itemNo ?? "",
            isCopied: e?.isDuplicatedProduct ?? false,
            returnedQty: 0,
            additionalFeesId: this.templates?.labels_table[15]?.isChecked ? (e?.additionalFeeType?.id ?? 0) : 0,
            additionalRate: this.templates?.labels_table[15]?.isChecked ? (e?.additionalFee ?? 0) : 0,
            additionalAmount: this.templates?.labels_table[15]?.isChecked ? (e?.additionalFeeAmount ?? 0) : 0,
            additionalFeesFinancialId: this.templates?.labels_table[15]?.isChecked ? (e?.additionalFeeType?.incomeAccount ?? 0) : 0,
            costPrice: e.costPrice ?? 0,
            totalCostPrice: qty ? qty * Number(uomValue) * (e.costPrice ?? 0) : e.ordQty * Number(uomValue) * (e.costPrice ?? 0),
        };
        return invoiceBundleProduct;
    }

    isVisibleBackOrderSelectionDialog() {
        if (this.selectedBackOrderOption == BackOrderOptions.NONE) {
            let isVisibleBackOrder = this.soStageChangeService.isVisibleBackOrderSelectionDialog(this.soDetails, this.isEnabledBackOrder, this.isEnabledBackOrderKit, this.isEnabledBackOrderBundle);
            if (isVisibleBackOrder) {
                this.displayBackOrderOption = true;
            } else {
                const isValid = this.utilityService.checkvalidation(this.combinedCustomFields);
                if (this.type && this.type == DialogType.EDIT && isValid) {
                    this.isDisabledSaveBtn = true;
                    this.createInvoice();
                }
            }
        } else {
            const isValid = this.utilityService.checkvalidation(this.combinedCustomFields);
            if (this.type && this.type == DialogType.EDIT && isValid) {
                this.isDisabledSaveBtn = true;
                if (this.selectedBackOrderOption == BackOrderOptions.SHIP) {
                    this.createInvoice();
                } else if (this.selectedBackOrderOption == BackOrderOptions.BACK_ORDER) {
                    this.createBackOrder();
                } else if (this.selectedBackOrderOption == BackOrderOptions.HOLD) {
                    this.displayConvertToSalesOrder = false;
                    this.onHoldSO.emit("");
                }
            }
        }
    }

    /** End Sales Order To Invoice */

    setCheckBoxValue(value) {
        const checkBox: any[] = [];
        value.forEach((element) => {
            const val = { name: element };
            checkBox.push(val);
        });
        return checkBox;
    }

    onCustomUpload(files: File[], field) {
        if (typeof Worker !== undefined) {
            for (let file of files) {
                let errors = validateFiles(file, 4, this.allowedExtensions);
                if (errors.length > 0) {
                    for (let error of errors) {
                        this.messageService.add({
                            severity: "error",
                            summary: "Error",
                            detail: error.fileName + ": " + error.error,
                        });
                    }
                } else {
                    uploadFiles(file, ({ name, content, size, extension }) => {
                        let attachment = {
                            name: name,
                            content: content,
                            extension: extension,
                            sizeInBytes: size,
                        };
                        field.customUploadedFiles.push(attachment);
                    });
                }
            }
        } else {
            this.messageService.add({
                severity: "error",
                summary: "Error",
                detail: "Please update the browser. Web Workers are not supported in the older versions of this browser.",
            });
        }
    }

    onChangeStage(event) {
        /** Sales Order can not be moved to any other stage if account credit is not available enough */
        if (event?.value?.name?.toLowerCase() != "entered" && (this.type == DialogType.EDIT || this.type == DialogType.CONVERT)) {
            this.isAvailableEnoughAccCredit = this.utilityService.checkAvailabilityOfAccountCredit(this.soDetails?.account?.availableCredit, this.soDetails?.netAmount, this.soDetails?.account?.accountCreditEnabled, this.soDetails?.account?.accountCreditControlId);
        } else {
            this.isAvailableEnoughAccCredit = true;
        }
        const selectedStageId = this.soForm?.controls["salesOrderStage"].value?.id;
        this.allStatus = this.allStages.filter((s) => s.id == selectedStageId)[0].status;
    }
    onChangeLocation() {
        if (this.type == DialogType.COPY) {
            this.onChangeAccountUpdateProducts();
        }
    }

    onChangeStatus() {
        /**
         * If status is hold or cancel
         * user is not allowed to perform stage change
         */
        // const st = this.soForm?.controls?.salesOrderStatus.value;
        // if (st.name == "Hold" || st.name == "Cancel") {
        //     this.soForm?.controls?.salesOrderStage.disable();
        // } else {
        //     this.soForm?.controls?.salesOrderStage.enable();
        // }
    }

    onDialogClose() {
        this.displayConvertToSalesOrder = false;
        this.onCancelClicked.emit(false);
    }

    confirmVoid() {
        this.confirmationService.confirm({
            message: "Do you want to void this Sales Order?",
            header: "Void Confirmation",
            icon: "pi pi-info-circle",
            accept: () => {
                if (this.statementMessege) {
                    this.messageService.add({ severity: Severity.Warn, summary: this.titlecasePipe.transform(Severity.Warn), detail: ClosingYearDisplayMessages.voidDeleteMessage });
                } else {
                    this.displayConvertToSalesOrder = false;
                    this.onVoidSO.emit(this.soDetails.id);
                }
            },
            reject: () => {},
        });
    }

    openWarehouseList(c) {
        this.displayOpenWarehouseList = true;
        this.warehouseLists = c.warehouseList;
        this.selectedWarehouseList = [];
    }

    addWarehouse() {
        this.displayOpenWarehouseList = false;
        this.purchaseListTB.forEach((p) => {
            const filteredProduct = this.selectedWarehouseList.filter((s) => s.productId == p.id)[0];
            if (filteredProduct && p.id == filteredProduct.productId) {
                let qoh = 0;
                let avail = 0;
                let codes = "";
                this.selectedWarehouseList.forEach((e, index) => {
                    avail += e.availQty;
                    qoh += e.qtyOnHand;
                    codes += e.warehouseName + ",";
                });
                p.selectedWarehouseList = this.selectedWarehouseList;
                p.selectedWarehouseCode = codes.slice(0, codes.length - 1);
                p.totalAvailInSelectedWareHouse = avail;
                p.totalQohInSelectedWareHouse = qoh;
            }
        });
    }

    checkRequired(name, cf_list) {
        return cf_list.find((el) => el.name === name)?.isRequired || false;
    }

    /**Tracking SerialNo**/

    openScanInfo(product) {
        this.allChecked = false;
        this.importForAllProducts = false;
        this.isPrefix = false;
        this.prefixValue = "";
        this.refId = '';
        this.isAutoGenerated = false;
        this.nameLists = [];
        this.autoGenerateLists = [];
        this.productHeader = product.itemNo;
        this.selectedProductForScan = _.cloneDeep(product);
        this.productSerialSettings = product.serialSettings;
        this.prepareTrackingForm();
        this.selectedBundleForScan = null;
        this.selectedKitForScan = null;
        this.displayScanInfo = true;
        this.scanQty = this.stageId == SoStageId.Entered ? Number(product.ordQty) : this.stageId == SoStageId.Pick ? Number(product.pickedQty) : Number(product.packedQty);
        const data = product.salesOrderSerialDetails && product.salesOrderSerialDetails.length > 0 ? product.salesOrderSerialDetails[0] : null;
        this.trackingForm.patchValue({
            lotNo: data?.lotNumber ? data.lotNumber : "",
            revisionNo: data?.revisionNumber ? data.revisionNumber : "",
            expiration: data?.expirationDate ? new Date(data.expirationDate) : null,
        });
        const arr: any[] = [];
        if (product.salesOrderSerialDetails && product.salesOrderSerialDetails.length > 0) {
            product.salesOrderSerialDetails.forEach((element) => {
                const obj = {
                    id: element.id,
                    serialNo: element.barcode,
                    serialNo2: element.serialNumber2,
                    serialNo3: element.serialNumber3,
                    serialNo4: element.serialNumber4,
                    serialNo5: element.serialNumber5,
                    serialNo6: element.serialNumber6,
                    serialNo7: element.serialNumber7,
                    serialNo8: element.serialNumber8,
                    serialNo9: element.serialNumber9,
                    serialNo10: element.serialNumber10,
                    serialNo11: element.serialNumber11,
                    serialNo12: element.serialNumber12,
                    serialNo13: element.serialNumber13,
                    serialNo14: element.serialNumber14,
                    serialNo15: element.serialNumber15,
                    serialNo16: element.serialNumber16,
                    serialNo17: element.serialNumber17,
                    lotNo: element.lotNumber,
                    revisionNo: element.revisionNumber,
                    expiration: element.expirationDate,
                    systemPresent: true,
                    referenceId: this.refId
                };
                arr.push(obj);
            });
        }
        this.autoGenerateLists = arr;
        this.nameLists = this.autoGenerateLists.slice(0, 100);
        this.listLength = this.autoGenerateLists.length;
        this.totalTBRecord = this.listLength;
        this.checkSerialNoInSystem(this.selectedProductForScan?.id, this.selectedProductForScan.warehouseId, this.selectedOrder?.id || 0);
        // Apply the custom validator after initializing the form
        if (!this.utilService.hasRequiredValidator(this.trackingForm)) {
            this.trackingForm.setValidators(this.utilService.atLeastOneFieldValidator(["lotNo", "revisionNo", "expiration", "serialNo", "serialNo2", "serialNo3", "serialNo4", "serialNo5", "serialNo6", "serialNo7", "serialNo8", "serialNo9", "serialNo10", "serialNo11", "serialNo12", "serialNo13", "serialNo14", "serialNo15", "serialNo16", "serialNo17"]));
            this.trackingForm.updateValueAndValidity(); // Ensure validation is applied
        }
        this.trackingForm.controls['qty'].setValue(this.selectedProductForScan?.ordQty - this.listLength);
    }

    openScanInfoForBundle(bundle, product, mainProduct?) {
        this.allChecked = false;
        this.importForAllProducts = false;
        this.nameLists = [];
        this.autoGenerateLists = [];
        this.selectedProductForScan = _.cloneDeep(product);
        this.selectedBundleForScan = _.cloneDeep(bundle);
        this.selectedKitForScan = _.cloneDeep(mainProduct);
        this.productSerialSettings = product.serialSettings;
        this.prepareTrackingForm();
        this.displayScanInfo = true;
        this.scanQty = this.stageId == SoStageId.Entered ? Number(product.ordQty) : this.stageId == SoStageId.Pick ? Number(product.pickedQty) : Number(product.packedQty);
        const data = product.salesOrderBundleProductSerialDetail && product.salesOrderBundleProductSerialDetail.length > 0 ? product.salesOrderBundleProductSerialDetail[0] : null;
        this.trackingForm.patchValue({
            lotNo: data?.lotNumber ? data.lotNumber : "",
            revisionNo: data?.revisionNumber ? data.revisionNumber : "",
            expiration: data?.expirationDate ? new Date(data.expirationDate) : null,
        });
        const arr: any[] = [];
        if (product.salesOrderBundleProductSerialDetail && product.salesOrderBundleProductSerialDetail.length > 0) {
            product.salesOrderBundleProductSerialDetail.forEach((element) => {
                const obj = {
                    id: element.id,
                    serialNo: element.barcode,
                    serialNo2: element.serialNumber2,
                    serialNo3: element.serialNumber3,
                    serialNo4: element.serialNumber4,
                    serialNo5: element.serialNumber5,
                    serialNo6: element.serialNumber6,
                    serialNo7: element.serialNumber7,
                    serialNo8: element.serialNumber8,
                    serialNo9: element.serialNumber9,
                    serialNo10: element.serialNumber10,
                    serialNo11: element.serialNumber11,
                    serialNo12: element.serialNumber12,
                    serialNo13: element.serialNumber13,
                    serialNo14: element.serialNumber14,
                    serialNo15: element.serialNumber15,
                    serialNo16: element.serialNumber16,
                    serialNo17: element.serialNumber17,
                    lotNo: element.lotNumber,
                    revisionNo: element.revisionNumber,
                    expiration: element.expirationDate,
                    systemPresent: true,
                    referenceId: this.refId
                };
                arr.push(obj);
            });
        }
        this.autoGenerateLists = arr;
        this.nameLists = this.autoGenerateLists.slice(0, 100);
        this.listLength = this.autoGenerateLists.length;
        this.totalTBRecord = this.listLength;
        this.checkSerialNoInSystem(this.selectedProductForScan?.id, this.selectedProductForScan.warehouseId, this.selectedOrder?.id || 0);
        // Apply the custom validator after initializing the form
        if (!this.utilService.hasRequiredValidator(this.trackingForm)) {
            this.trackingForm.setValidators(this.utilService.atLeastOneFieldValidator(["lotNo", "revisionNo", "expiration", "serialNo", "serialNo2", "serialNo3", "serialNo4", "serialNo5", "serialNo6", "serialNo7", "serialNo8", "serialNo9", "serialNo10", "serialNo11", "serialNo12", "serialNo13", "serialNo14", "serialNo15", "serialNo16", "serialNo17"]));
            this.trackingForm.updateValueAndValidity(); // Ensure validation is applied
        }
        this.trackingForm.controls['qty'].setValue(this.selectedProductForScan?.ordQty - this.listLength);
    }

    prepareTrackingForm() {
        const qty = this.selectedProductForScan?.totalQuantity;
        this.trackingForm = this.fb.group({
            qty: [qty - this.listLength, [Validators.required]],
            lotNo: [""],
            revisionNo: [""],
            expiration: [""],
            serialNo: [""],
            serialNo2: [""],
            serialNo3: [""],
            serialNo4: [""],
            serialNo5: [""],
            serialNo6: [""],
            serialNo7: [""],
            serialNo8: [""],
            serialNo9: [""],
            serialNo10: [""],
            serialNo11: [""],
            serialNo12: [""],
            serialNo13: [""],
            serialNo14: [""],
            serialNo15: [""],
            serialNo16: [""],
            serialNo17: [""],
            packageBarcode: [""],
        });
        /**set validation for Tracking form**/
        for (let opt of this.trackingOptions) {
            if (opt.enabled && (this.productSerialSettings ? this.productSerialSettings[`${opt.code}`] : true)) {
                if (opt.field !== "serialNo" && opt.isRequired) {
                    this.trackingForm?.get(`${opt.field}`).setValidators(Validators.required);
                } else if (opt.field === "serialNo" && opt.isRequired) {
                    if (this.utilityService.displayName("serializedChecked", this.trackingOptions, "control") == "InputBox") {
                        this.trackingForm?.get(`${opt.field}`).setValidators([Validators.required, Validators.pattern(/^[A-Za-z0-9-]*$/)]);
                    } else {
                        this.trackingForm?.get(`${opt.field}`).setValidators([Validators.required]);
                    }
                } else {
                    this.trackingForm?.get(`${opt.field}`).clearValidators();
                }
                this.trackingForm?.get(`${opt.field}`).updateValueAndValidity();
            }
        }
    }

    countNameList(value) {
        if (this.trackingForm.valid && this.listLength < this.scanQty) {
            if (value.serialNo) {
                value.serialNo = this.isPrefix ? this.prefixValue.concat(value.serialNo) : value.serialNo;
                const duplicate = this.autoGenerateLists?.filter((sr) => sr.serialNo == value.serialNo);
                for (let prd of this.purchaseListTB) {
                    const prdDuplicate = prd.salesOrderSerialDetails?.filter((sNo) => sNo.barcode == value.serialNo);
                    if (prdDuplicate?.length > 0) {
                        this.messageService.add({
                            severity: "error",
                            summary: "Error",
                            detail: "Duplicate serialNo found.",
                        });
                        return;
                    }
                    //bundle items
                    if (prd.bundleDetails?.length > 0) {
                        for (let bundle of prd.bundleDetails) {
                            const bundleDuplicate = bundle.salesOrderBundleProductSerialDetail?.filter((sNo) => sNo.barcode == value.serialNo);
                            if (bundleDuplicate?.length > 0) {
                                this.messageService.add({ severity: "error", summary: "Error", detail: "Duplicate serialNo found." });
                                return;
                            }
                            //kit under kit items
                            if (bundle.bundleDetails?.length > 0) {
                                for (let kp of bundle.bundleDetails) {
                                    const kitDuplicate = kp.salesOrderBundleProductSerialDetail?.filter((sNo) => sNo.barcode == value.serialNo);
                                    if (kitDuplicate?.length > 0) {
                                        this.messageService.add({ severity: "error", summary: "Error", detail: "Duplicate serialNo found." });
                                        return;
                                    }
                                }
                            }
                        }
                    }
                }
                if (duplicate?.length > 0) {
                    this.messageService.add({
                        severity: "error",
                        summary: "Error",
                        detail: "Serial No you tried to enter is already present in below list.",
                    });
                } else {
                    const present = this.systemTrackingData?.find((depOb) => depOb.serialNo == value.serialNo);
                    if (present) {
                        value.systemPresent = true;
                        value.checked = false;
                        this.autoGenerateLists.push(value);
                        this.nameLists = this.autoGenerateLists.slice(0, 100);
                        this.listLength = this.listLength + 1;
                        this.totalTBRecord = this.listLength;
                        this.trackingForm.controls['qty'].setValue(this.selectedProductForScan?.ordQty - this.listLength);
                    } else {
                        this.checkSerialsForSystem(this.trackingForm.controls["serialNo"].value, this.selectedProductForScan?.id, this.selectedProductForScan.warehouseId, value);
                    }
                }
            } else {
                const totalQty = this.selectedProductForScan?.totalQuantity;
                for (let i = 0; i < value.qty; i++) {
                    if (this.listLength < totalQty) {
                        this.autoGenerateLists.push({ ...value });
                        this.listLength++;
                    }
                }
                this.nameLists = this.autoGenerateLists.slice(0, 100);
                this.totalTBRecord = this.listLength;
                this.trackingForm.controls["qty"].setValue(totalQty - this.listLength);
            }
        }
        const controlNames = Object.keys(this.trackingForm.controls);
        for (let ctrl of controlNames) {
            if (this.trackingOptions?.find((el) => el.field === ctrl)?.clearField) {
                this.trackingForm.controls[`${ctrl}`].setValue("");
            }
        }
    }

    checkSerialsForSystem(serialNo, productIds, warehouseId, value) {
        this.salesOrderService
            .checkSerialNoInAllSystem(serialNo, warehouseId, productIds)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((res) => {
                if (!this.serialConfig?.childInventorySettings[0]?.enabled) {
                    if (res.allowSave) {
                        value.systemPresent = false;
                        value.checked = true;
                        this.autoGenerateLists.push(value);
                        this.nameLists = this.autoGenerateLists.slice(0, 100);
                        this.listLength = this.listLength + 1;
                        this.totalTBRecord = this.listLength;
                    } else if (!res.allowSave || !res.isMatched) {
                        this.messageService.add({ severity: "error", summary: "Error", detail: `${res.message}` });
                    } else {
                        this.messageService.add({ severity: "error", summary: "Error", detail: "SerialNo you tried to import is not a part of this order and associated with other product,you can't add." });
                    }
                } else {
                    //auto-remove unmatched while save button
                    value.systemPresent = false;
                    value.checked = true;
                    value.remove = true;
                    this.autoGenerateLists.push(value);
                    this.nameLists = this.autoGenerateLists.slice(0, 100);
                    this.listLength = this.listLength + 1;
                    this.totalTBRecord = this.listLength;
                }
                this.trackingForm.controls['qty'].setValue(this.selectedProductForScan?.ordQty - this.listLength);
            });
    }

    removeNumber(i) {
        this.nameLists.splice(i, 1);
        this.autoGenerateLists.splice(i, 1);
        this.nameLists = this.autoGenerateLists.slice(0, 100);
        this.listLength--;
        this.totalTBRecord = this.listLength;
        this.unMatchedSerials = this.autoGenerateLists?.filter((sr) => !sr.systemPresent);
        this.trackingForm.controls['qty'].setValue(this.selectedProductForScan?.ordQty - this.listLength);
    }

    deleteAll() {
        this.nameLists = [];
        this.autoGenerateLists = [];
        this.listLength = 0;
        this.totalTBRecord = 0;
        this.trackingForm.controls['qty'].setValue(this.selectedProductForScan?.ordQty - this.listLength);
    }

    saveSerializedNo(c) {
        if (this.serialConfig?.childInventorySettings[0]?.enabled) {
            const arrayList = JSON.parse(JSON.stringify(this.autoGenerateLists));
            for (let serial of arrayList) {
                if (serial.remove) {
                    const index = this.autoGenerateLists?.indexOf(serial);
                    this.autoGenerateLists.splice(index, 1);
                }
            }
        }
        // bundle items
        if (this.selectedBundleForScan && this.selectedBundleForScan.typeId && (this.selectedBundleForScan.typeId == TypeIds.BundleTypeId || this.selectedBundleForScan.typeId == TypeIds.KitTypeId)) {
            this.purchaseListTB.forEach((element) => {
                if (element.id == this.selectedBundleForScan.id) {
                    element.bundleDetails.forEach((b) => {
                        if (this.type == DialogType.CREATE) {
                            if (b.id == this.selectedProductForScan.id) {
                                b.salesOrderBundleProductSerialDetail = [];
                                this.autoGenerateLists.forEach((nl) => {
                                    const obj = {
                                        id: 0,
                                        createdSource: this.app.userIP,
                                        updatedSource: this.app.userIP,
                                        createdBy: this.app.userId,
                                        updatedBy: this.app.userId,
                                        createdDate: this.app._saveDateTimeWithZone(new Date()),
                                        updatedDate: this.app._saveDateTimeWithZone(new Date()),
                                        salesOrderId: 0,
                                        salesOrderProductId: 0,
                                        barcode: nl.serialNo,
                                        serialNumber2: nl.serialNo2,
                                        serialNumber3: nl.serialNo3,
                                        serialNumber4: nl.serialNo4,
                                        serialNumber5: nl.serialNo5,
                                        serialNumber6: nl.serialNo6,
                                        serialNumber7: nl.serialNo7,
                                        serialNumber8: nl.serialNo8,
                                        serialNumber9: nl.serialNo9,
                                        serialNumber10: nl.serialNo10,
                                        serialNumber11: nl.serialNo11,
                                        serialNumber12: nl.serialNo12,
                                        serialNumber13: nl.serialNo13,
                                        serialNumber14: nl.serialNo14,
                                        serialNumber15: nl.serialNo15,
                                        serialNumber16: nl.serialNo16,
                                        serialNumber17: nl.serialNo17,
                                        lotNumber: nl.lotNo,
                                        revisionNumber: nl.revisionNo,
                                        expirationDate: nl.expiration,
                                        statusId: Status.Active,
                                        shipped: true,
                                        systemPresent: nl.systemPresent,
                                        referenceId: this.refId
                                    };
                                    b.salesOrderBundleProductSerialDetail.push(obj);
                                });
                            }
                        } else {
                            if (b.rowId == this.selectedProductForScan.rowId) {
                                b.salesOrderBundleProductSerialDetail = [];
                                this.autoGenerateLists.forEach((nl) => {
                                    const obj = {
                                        id: this.type == DialogType.EDIT ? (nl?.id ? nl.id : 0) : 0,
                                        createdSource: this.app.userIP,
                                        updatedSource: this.app.userIP,
                                        createdBy: this.app.userId,
                                        updatedBy: this.app.userId,
                                        createdDate: this.app._saveDateTimeWithZone(new Date()),
                                        updatedDate: this.app._saveDateTimeWithZone(new Date()),
                                        salesOrderId: 0,
                                        salesOrderProductId: this.type == DialogType.EDIT ? element?.rowId : 0,
                                        salesOrderBundleDetailId: b.rowId ? b.rowId : 0,
                                        barcode: nl.serialNo,
                                        serialNumber2: nl.serialNo2,
                                        serialNumber3: nl.serialNo3,
                                        serialNumber4: nl.serialNo4,
                                        serialNumber5: nl.serialNo5,
                                        serialNumber6: nl.serialNo6,
                                        serialNumber7: nl.serialNo7,
                                        serialNumber8: nl.serialNo8,
                                        serialNumber9: nl.serialNo9,
                                        serialNumber10: nl.serialNo10,
                                        serialNumber11: nl.serialNo11,
                                        serialNumber12: nl.serialNo12,
                                        serialNumber13: nl.serialNo13,
                                        serialNumber14: nl.serialNo14,
                                        serialNumber15: nl.serialNo15,
                                        serialNumber16: nl.serialNo16,
                                        serialNumber17: nl.serialNo17,
                                        lotNumber: nl.lotNo,
                                        revisionNumber: nl.revisionNo,
                                        expirationDate: nl.expiration,
                                        statusId: Status.Active,
                                        shipped: true,
                                        systemPresent: nl.systemPresent,
                                        referenceId: this.refId
                                    };
                                    b.salesOrderBundleProductSerialDetail.push(obj);
                                });
                            }
                        }
                    });
                } else {
                    //kit under kit
                    for (let element of this.purchaseListTB) {
                        if (element.id == this.selectedKitForScan?.id) {
                            element.bundleDetails.forEach((k) => {
                                if (k.id == this.selectedBundleForScan.id) {
                                    for (let kp of k.bundleDetails) {
                                        if (this.type == DialogType.CREATE) {
                                            if (kp.id == this.selectedProductForScan.id) {
                                                kp.salesOrderBundleProductSerialDetail = [];
                                                this.autoGenerateLists.forEach((nl) => {
                                                    const obj = {
                                                        id: 0,
                                                        createdSource: this.app.userIP,
                                                        updatedSource: this.app.userIP,
                                                        createdBy: this.app.userId,
                                                        updatedBy: this.app.userId,
                                                        createdDate: this.app._saveDateTimeWithZone(new Date()),
                                                        updatedDate: this.app._saveDateTimeWithZone(new Date()),
                                                        salesOrderId: 0,
                                                        salesOrderProductId: 0,
                                                        barcode: nl.serialNo,
                                                        serialNumber2: nl.serialNo2,
                                                        serialNumber3: nl.serialNo3,
                                                        serialNumber4: nl.serialNo4,
                                                        serialNumber5: nl.serialNo5,
                                                        serialNumber6: nl.serialNo6,
                                                        serialNumber7: nl.serialNo7,
                                                        serialNumber8: nl.serialNo8,
                                                        serialNumber9: nl.serialNo9,
                                                        serialNumber10: nl.serialNo10,
                                                        serialNumber11: nl.serialNo11,
                                                        serialNumber12: nl.serialNo12,
                                                        serialNumber13: nl.serialNo13,
                                                        serialNumber14: nl.serialNo14,
                                                        serialNumber15: nl.serialNo15,
                                                        serialNumber16: nl.serialNo16,
                                                        serialNumber17: nl.serialNo17,
                                                        lotNumber: nl.lotNo,
                                                        revisionNumber: nl.revisionNo,
                                                        expirationDate: nl.expiration,
                                                        statusId: Status.Active,
                                                        shipped: true,
                                                        systemPresent: nl.systemPresent,
                                                        referenceId: this.refId
                                                    };
                                                    kp.salesOrderBundleProductSerialDetail.push(obj);
                                                });
                                            }
                                        } else {
                                            if (kp.rowId == this.selectedProductForScan.rowId) {
                                                kp.salesOrderBundleProductSerialDetail = [];
                                                this.autoGenerateLists.forEach((nl) => {
                                                    const obj = {
                                                        id: this.type == DialogType.EDIT ? (nl?.id ? nl.id : 0) : 0,
                                                        createdSource: this.app.userIP,
                                                        updatedSource: this.app.userIP,
                                                        createdBy: this.app.userId,
                                                        updatedBy: this.app.userId,
                                                        createdDate: this.app._saveDateTimeWithZone(new Date()),
                                                        updatedDate: this.app._saveDateTimeWithZone(new Date()),
                                                        salesOrderId: 0,
                                                        salesOrderProductId: this.type == DialogType.EDIT ? element?.rowId : 0,
                                                        salesOrderBundleDetailId: k.rowId ? k.rowId : 0,
                                                        barcode: nl.serialNo,
                                                        serialNumber2: nl.serialNo2,
                                                        serialNumber3: nl.serialNo3,
                                                        serialNumber4: nl.serialNo4,
                                                        serialNumber5: nl.serialNo5,
                                                        serialNumber6: nl.serialNo6,
                                                        serialNumber7: nl.serialNo7,
                                                        serialNumber8: nl.serialNo8,
                                                        serialNumber9: nl.serialNo9,
                                                        serialNumber10: nl.serialNo10,
                                                        serialNumber11: nl.serialNo11,
                                                        serialNumber12: nl.serialNo12,
                                                        serialNumber13: nl.serialNo13,
                                                        serialNumber14: nl.serialNo14,
                                                        serialNumber15: nl.serialNo15,
                                                        serialNumber16: nl.serialNo16,
                                                        serialNumber17: nl.serialNo17,
                                                        lotNumber: nl.lotNo,
                                                        revisionNumber: nl.revisionNo,
                                                        expirationDate: nl.expiration,
                                                        statusId: Status.Active,
                                                        shipped: true,
                                                        systemPresent: nl.systemPresent,
                                                        referenceId: this.refId
                                                    };
                                                    kp.salesOrderBundleProductSerialDetail.push(obj);
                                                });
                                            }
                                        }
                                    }
                                }
                            });
                        }
                    }
                }
            });
        } else {
            this.purchaseListTB.forEach((element) => {
                if (element.id == this.selectedProductForScan.id) {
                    element.salesOrderSerialDetails = [];
                    this.autoGenerateLists.forEach((nl) => {
                        const obj = {
                            id: this.type == DialogType.EDIT ? (nl?.id ? nl.id : 0) : 0,
                            createdSource: this.app.userIP,
                            updatedSource: this.app.userIP,
                            createdBy: this.app.userId,
                            updatedBy: this.app.userId,
                            createdDate: this.app._saveDateTimeWithZone(new Date()),
                            updatedDate: this.app._saveDateTimeWithZone(new Date()),
                            invoiceId: 0,
                            invoiceProductId: this.type == DialogType.EDIT ? element?.rowId : 0,
                            salesOrderId: 0,
                            salesOrderProductId: this.type == DialogType.EDIT ? element?.rowId : 0,
                            barcode: nl.serialNo,
                            serialNumber2: nl.serialNo2,
                            serialNumber3: nl.serialNo3,
                            serialNumber4: nl.serialNo4,
                            serialNumber5: nl.serialNo5,
                            serialNumber6: nl.serialNo6,
                            serialNumber7: nl.serialNo7,
                            serialNumber8: nl.serialNo8,
                            serialNumber9: nl.serialNo9,
                            serialNumber10: nl.serialNo10,
                            serialNumber11: nl.serialNo11,
                            serialNumber12: nl.serialNo12,
                            serialNumber13: nl.serialNo13,
                            serialNumber14: nl.serialNo14,
                            serialNumber15: nl.serialNo15,
                            serialNumber16: nl.serialNo16,
                            serialNumber17: nl.serialNo17,
                            lotNumber: nl.lotNo,
                            revisionNumber: nl.revisionNo,
                            expirationDate: nl.expiration,
                            statusId: Status.Active,
                            shipped: true,
                            systemPresent: nl.systemPresent,
                            referenceId: this.refId
                        };
                        element.salesOrderSerialDetails.push(obj);
                    });
                }
            });
        }
        this.selectedProductForScan = null;
        this.selectedBundleForScan = null;
        this.selectedKitForScan = null;
        this.displayScanInfo = false;
    }

    openImport() {
        this.displayImport = true;
    }
    hideImport() {
        this.displayImport = false;
    }

    //Auto-Generate Serial Tracking
    generate(value) {
        for (let i = 0; i < (this.selectedProductForScan?.totalQuantity ? this.selectedProductForScan?.totalQuantity : 0) - this.listLength; i++) {
            value.serialNo = this.prefixValue.concat(this.utilityService.generateSerialNo(12 - this.prefixValue?.length));
            this.autoGenerateLists.push(JSON.parse(JSON.stringify(value)));
            this.totalTBRecord = this.autoGenerateLists.length;
            this.nameLists = this.autoGenerateLists.slice(0, 100);
        }
        this.listLength = this.selectedProductForScan?.totalQuantity ? this.selectedProductForScan?.totalQuantity : 0;
    }

    loadSerialsLazy(event) {
        if (this.autoGenerateLists) {
            this.nameLists = this.autoGenerateLists.slice(event.first, event.first + event.rows);
        }
    }

    importSave(data) {
        this.refId = data.referenceId;
        const unique =
            data.list?.filter((obj) => {
                const autoIndex = this.autoGenerateLists.findIndex((item) => item.serialNo === obj.serialNo);
                const hasBlankSerialNo = this.autoGenerateLists.some((item) => item.serialNo === "");
                return autoIndex === -1 || hasBlankSerialNo;
            }) || [];

        const qty = this.selectedProductForScan?.totalQuantity - this.listLength;
        if (unique.length > 0 && data.list?.length - unique.length > qty) {
            this.confirmationService.confirm({
                message: "You cannot import serial numbers more than ordered qty,Do you still want to proceed?",
                header: "Alert Confirmation",
                icon: "pi pi-info-circle",
                accept: () => {
                    this.importSerialData(data);
                },
                reject: () => {},
            });
        } else {
            this.importSerialData(data);
        }
    }

    importSerialData(data) {
        
        this.unMatchedSerials = [];
        for (let dt of data.list) {
            if (dt.serialNo) {
                const present = this.systemTrackingData?.find((depOb) => depOb.serialNo == dt.serialNo);
                if (present) {
                    dt.systemPresent = true;
                    dt.remove = false;
                    dt.checked = false;
                } else if (!present && this.serialConfig?.enabled) {
                    dt.systemPresent = false;
                    dt.remove = false;
                    dt.checked = true;
                } else if (!present || !this.serialConfig?.enabled) {
                    dt.systemPresent = true;
                    dt.checked = false;
                }
            } else {
                dt.systemPresent = true;
                dt.remove = false;
                dt.checked = false;
            }
            //this.autoGenerateLists.push(dt); /*new logic*/
            if (data.action == "add") {
                const index = this.autoGenerateLists?.findIndex((exp) => exp.serialNo == dt.serialNo);
                if (index > -1) {
                    dt.id = this.autoGenerateLists[index].id;
                    this.autoGenerateLists[index] = dt;
                } else {
                    if (this.listLength < this.selectedProductForScan?.totalQuantity) {
                        this.autoGenerateLists.push(dt);
                        this.listLength++;
                    }
                }
            } else {
                // Get the total quantity from the form control
                const totalQty = this.selectedProductForScan.totalQuantity || 0;
                const filteredList = data.list.slice(0, totalQty);
                // Fields to skip when comparing
                const skipKeys = ['id', 'expiration', 'field1', 'field2', 'field3', 'field4', 'field5', 'field6', 'field7', 'field8',
                    'field9', 'field10', 'field11', 'field12', 'field13', 'field14', 'field15', 'field16', 'field17', 'field18', 'field19',
                    'field20'
                ];
                // Compare only defined + non-empty fields from newItem against existingItem
                const isMatch = (existingItem: any, newItem: any): boolean => {
                    for (const key in newItem) {
                        if (skipKeys.includes(key)) continue;

                        const newVal = newItem[key];
                        if (newVal !== undefined && newVal !== null && newVal !== '') {
                            if (existingItem[key] !== newVal) return false;
                        }
                    }
                    return true;
                };
                // Step 1: Update existing items
                let updatedList = this.autoGenerateLists.map(existingItem => {
                    const match = filteredList.find(newItem => isMatch(existingItem, newItem));
                    if (match) {
                        return {
                            ...existingItem,
                            ...Object.keys(match).reduce((acc, key) => {
                                acc[key] = match[key] !== undefined && match[key] !== ''
                                    ? match[key]
                                    : existingItem[key]; // preserve existing if new is blank
                                return acc;
                            }, {} as any)
                        };
                    }
                    return existingItem;
                });
                // Step 2: Remove items not found in filteredList
                updatedList = updatedList.filter(existingItem =>
                    filteredList.some(newItem => isMatch(existingItem, newItem))
                );
                // Step 3: Add new items not present in updatedList
                filteredList.forEach(newItem => {
                    const exists = updatedList.some(existingItem => isMatch(existingItem, newItem));
                    if (!exists) {
                        updatedList.push(newItem);
                    }
                });
                this.autoGenerateLists = updatedList;
            }
            this.unMatchedSerials = this.autoGenerateLists?.filter((sr) => !sr.systemPresent);
        }
        this.nameLists = this.autoGenerateLists.slice(0, 100);
        this.listLength = this.autoGenerateLists.length;
        this.totalTBRecord = this.listLength;
        this.disabledSave = false;
        this.displayImport = false;
        this.trackingForm.controls['qty'].setValue(this.selectedProductForScan?.ordQty - this.listLength);
        this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: "Import successfully, removed duplicate Serial No.",
        });
    }

    checkSerialNoInSystem(productId, warehouseId, orderId) {
        this.salesOrderService
            .checkSerialNoInSystem(orderId, warehouseId, productId,'salesOrder')
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((data) => {
                this.systemTrackingData = data;
            });
    }

    openTracking() {
        this.displayTracking = true;
    }

    closeTracking() {
        this.displayTracking = false;
    }
    saveTracking(data) {
        for (let dt of data) {
            const newValue = {
            ...dt, 
            id: 0 ,        
            systemPresent: true, 
            remove: false,       
            checked: false       
            };
            
            const presentSerialNo = this.autoGenerateLists?.find(nos => nos.serialNo == dt.serialNo);
            if (!presentSerialNo && this.listLength < this.selectedProductForScan?.ordQty) {
            this.autoGenerateLists.push(newValue);
            // this.nameLists = this.autoGenerateLists?.slice(0, 100);
            this.listLength = this.listLength + 1;
            }
        }
        this.trackingForm.controls['qty'].setValue(this.selectedProductForScan?.ordQty - this.listLength);
        this.nameLists = this.autoGenerateLists?.slice(0, 100);
        this.totalTBRecord = this.listLength;
        this.displayTracking = false;
    }

    /**End tracking SerialNo**/

    onClose(e) {
        this.displayProductSelectionModal = false;
    }

    onEnterDownStopPropagation(event) {
        event.stopPropagation();
    }

    initCustomFields() {
        this.combinedCustomFields.billing_address_item = [];
        this.combinedCustomFields.shipping_address_item = [];
        this.combinedCustomFields.misc_item = [];
        this.combinedCustomFields.section_item = [];
        this.combinedCustomFields.footer_item = [];
        this.combinedCustomFields.message_item = [];
        this.combinedCustomFields.other1_item = [];
        this.combinedCustomFields.other2_item = [];
        this.combinedCustomFields.other3_item = [];
        const salesChannel = this.orderChannels?.filter((s) => s.name == this.soChannel.SALES_ORDER)[0];
        this.allStages = salesChannel?.stages;
        const selectedStageId = this.allStages[0]?.id;
    }

    getColsCount() {
        this.cols = 0;
        this.footerValueColSpan = 2;
        if (this.templates && this.templates.labels_table) {
            this.templates.labels_table.forEach((e) => {
                this.cols += e && e.isChecked ? 1 : 0;
            });
        }

        let nonStaticCols = 0;
        if (this.templates && this.templates.labels_table?.[19]?.isChecked) {
            nonStaticCols += 1;
        }
        if (this.templates && this.templates.labels_table?.[20]?.isChecked) {
            nonStaticCols += 1;
        }
        if (this.templates && this.templates.labels_table?.[21]?.isChecked) {
            nonStaticCols += 1;
        }
        this.cols = this.cols - nonStaticCols;

        if ((this.type == DialogType.CREATE || this.type == DialogType.COPY) && !this.isOrderToBeShipped) {
            this.cols -= 4;
            this.footerValueColSpan = 2;
        } else if (this.stageId == SoStageId.Entered && !this.isOrderToBeShipped && this.type != DialogType.CONVERT) {
            this.cols -= 4;
            this.footerValueColSpan = 3;
        } else if (this.stageId == SoStageId.Pick && !this.isOrderToBeShipped) {
            this.cols -= 3;
            this.footerValueColSpan = 4;
        } else if ((this.stageId == SoStageId.Pack || this.stageId == SoStageId.Verification || this.stageId == SoStageId.Labelling || this.stageId == SoStageId.ReadyToShip) && !this.isOrderToBeShipped) {
            this.cols -= 2;
            this.footerValueColSpan = 4;
        } else if (this.stageId == SoStageId.Shipped && !this.isOrderToBeShipped) {
            this.footerValueColSpan = 1;
            if (!this.isEnabledBackOrder) {
                this.cols -= 1;
            }
        } else if (this.isOrderToBeShipped) {
            this.cols -= 1;
            this.footerValueColSpan = 3;
            if (!this.isEnabledBackOrder) {
                this.cols -= 1;
            }
        } else if (this.type == DialogType.CONVERT) {
            // this.cols = 11;
            this.cols -= 2;
            this.footerValueColSpan = 1;
        }
    }

    copyProduct() {
        const newProduct: any = _.cloneDeep(this.selectedProduct);
        if (this.type == DialogType.EDIT) {
            newProduct.uuid = uuidv4();
            newProduct.fieldId = 0;
            newProduct.rowId = 0;
            newProduct.isDuplicatedProduct = true;
            newProduct.description = `${newProduct.description} - add`;
            if (newProduct?.typeId == TypeIds.KitTypeId && newProduct.bundleDetails && newProduct.bundleDetails.length > 0) {
                newProduct.bundleDetails = newProduct.bundleDetails.map((bProduct) => ({ ...bProduct, uuid: uuidv4(), fieldId: 0, rowId: 0, isDuplicatedProduct: true }));
            }
        } else {
            newProduct.uuid = uuidv4();
            newProduct.isDuplicatedProduct = true;
            newProduct.description = `${newProduct.description} - add`;
            if (newProduct?.typeId == TypeIds.KitTypeId && newProduct.bundleDetails && newProduct.bundleDetails.length > 0) {
                newProduct.bundleDetails = newProduct.bundleDetails.map((bProduct) => ({ ...bProduct, isDuplicatedProduct: true }));
            }
        }
        this.purchaseListTB.push(newProduct);
        // this.selectedProductsList = this.purchaseListTB;
        this.calculateOrderTotal();
    }

    /** Context Menu */
    prepareProductContextMenu(e: MouseEvent, cmProduct) {
        if (this.selectedProduct?.isDuplicatedProduct || this.selectedProduct?.typeId == TypeIds.BundleTypeId) {
            this.productconfigMenu = [];
            cmProduct?.hide();
        } else {
            this.productconfigMenu = [
                {
                    label: "Copy",
                    icon: "pi pi-copy",
                    visible: true,
                    command: () => {
                        this.copyProduct();
                    },
                },
            ];
            cmProduct?.show();
        }
    }

    /** Sales Order Amount Calculation */

    /**
     * Calculating inventory, bundle, kit items sub total
     * based on quantity, tax & discount
     */
    calculateSubTotal(item, qty, type) {
        if (item.typeId == TypeIds.BundleTypeId) {
            this.calculateBundleProductsSubTotal(item, qty);
        } else {
            this.onChangeProductTaxOrDiscount(item, type);
        }
        this.checkIsDisabledCheckBox();
    }

    /*** Calculating individual inventory items subtotal that added in products list */
    onChangeProductTaxOrDiscount(product, type) {
        const uomValue = product?.unit?.uomDetail?.value || 1;
        product.totalQuantity = this.isOrderToBeShipped ? Number(product.packedQty) * Number(uomValue) : this.stageId == SoStageId.Entered ? Number(product.ordQty) * Number(uomValue) : this.stageId == SoStageId.Pick ? Number(product.pickedQty) * Number(uomValue) : Number(product.packedQty) * Number(uomValue);
        product.totalCostPrice = Number(product.costPrice) * Number(product.totalQuantity);

        if (type == "discounttype") {
            product.discount = product?.discountType?.discountValue ?? 0;
        } else if (type == "additionalFeeType") {
            product.additionalFee = product?.additionalFeeType?.discountValue ?? 0;
        } else if (type == "baseSubTotal") {
            product.price = Number(product.baseSubTotal) / Number(product.totalQuantity);
        }

        if (this.type == DialogType.COPY) {
            this.stageId = SoStageId.Entered;
        }

        /** Pricebook */
        if (product.typeId != TypeIds.BundleTypeId) {
            if ((type == "qty" || type == "uom") && product.accountPriceTier?.length > 0 && !this.soDetails?.isConvertedFromEstimate) {
                product.price = this.utilityService.applyPriceBook(this.aggregateDiscount, product, Number(product.ordQty) * Number(uomValue));
                product.price = product.price * (this.currencyExchangeRate ?? this.baseCurrency?.exchangeRate);
            }
        }

        this.productCalculationUtilityService.calculateSalesOrderProductsSubTotal(product, this.type, this.allTaxRates, SOChannel.SALES_ORDER, this.aggregateDiscount, this.isVisibleRowTax, this.footerTaxEnabled, this.stageId, this.soDetails?.isConvertedFromEstimate, this.isOrderToBeShipped, this.shippingAddressInfo?.address?.stateId, this.shippingAddressInfo?.address?.zipCode, this.taxSettings, this.taxConfig, this.discountOptions, product?.discountType?.id ?? 0, this.templates?.labels_table[15]?.isChecked ?? false, this.templates?.labels_table[6]?.isChecked ?? false);
        if (this.isEnabledBackOrder && this.isOrderToBeShipped) {
            product.backOrderQty = product.ordQty - product.packedQty;
            if (product.backOrderQty < 0) {
                product.backOrderQty = 0;
            }
            if (product?.typeId == TypeIds.KitTypeId && this.isEnabledBackOrderKit) {
                product?.bundleDetails?.forEach((e) => {
                    e.backOrderQty = e.ordQty - e.packedQty;
                    if (e.backOrderQty < 0) {
                        e.backOrderQty = 0;
                    }
                });
            }
        }
        this.calculateOrderTotal();
    }

    /**
     * Calculating bundle & products sub total
     * when bundle's qty changed, that quantity should set to its products.
     * Based on the products new quantity, subtotal will be calculated
     * sum total of all products should set to bundle's subtotal
     */
    calculateBundleProductsSubTotal(item, qty) {
        let total = 0;
        let totalOfBaseSubtotal = 0;
        let taxTotal = 0;
        item?.bundleDetails?.forEach((e) => {
            const uomValue = e?.unit?.uomDetail?.value || 1;
            if (this.stageId == SoStageId.Entered) {
                if (this.type == DialogType.CREATE || this.type == DialogType.COPY) {
                    e.ordQty = Number(e.originalQty) * Number(qty) * Number(item?.unit?.uomDetail?.value || 1);
                } else {
                    e.ordQty = Number(e.originalQty) * Number(qty) * Number(item?.unit?.uomDetail?.value || 1);
                }
                e.totalQuantity = Number(e.ordQty) * Number(uomValue);

                /** Pricebook */
                if (e.accountPriceTier?.length > 0 && !this.soDetails?.isConvertedFromEstimate) {
                    e.price = this.utilityService.applyPriceBook(this.aggregateDiscount, e, e.totalQuantity);
                    e.price = e.price * (this.currencyExchangeRate ?? this.baseCurrency?.exchangeRate);
                }
            } else if (this.stageId == SoStageId.Pick) {
                e.pickedQty = Number(qty) * Number(e.originalQty) * Number(item?.unit?.uomDetail?.value || 1);
                e.totalQuantity = Number(e.pickedQty) * Number(uomValue);
            } else {
                e.packedQty = Number(qty) * Number(e.originalQty) * Number(item?.unit?.uomDetail?.value || 1);
                e.totalQuantity = Number(e.packedQty) * Number(uomValue);
            }

            if (this.isEnabledBackOrder && this.isOrderToBeShipped) {
                if (item?.typeId == TypeIds.BundleTypeId && this.isEnabledBackOrderBundle) {
                    e.backOrderQty = e.ordQty - e.packedQty;
                } else if (item?.typeId == TypeIds.KitTypeId && this.isEnabledBackOrderKit) {
                    e.backOrderQty = e.ordQty - e.packedQty;
                }
            }
            if (e.backOrderQty < 0) {
                e.backOrderQty = 0;
            }
            let subTotal = Number(e.totalQuantity) * Number(e.price);
            e.totalCostPrice = Number(e.costPrice) * Number(e.totalQuantity);
            e.baseSubTotal = subTotal;

            /** Tax and Discount */
            let appliedDiscount = this.discountOptions?.find((discount) => discount.id == e?.discountType?.id);
            let productsTotalTax = 0;
            /** If checked, sale tax will be calculated on the order total after discount has been applied. */
            if (appliedDiscount && appliedDiscount.isTaxable) {
                let discount = this.utilityService.calculateProductWiseDiscount(e?.discountType, subTotal, e.discount);
                e.discountAmount = discount;
                e.subTotal = Number(subTotal) - Number(discount);
                // additional fee
                if (this.templates?.labels_table[15]?.isChecked && e?.additionalFeeType?.isTaxable) {
                    let addFee = this.utilityService.calculateProductWiseAdditionalFee(e?.additionalFeeType?.type?.name, e.subTotal, e.additionalFee);
                    e.additionalFeeAmount = addFee;
                    e.subTotal = e.subTotal + Number(addFee);
                }
                if (this.footerTaxEnabled && this.isVisibleRowTax) {
                    e?.bundleDetailSubTax?.forEach((sTax) => {
                        productsTotalTax += this.utilityService.calculateProductsTax(sTax.taxRate, e.subTotal);
                    });
                }
                e.subTotal = e.subTotal + productsTotalTax;
                e.taxAmount = productsTotalTax;
                // additional fee
                if (this.templates?.labels_table[15]?.isChecked && !e?.additionalFeeType?.isTaxable) {
                    let addFee = this.utilityService.calculateProductWiseAdditionalFee(e?.additionalFeeType?.type?.name, e.subTotal, e.additionalFee);
                    e.additionalFeeAmount = addFee;
                    e.subTotal = e.subTotal + Number(addFee);
                }
            } else {
                // additional fee
                if (this.templates?.labels_table[15]?.isChecked && e?.additionalFeeType?.isTaxable) {
                    let addFee = this.utilityService.calculateProductWiseAdditionalFee(e?.additionalFeeType?.type?.name, subTotal, e.additionalFee);
                    e.additionalFeeAmount = addFee;
                    subTotal = subTotal + Number(addFee);
                }
                let productsTotalTax = 0;
                if (this.footerTaxEnabled && this.isVisibleRowTax) {
                    e?.bundleDetailSubTax?.forEach((sTax) => {
                        productsTotalTax += this.utilityService.calculateProductsTax(sTax.taxRate, subTotal);
                    });
                }
                e.subTotal = subTotal + productsTotalTax;
                e.taxAmount = productsTotalTax;

                let discount = this.utilityService.calculateProductWiseDiscount(e?.discountType, e.subTotal, e.discount);
                e.discountAmount = discount;
                e.subTotal = Number(e.subTotal) - Number(discount);
                // additional fee
                if (this.templates?.labels_table[15]?.isChecked && !e?.additionalFeeType?.isTaxable) {
                    let addFee = this.utilityService.calculateProductWiseAdditionalFee(e?.additionalFeeType?.type?.name, e.subTotal, e.additionalFee);
                    e.additionalFeeAmount = addFee;
                    e.subTotal = e.subTotal + Number(addFee);
                }
            }

            total += e.subTotal;
            totalOfBaseSubtotal += e.baseSubTotal;
            taxTotal += productsTotalTax;
        });
        const uomValue = item?.unit?.uomDetail?.value || 1;
        item.totalQuantity = this.stageId == SoStageId.Entered ? Number(item.ordQty) * Number(uomValue) : this.stageId == SoStageId.Pick ? Number(item.pickedQty) * Number(uomValue) : Number(item.packedQty) * Number(uomValue);
        item.price = total;
        item.subTotal = total;
        item.baseSubTotal = totalOfBaseSubtotal;
        item.taxAmount = taxTotal;
        this.calculateOrderTotal();
    }

    /**
     * Calculating child product's subtotal of any Bundle
     * when products qty, tax, discount changed , then need to calculate subtotal based on that changes
     * also need to add addtional amount to bundles subtotal
     */
    onChangeBundleProductTaxOrDiscount(bundle, product, type) {
        if (type == "discounttype") {
            // product.discount = 0;
            product.discount = product?.discountType?.discountValue ?? 0;
        } else if (type == "additionalFeeType") {
            product.additionalFee = product?.additionalFeeType?.discountValue ?? 0;
        } else if (type == "baseSubTotal") {
            const uomValue = product?.unit?.uomDetail?.value || 1;
            product.totalQuantity = this.isOrderToBeShipped ? Number(product.packedQty) * Number(uomValue) : this.stageId == SoStageId.Entered ? Number(product.ordQty) * Number(uomValue) : this.stageId == SoStageId.Pick ? Number(product.pickedQty) * Number(uomValue) : Number(product.packedQty) * Number(uomValue);
            product.price = Number(product.baseSubTotal) / Number(product.totalQuantity);
        } else if(type == "price" && product.price == 0){
            product.discount = 0;
            product.additionalFee = 0;
            product.discountType = null;
            product.additionalFeeType = null;
        }

        if (bundle.typeId == this.typeIds.BundleTypeId) {
            bundle.bundleDetails.forEach((e) => {
                if (e.id == product.id) {
                    const uomValue = e?.unit?.uomDetail?.value || 1;
                    e.totalQuantity = this.isOrderToBeShipped ? Number(e.packedQty) * Number(uomValue) : this.stageId == SoStageId.Entered ? Number(e.ordQty) * Number(uomValue) : this.stageId == SoStageId.Pick ? Number(e.pickedQty) * Number(uomValue) : Number(e.packedQty) * Number(uomValue);

                    /** Pricebook */
                    if (type == "qty" && e.accountPriceTier?.length > 0 && !this.soDetails?.isConvertedFromEstimate) {
                        e.price = this.utilityService.applyPriceBook(this.aggregateDiscount, e, Number(e.ordQty) * Number(uomValue));
                        e.price = e.price * (this.currencyExchangeRate ?? this.baseCurrency?.exchangeRate);
                    }

                    if (this.isEnabledBackOrder && this.isEnabledBackOrderBundle && this.isOrderToBeShipped) {
                        e.backOrderQty = e.ordQty - e.packedQty;
                        if (e.backOrderQty < 0) {
                            e.backOrderQty = 0;
                        }
                    }
                    let subTotal = Number(e.totalQuantity) * Number(e.price);
                    e.baseSubTotal = subTotal;

                    /** Tax and Discount */
                    let appliedDiscount = this.discountOptions?.find((discount) => discount.id == e?.discountType?.id);
                    let productsTotalTax = 0;
                    /** If checked, sale tax will be calculated on the order total after discount has been applied. */
                    if (appliedDiscount && appliedDiscount.isTaxable) {
                        let discount = this.utilityService.calculateProductWiseDiscount(e?.discountType, subTotal, e.discount);
                        e.discountAmount = discount;
                        e.subTotal = Number(subTotal) - Number(discount);
                        // additional fee
                        if (this.templates?.labels_table[15]?.isChecked && e?.additionalFeeType?.isTaxable) {
                            let addFee = this.utilityService.calculateProductWiseAdditionalFee(e?.additionalFeeType?.type?.name, e.subTotal, e.additionalFee);
                            e.additionalFeeAmount = addFee;
                            e.subTotal = e.subTotal + Number(addFee);
                        }
                        if (this.footerTaxEnabled && this.isVisibleRowTax) {
                            e?.bundleDetailSubTax?.forEach((sTax) => {
                                productsTotalTax += this.utilityService.calculateProductsTax(sTax.taxRate, e.subTotal);
                            });
                        }
                        e.subTotal = e.subTotal + productsTotalTax;
                        e.taxAmount = productsTotalTax;
                        // additional fee
                        if (this.templates?.labels_table[15]?.isChecked && !e?.additionalFeeType?.isTaxable) {
                            let addFee = this.utilityService.calculateProductWiseAdditionalFee(e?.additionalFeeType?.type?.name, e.subTotal, e.additionalFee);
                            e.additionalFeeAmount = addFee;
                            e.subTotal = e.subTotal + Number(addFee);
                        }
                    } else {
                        // additional fee
                        if (this.templates?.labels_table[15]?.isChecked && e?.additionalFeeType?.isTaxable) {
                            let addFee = this.utilityService.calculateProductWiseAdditionalFee(e?.additionalFeeType?.type?.name, subTotal, e.additionalFee);
                            e.additionalFeeAmount = addFee;
                            subTotal = subTotal + Number(addFee);
                        }
                        let productsTotalTax = 0;
                        if (this.footerTaxEnabled && this.isVisibleRowTax) {
                            e?.bundleDetailSubTax?.forEach((sTax) => {
                                productsTotalTax += this.utilityService.calculateProductsTax(sTax.taxRate, subTotal);
                            });
                        }
                        e.subTotal = subTotal + productsTotalTax;
                        e.taxAmount = productsTotalTax;
                        let discount = this.utilityService.calculateProductWiseDiscount(e?.discountType, e.subTotal, e.discount);
                        e.discountAmount = discount;
                        e.subTotal = Number(e.subTotal) - Number(discount);
                        // additional fee
                        if (this.templates?.labels_table[15]?.isChecked && !e?.additionalFeeType?.isTaxable) {
                            let addFee = this.utilityService.calculateProductWiseAdditionalFee(e?.additionalFeeType?.type?.name, subTotal, e.additionalFee);
                            e.additionalFeeAmount = addFee;
                            subTotal = subTotal + Number(addFee);
                        }
                    }
                }
            });
            let total = 0;
            let totalOfBaseSubtotal = 0;
            let taxTotal = 0;
            bundle.bundleDetails.forEach((e) => {
                total += Number(e.subTotal);
                totalOfBaseSubtotal += Number(e.baseSubTotal);
                taxTotal += Number(e.taxAmount);
            });
            bundle.price = total;
            bundle.subTotal = total;
            bundle.baseSubTotal = totalOfBaseSubtotal;
            bundle.taxAmount = taxTotal;
            this.calculateOrderTotal();
        }
        this.checkIsDisabledCheckBox();
    }

    onchangeAdditionalDiscountTypeName() {
        this.enableDiableAdditionalDiscountRateField();
        this.additionalDiscountRateTypes = [this.soForm?.controls?.additionalDiscountTypeName?.value];
        this.soForm?.controls?.additionalDiscountType.setValue(this.soForm?.controls?.additionalDiscountTypeName?.value ?? null);
        this.soForm?.controls?.additionalDiscountRate.setValue(this.soForm?.controls?.additionalDiscountTypeName?.value?.discountValue ?? 0);
        this.calculateOrderTotal();
    }
    enableDiableAdditionalDiscountRateField() {
        if (this.soForm?.controls?.additionalDiscountTypeName?.value?.description?.toLowerCase() != "manual") {
            this.soForm?.controls?.additionalDiscountRate?.disable();
        } else {
            this.soForm?.controls?.additionalDiscountRate?.enable();
        }
    }

    /** Order Total Calculation */
    
    calculateOrderTotal(type?: string) {
        if (type == "discounttype") {
            this.soForm?.controls["discountValue"]?.setValue(this.soForm?.controls["discountType"]?.value?.discountValue || 0);
        } else if (type == "totalAdditionalFeetype") {
            this.soForm?.controls["additionalFee"]?.setValue(this.soForm?.controls["additionalFeeType"]?.value?.discountValue || 0);
        }
        this.discount = 0;
        this.orderTotal = 0;
        this.sumTotal = 0;
        this.tax = 0;
        this.productsTotal = 0;
        this.additionalDiscountAmount = 0;
        this.totalAdditionalFee = 0;
        this.productsTotalAdditionalFee = 0;
        let totalAmount = this.calculateProductsTotal();

        // Step 1: Subtract Discount
        this.discount = this.calculateDiscount();
        if (this.footerDiscountEnabled) {
            totalAmount -= this.discount;
        }

        // Step 2: Add Tax
        this.tax = this.calculateTax(totalAmount);
        if (this.footerTaxEnabled) {
            totalAmount += this.tax;
        }

        // Step 3: Add Additional Fee
        this.totalAdditionalFee = this.calculateAdditionalFee(totalAmount);
        totalAmount += this.totalAdditionalFee;

       // Step 4: Subtract Additional Discount
        this.additionalDiscountAmount = this.calculateAdditionalDiscount(totalAmount);
        totalAmount = Number(totalAmount) - Number(this.additionalDiscountAmount);

        // Step 5: Add Shipping Charge
        const shipValue = this.soForm?.controls["shippingChargeAmount"].value ? Number(this.soForm?.controls["shippingChargeAmount"].value) : 0;
        this.orderTotal = totalAmount + shipValue;
        
        // Step 6: Check for Free Shipping
        if (this.soDetails && this.soDetails?.isFreeShipping) {
            this.orderTotal -= shipValue;
        }
    }
    private calculateProductsTotal() {
        for (let s of this.purchaseListTB) {
            if (s.typeId == TypeIds.BundleTypeId) {
                let bTotal = 0;
                s?.bundleDetails?.forEach((b) => {
                    bTotal += Number(b.subTotal);
                    this.productsTotalAdditionalFee += Number(b.additionalFeeAmount);
                });
                s.subTotal = bTotal;
            } else {
                this.productsTotalAdditionalFee += Number(s.additionalFeeAmount);
            }
            this.sumTotal += Number(s.baseSubTotal);
            this.productsTotal += Number(s.subTotal);
        }
        const totalAmount = this.sumTotal + this.productsTotalAdditionalFee;
        return totalAmount;
    }
    private calculateDiscount() {
        const disName = this.soForm?.controls["discountType"].value ? this.soForm?.controls["discountType"]?.value?.name : "";
        let disValue = this.soForm?.controls["discountValue"]?.value ? this.soForm?.controls["discountValue"]?.value : 0;
        if (disName == "%" || disName == "Percentage") {
            if (disValue > 100) {
                disValue = 100;
                this.soForm?.controls["discountValue"]?.setValue(disValue);
            }
        } else if (disName == "$" || disName == "Amount") {
            if (disValue > Number(this.sumTotal)) {
                disValue = Number(this.sumTotal);
                this.soForm?.controls["discountValue"]?.setValue(disValue);
            }
        }
        return this.utilityService.calculateOrderTotalDiscount(disName, disValue, this.sumTotal, this.purchaseListTB, this.isVisibleRowDiscount, this.footerDiscountEnabled, this.isVisibleFooterDiscount);
    }
    private calculateTax(totalAmount: number): number {
        return this.utilityService.calculateOrderTotalTax(this.purchaseListTB, totalAmount, this.isVisibleRowTax, this.footerTaxEnabled, this.isVisibleFooterTax, this.allTaxRates);
    }
    private calculateAdditionalFee(totalAmount: number): number {
        return this.utilityService.calculateOrderTotalAdditionalFee(this.soForm?.controls["additionalFeeType"]?.value?.type?.name, this.soForm?.controls["additionalFee"]?.value, totalAmount, this.purchaseListTB, this.templates?.labels_table[15]?.isChecked, this.templates?.labels_footer[10]?.isChecked);
    }
    private calculateAdditionalDiscount(totalAmount: number): Number {
        if (this.soForm?.controls?.additionalDiscountTypeName?.value?.type?.description == "%" || this.soForm?.controls?.additionalDiscountTypeName?.value?.type?.description == "Percentage") {
            if (Number(this.soForm?.controls?.additionalDiscountRate.value) > 100) {
                this.soForm?.controls?.additionalDiscountRate.setValue(100);
            }
        } else if (this.soForm?.controls?.additionalDiscountTypeName?.value?.type?.description == "$" || this.soForm?.controls?.additionalDiscountTypeName?.value?.type?.description == "Amount") {
            if (Number(this.soForm?.controls?.additionalDiscountRate.value) > Number(totalAmount)) {
                this.soForm?.controls?.additionalDiscountRate.setValue(totalAmount);
            }
        }
        if (this.soForm?.controls?.additionalDiscountTypeName?.value && this.soForm?.controls?.additionalDiscountType?.value) {
            if (this.soForm?.controls?.additionalDiscountType.value.type.description == "%" || this.soForm?.controls?.additionalDiscountType.value.type.description == "Percentage") {
                this.additionalDiscountAmount = this.soForm?.controls?.additionalDiscountRate.value > 0 ? totalAmount * (Number(this.soForm?.controls?.additionalDiscountRate.value) / 100) : this.additionalDiscountAmount;
            } else {
                this.additionalDiscountAmount = Number(this.soForm?.controls?.additionalDiscountRate.value);
            }
        }
        return this.additionalDiscountAmount;
    }

    /** End Order Total Calculation */


    /** calculating discount amount for each product */
    calculateProductsDiscount(disType: any, totalQty: number, price: number, discount: number) {
        let discountAmount = 0;
        if (disType) {
            if (disType.description == "%" || disType.description?.toLowerCase() == "percentage") {
                discountAmount = (Number(totalQty) * Number(price) * Number(discount)) / 100;
            } else if (disType.description == "$" || disType.description?.toLowerCase() == "amount") {
                discountAmount = discount;
            }
        }
        return discountAmount;
    }

    getPackQtyDiscountAmount(b) {
        const uomValue = b?.unit?.uomDetail?.value || 1;
        if (b.packedQty > 0) {
            return b?.discountType?.description == "%" && b.discountAmount ? (Number(b.discountAmount) * 100) / (Number(b.packedQty) * Number(uomValue) * Number(b.pricePerProduct)) : b.discountAmount;
        } else {
            return b?.discountType?.description == "%" && b.discountAmount ? (Number(b.discountAmount) * 100) / (Number(b.quantity) * Number(uomValue) * Number(b.pricePerProduct)) : b.discountAmount;
        }
    }

    getPackQtyTaxAmount(b) {
        const uomValue = b?.unit?.uomDetail?.value || 1;
        let amount = 0;
        if (b.tax && b.tax.taxRate) {
            amount = b.packedQty > 0 ? (Number(b.tax.taxRate) / 100) * (Number(b.packedQty) * Number(uomValue) * Number(b.pricePerProduct)) : (Number(b.tax.taxRate) / 100) * (Number(b.quantity) * Number(uomValue) * Number(b.pricePerProduct));
        }
        return amount;
    }

    calculateDiscountAmount(total, products) {
        let dis = 0;
        const disName = this.soForm?.controls["discountType"].value ? this.soForm?.controls["discountType"]?.value?.name : "";
        const disValue = this.soForm?.controls["discountValue"]?.value ? this.soForm?.controls["discountValue"]?.value : 0;
        if (this.isVisibleRowDiscount) {
            if (disName == "%" || disName == "Percentage") {
                dis = Number(total * (Number(disValue) / 100));
            } else if (disName == "$" || disName == "Amount") {
                dis = Number(disValue);
            }
        } else {
            products?.forEach((e) => {
                if (e.typeId == this.typeIds.BundleTypeId) {
                    e.bundleDetails.forEach((b) => {
                        dis += Number(b.discountAmount);
                    });
                } else {
                    dis += Number(e.discountAmount);
                }
            });
        }
        return isNaN(dis) ? 0 : dis;
    }

    calculateTaxAmount(total, products) {
        let tax = 0;
        if (!this.isVisibleRowTax) {
            tax = total * (this.taxRate / 100);
        } else {
            products.forEach((e) => {
                if (e.typeId == this.typeIds.BundleTypeId) {
                    e.bundleDetails.forEach((b) => {
                        tax += Number(b.taxAmount);
                    });
                } else {
                    tax += Number(e.taxAmount);
                }
            });
        }
        return tax;
    }

    isNumberKey(evt, product?, type?) {
        if (type == "price" || type == "baseSubtotal") {
            product.minPrice = 0;
            product.minBaseSubtotal = 0;
            if (product?.typeId == TypeIds.ServiceTypeId) {
                let inventoryOrNonInventoryProducts = this.purchaseListTB?.filter((p) => p?.typeId == TypeIds.InventoryTypeId || p?.typeId == TypeIds.NonInventoryTypeId);
                if (inventoryOrNonInventoryProducts && inventoryOrNonInventoryProducts?.length > 0) {
                    product.minPrice = -999999999999.9999;
                    product.minBaseSubtotal = -999999999999.9999;
                    return this.utilityService.allowPositiveOrNegativeNumber(evt);
                }
                return this.utilityService.allowPositiveNumberOnly(evt);
            }
            return this.utilityService.allowPositiveNumberOnly(evt);
        }
        return this.utilityService.allowPositiveNumberOnly(evt);
    }

    // getDiscountAmount(b, uomValue) {
    //     if (this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked) {
    //         if (this.stageId != 1 && b.pickedQty) {
    //             const discount = b?.discountType?.description == "%" && b.discountAmount ? (Number(b.discountAmount) * 100) / (Number(b.pickedQty) * Number(b.pricePerProduct)) : b.discountAmount;
    //             const actualDiscount = discount / uomValue;
    //             return b?.discountType?.description == "%" ? actualDiscount.toFixed(2) : discount.toFixed(2);
    //         } else {
    //             const discount = b?.discountType?.description == "%" && b.discountAmount ? (Number(b.discountAmount) * 100) / (Number(b.quantity) * Number(b.pricePerProduct)) : b.discountAmount;
    //             const actualDiscount = discount / uomValue;
    //             return b?.discountType?.description == "%" ? actualDiscount.toFixed(2) : discount.toFixed(2);
    //         }
    //     } else {
    //         return 0;
    //     }
    // }
    // getDiscountAmountForConvert(b, q) {
    //     if (this.footerDiscountEnabled && this.templates?.labels_table[6]?.isChecked) {
    //         const uomValue = b && b.unit && b.unit.uomDetail && b.unit.uomDetail.value ? b.unit.uomDetail.value : 1;
    //         return b?.discountType?.description == "%" && b.discountAmount ? (Number(b.discountAmount) * 100) / (Number(q) * Number(uomValue) * Number(b.price)) : b.discountAmount;
    //     } else {
    //         return 0;
    //     }
    // }
    getTaxAmountForConvert(b, q) {
        const uomValue = b && b.unit && b.unit.uomDetail && b.unit.uomDetail.value ? b.unit.uomDetail.value : 1;
        let amount = 0;
        if (b.taxType && b.taxType.taxRate) {
            amount = (Number(b.taxType.taxRate) / 100) * (Number(q) * Number(uomValue) * Number(b.price));
        }
        return amount;
    }
    getTaxAmount(b, uomValue) {
        let amount = 0;
        if (b.tax && b.tax.taxRate) {
            amount = this.stageId != 1 && b.pickedQty ? (Number(b.tax.taxRate) / 100) * (Number(b.pickedQty * uomValue) * Number(b.pricePerProduct)) : (Number(b.tax.taxRate) / 100) * (Number(b.quantity * uomValue) * Number(b.pricePerProduct));
        }
        return amount;
    }

    onChangeBundleProductTaxOrDiscountForPicked(bundle, product) {
        bundle.bundleDetails.forEach((e) => {
            if (e.id == product.id) {
                let discount = 0;
                if (e?.taxType?.taxRate) {
                    const tax = Number(Number(e.taxType.taxRate) / 100);
                    e.taxAmount = Number(e.pickedQty) * Number(e.price) * Number(tax);
                } else {
                    e.taxAmount = 0;
                }
                e.subTotal = Number(e.pickedQty) * Number(e.price) + Number(e.taxAmount);

                if (e?.discountType) {
                    const disType = e.discountType;
                    if ((disType.description == "%" || disType.description == "Percentage") && e.discount) {
                        discount = (Number(e.pickedQty) * Number(e.price) * Number(e.discount)) / 100;
                        e.discountAmount = discount;
                    } else if ((disType.description == "$" || disType.description == "Amount") && e.discount) {
                        discount = e.discount;
                        e.discountAmount = discount;
                    }
                }
                e.subTotal = Number(e.subTotal) - Number(discount);
            }
        });
        let total = 0;
        bundle.bundleDetails.forEach((e) => {
            total += e.subTotal;
        });
        bundle.price = total;
        bundle.subTotal = total;
        this.calculateOrderTotal();
    }

    onChangeTax() {
        this.orderTotal = 0;
        this.sumTotal = 0;
        this.taxRate = this.soForm?.controls["tax"].value.taxRate;
        for (let s of this.purchaseListTB) {
            this.sumTotal = this.sumTotal + s.baseSubTotal; //0.00 + 600.00
        }

        if (this.soForm?.controls["discountType"]?.value?.name == "%" || this.soForm?.controls["discountType"]?.value?.name == "Percentage") {
            this.discount = Number(this.sumTotal * (Number(this.soForm?.controls["discountValue"]?.value) / 100));
        } else if (this.soForm?.controls["discountType"]?.value?.name == "$" || this.soForm?.controls["discountType"]?.value?.name == "Amount") {
            this.discount = Number(this.soForm?.controls["discountValue"]?.value);
        }
        this.tax = 0;
        if (this.sumTotal && this.taxRate) {
            this.tax = Number(this.sumTotal * (this.taxRate / 100));
        } else {
            this.tax = 0;
        }
        this.orderTotal = this.sumTotal + Number(this.soForm?.controls["shippingChargeAmount"].value) + this.tax - this.discount;
    }

    // calculateProductsTax(taxRate: number, subTotal: number) {
    //     return subTotal * (Number(taxRate) / 100);
    // }
    calculateProductsTax(taxRate: number, subTotal: number, product: any) {
        let totalAmount: number = subTotal;
        let appliedDiscount = this.discountOptions?.find((discount) => discount.id == product?.discountType?.id ?? 0);
        /** If checked, sale tax will be calculated on the order total after discount has been applied. */
        if (appliedDiscount && appliedDiscount.isTaxable) {
            if (this.footerDiscountEnabled) {
                totalAmount -= Number(product.discountAmount);
            }
            if (this.templates?.labels_table[15]?.isChecked && product?.additionalFeeType?.isTaxable) {
                totalAmount += product?.additionalFeeAmount ?? 0;
            }
            return totalAmount * (Number(taxRate) / 100);
        } else {
            if (this.templates?.labels_table[15]?.isChecked && product?.additionalFeeType?.isTaxable) {
                totalAmount += product?.additionalFeeAmount ?? 0;
            }
            return totalAmount * (Number(taxRate) / 100);
        }
    }

    /** End Sales Order Amount Calculation */

    private getSelectedProductQuantity(product) {
        const foundProduct = this.selectedPL?.find((s) => s.id === product.id);
        if (!foundProduct) {
            return 0;
        }
        return this.isOrderToBeShipped ? foundProduct?.packedQty : foundProduct?.shippedQty;
    }

    replaceCommaLine(data) {
        let dataToArray = data.split(",").map((item) => item.trim());
        return dataToArray;
    }

    onClearLocation() {
        if (this.allLocations && this.allLocations.length) {
            this.soForm?.controls["location"].setValue(this.allLocations.filter((l) => l.isDefault == true)[0]);
        }
    }

    setTableCheck() {
        for (let s of this.autoGenerateLists) {
            if (this.allChecked) {
                s.checked = true;
            } else {
                s.checked = false;
            }
        }
    }

    setMainHeaderTracking() {
        const checked = this.nameLists.filter((ch) => ch.checked == true);
        if (checked.length == this.nameLists?.length) {
            this.allChecked = true;
        } else {
            this.allChecked = false;
        }
    }

    showCouponList() {
        this.displayCouponList = true;
        let v = this.soForm?.controls["couponValue"];
        this.selectedCoupon = this.couponLists.filter((e) => e.code == v.value)[0];
    }

    couponSelect(e) {
        this.soForm?.controls["couponValue"].setValue(this.selectedCoupon.code);
        this.displayCouponList = false;
    }

    onAddNewContact(data) {
        this.appMainService.isShowSpinner("onAddNewContact");
        from(this.salesOrderService.getAccountDetailsById(this.accountInfo?.id)).subscribe(
            (data) => {
                this.appMainService.isHideSpinner("onAddNewContact");
                this.accountInfo = data;
            },
            (error) => {
                this.appMainService.isHideSpinner("onAddNewContact");
                console.error("Error fetching account details", error);
            },
        );
    }
    getAllTax() {
        this.salesOrderService
            .getAllTax()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((res) => {
                this.footerTaxEnabled = res.item1;
                if (res.item1) {
                    this.allTax = res.item2;
                    if (this.allTax && this.allTax.length > 0) {
                        this.soTax = this.allTax.filter((t) => t.isDefault == true)[0];
                    }
                }
            });
    }

    loadPaymentTerm() {
        this.appMainService.isShowSpinner("loadPaymentTerm");
        this.paymentTermService
            .getPaymentTermList()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (res) => {
                    this.appMainService.isHideSpinner("loadPaymentTerm");
                    this.allPaymentTerms = res;
                },
                error: () => {
                    this.appMainService.isHideSpinner("loadPaymentTerm");
                    this.messageService.add({ severity: "error", summary: "Error", detail: "Error occurred..." });
                },
            });
    }
    loadPaymentMethod() {
        this.appMainService.isShowSpinner("loadPaymentMethod");
        this.paymentMethodService
            .getPaymentMrthodList()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (res) => {
                    this.appMainService.isHideSpinner("loadPaymentMethod");
                    this.allPaymentMethods = res;
                },
                error: () => {
                    this.appMainService.isHideSpinner("loadPaymentMethod");
                    this.messageService.add({ severity: "error", summary: "Error", detail: "Error occurred..." });
                },
            });
    }
    loadShippingTerm() {
        this.appMainService.isShowSpinner("loadShippingTerm");
        this.shippingtermService
            .getShippingTermList()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (res) => {
                    this.appMainService.isHideSpinner("loadShippingTerm");
                    this.allShippingTerms = res;
                },
                error: () => {
                    this.appMainService.isHideSpinner("loadShippingTerm");
                    this.messageService.add({ severity: "error", summary: "Error", detail: "Error occurred..." });
                },
            });
    }
    loadAllUser() {
        this.appMainService.isShowSpinner("loadAllUser");
        this.salesOrderService
            .getAllUser()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (res) => {
                    this.appMainService.isHideSpinner("loadAllUser");
                    this.allUser = res;
                },
                error: () => {
                    this.appMainService.isHideSpinner("loadAllUser");
                    this.messageService.add({ severity: "error", summary: "Error", detail: "Error occurred..." });
                },
            });
    }
    loadAllLocation() {
        this.allLocations = [];
        this.appMainService.isShowSpinner("loadAllLocation");
        this.salesOrderService
            .getAllLocations("0", "0", "")
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (res) => {
                    this.appMainService.isHideSpinner("loadAllLocation");
                    if (res && res.length > 0) {
                        this.allLocations = res?.map((l) => ({
                            ...l,
                            name: l.locationId + " - " + l.name,
                            contactName: l.contactPersonName,
                            qty: l.qtyInStock,
                        }));
                        if (this.type == DialogType.CREATE || this.type == DialogType.COPY) {
                            this.allLocations = this.allLocations?.filter((l) => l.statusId == 1);
                            this.soForm?.controls["location"].setValue(this.allLocations?.filter((l) => l.isDefault == true)[0]);
                        }
                    }
                },
                error: () => {
                    this.appMainService.isHideSpinner("loadAllLocation");
                    this.messageService.add({ severity: "error", summary: "Error", detail: "Error occurred..." });
                },
            });
    }
    loadOrderChannels(name) {
        this.appMainService.isShowSpinner("loadChannels");
        this.salesOrderService
            .getAllOrdersChannel(name)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (res) => {
                    const config = JSON.parse(res.configurationDetails[0].configJSONValue);
                    this.orderChannels = config;
                    const salesChannel = this.orderChannels?.filter((s) => s.name == this.soChannel.SALES_ORDER)[0];
                    this.allStages = salesChannel?.stages;
                    const selectedStageId = this.allStages[0]?.id;
                    this.allStatus = this.allStages.filter((s) => s.id == selectedStageId)[0].status;

                    if (this.type == DialogType.CREATE || this.type == DialogType.COPY) {
                        this.soForm?.controls["salesOrderStage"].setValue(this.allStages[0]);
                        this.soForm?.controls["salesOrderStatus"].setValue(this.allStatus[0]);
                        this.soForm?.controls["salesOrderStage"].disable();
                    }
                    this.appMainService.isHideSpinner("loadChannels");
                },
                error: () => {
                    this.appMainService.isHideSpinner("loadChannels");
                    this.messageService.add({ severity: "error", summary: "Error", detail: "Error occurred..." });
                },
            });
    }
    getDiscountSelection(name) {
        this.appMainService.isShowSpinner("getDiscountSelection");
        this.salesOrderService
            .getAllDiscountOption(name)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (res) => {
                    const aggregateDiscountValue = res?.filter((o) => o.name == "Aggregate Discount" && o.isDefault == true)[0];
                    this.aggregateDiscount = aggregateDiscountValue ? true : false;
                    this.appMainService.isHideSpinner("getDiscountSelection");
                },
                error: () => {
                    this.appMainService.isHideSpinner("getDiscountSelection");
                    this.messageService.add({ severity: "error", summary: "Error", detail: "Error occurred..." });
                },
            });
    }
    loadAllTiers() {
        this.appMainService.isShowSpinner("loadAllTiers");
        this.productsService
            .getAllTiers()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (res) => {
                    this.pricebookConfig = res.item1;
                    this.appMainService.isHideSpinner("loadAllTiers");
                },
                error: () => {
                    this.appMainService.isHideSpinner("loadAllTiers");
                    this.messageService.add({ severity: "error", summary: "Error", detail: "Error occurred..." });
                },
            });
    }
    getAllAccounts(channelId) {
        this.appMainService.isShowSpinner("loadSOAccounts");
        this.salesOrderService
            .getAccountsByChannelId(channelId, "")
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((responseData) => {
                this.appMainService.isHideSpinner("loadSOAccounts");
                this.allAccounts = responseData;
            });
    }

    checkTaxDiscountVisibility() {
        this.isVisibleRowTax = this.templates?.labels_table[5]?.isChecked;
        this.isVisibleRowDiscount = !this.templates?.labels_table[6]?.isChecked;
        this.isVisibleFooterTax = this.templates["labels_footer"] && this.templates["labels_footer"].length >= 3 ? this.templates["labels_footer"][2]?.isChecked : false;
        this.isVisibleFooterDiscount = this.templates["labels_footer"][1]?.isChecked ?? false;
    }

    setAllTaxData(res) {
        this.footerTaxEnabled = res?.item1;
        if (res?.item1) {
            this.allTax = res.item2;
            if (this.allTax && this.allTax.length > 0) {
                this.soTax = this.allTax.filter((t) => t.isDefault == true)[0];
            }
        }
    }
    setShippingTermData(res) {
        if (res) {
            this.allShippingTerms = res;
        }
    }
    setAllUserData(res) {
        if (res) {
            this.allUser = res;
        }
    }
    setAllLocationData(res) {
        this.allLocations = [];
        if (res && res.length > 0) {
            this.allLocations = res?.map((l) => ({
                ...l,
                name: l.locationId + " - " + l.name,
                contactName: l.contactPersonName,
                qty: l.qtyInStock,
            }));
            if (this.type == DialogType.CREATE || this.type == DialogType.COPY) {
                this.allLocations = this.allLocations?.filter((l) => l.statusId == 1);
                this.soForm?.controls["location"].setValue(this.allLocations?.filter((l) => l.isDefault == true)[0]);
            }
        }
    }
    setOrderChannelData(res) {
        if (res) {
            const config = JSON.parse(res.configurationDetails[0].configJSONValue);
            this.orderChannels = config;
            const salesChannel = this.orderChannels?.filter((s) => s.name == this.soChannel.SALES_ORDER)[0];
            this.allStages = salesChannel?.stages;
            const selectedStageId = this.allStages[0]?.id;
            this.allStatus = this.allStages.filter((s) => s.id == selectedStageId)[0].status;

            if (this.type == DialogType.CREATE || this.type == DialogType.COPY) {
                this.soForm?.controls["salesOrderStage"].setValue(this.allStages[0]);
                this.soForm?.controls["salesOrderStatus"].setValue(this.allStatus[0]);
                this.soForm?.controls["salesOrderStage"].disable();
            }
        }
    }
    setDiscountSelectionData(res) {
        if (res) {
            const aggregateDiscountValue = res?.filter((o) => o.name == "Aggregate Discount" && o.isDefault == true)[0];
            this.aggregateDiscount = aggregateDiscountValue ? true : false;
        }
    }
    setAllTiersData(res) {
        if (res) {
            this.pricebookConfig = res.item1;
        }
    }
    setAdditionalDiscounts(addDiscounts) {
        this.discountOptions = [];
        this.additionalDiscounts = [];
        if (addDiscounts && addDiscounts.length > 0) {
            this.additionalDiscounts = addDiscounts?.map((l) => ({ ...l, additionalDescription: `${l.description}(${l.type.description})`, typeDescription: l.type.description }));
            this.additionalDiscountRateTypes = [];
            this.discountOptions = this.utilityService.prepareDiscountOptions(addDiscounts);
        }
    }
    setAdditionalFees(addFees) {
        this.additionalFees = addFees?.map((l) => ({ ...l, additionalname: `${l.description}(${l.type.description})`, typeDescription: l.type.description }));
    }

    private handleError(apiName: string, error: any) {
        this.appMainService.isHideSpinner("loadData");
        this.messageService.add({ severity: "error", summary: "Error", detail: "Error occurred..." });
        return of(null);
    }

    onAccountViewClick(e) {
        this.displayAccountViewEdit = true;
        this.selectedAccountId = e?.id ?? 0;
        this.selectedAccountChannelId = this.soForm?.controls?.accountChannel.value?.id;
    }
    closeAccountViewEditModal() {
        this.displayAccountViewEdit = false;
        this.selectedAccountId = 0;
        this.selectedAccountChannelId = 0;
    }
    reloadResultAfterSave() {
        this.selectAccount({ id: this.selectedAccountId });
    }

    onAppliedAmountViewClick() {
        this.displayAppliedAmountViewModal = true;
    }

    onCloseAppliedAmountModal() {
        this.displayAppliedAmountViewModal = false;
    }
    getPickListValues(values) {
        return values;
    }

    /** Credit Memo Selection */
    displayCreditMemoSelectionModal() {
        this.displayCreditSelect = true;
    }
    onCloseCreditMemoSelectionModal(e) {
        this.displayCreditSelect = false;
    }
    onApplyCreditMemo(event: any) {
        this.creditAppliedTotal = (event.appliedCreditMemoTotal)?.toFixed(this.fractionDigits);
        this.totalCreditAmount = (event.totalCreditAmount)?.toFixed(this.fractionDigits);
        this.selectedCredits = event.selectedCredits;
        this.receivedPayment = event.receivedPayment;
        this.applyCreditMemoType = event.type;
        if (event.type == "apply") {
            this.displayCreditSelect = false;
        }
    }

    // find section by code
    getFilteredSectionsByType(code: string): string {
        return this.filteredSection?.find((s) => s.code == code)?.name ?? "";
    }

    setContentInEditor(text: any) {
        setTimeout(() => {
            const _quill = this.editor?.getQuill();
            const editorContainer = _quill.root;
            this.renderer.setProperty(editorContainer, "innerHTML", text);
        });
    }

    loadCurrencies(): void {
        this.accountDataService
            .loadCurrencies()
            .pipe(
                map((currencies) => {
                    this.currencies = currencies?.filter((el) => el.isActive) || [];
                    this.currencies = this.currencies.map((el) => {
                        return {
                            id: el.id,
                            name: el.name + " - " + el.code,
                        };
                    });

                    this.defaultCurrency = currencies
                        ?.filter((el) => el.isDefault)
                        .map((el) => {
                            return {
                                id: el.id,
                                name: el.name + " - " + el.code,
                            };
                        })[0];
                }),
                catchError(() => []),
            )
            .subscribe();
    }

    /** Multicurrency */
    getcurrencyExchangeRate() {
        this.currencyExchangeRate = this.orgCurrency?.find((cr) => cr.currencyId == this.accountInfo?.currencyId)?.exchangeRate;
        this.previousCurrencyExchangeRate = this.orgCurrency?.find((cr) => cr.currencyId == this.accountInfo?.currencyId)?.exchangeRate;
        if (this.type && (this.type == DialogType.EDIT || this.type == DialogType.COPY || this.type == DialogType.VIEW || this.type == DialogType.CONVERT || this.type == DialogType.CONVERT_FROM_RMA)) {
            this.currencyExchangeRate = this.savedCurrencyExchangeRate;
            this.previousCurrencyExchangeRate = this.savedCurrencyExchangeRate;
        }
    }

    closeCurrencyDialog(event) {
        this.currencyExchangeRate = event?.formData?.exchangeRate;
        if (event?.formData?.enableRecalculateItemRate) {
            this.onChangeCurrencyRecalculateAmount();
        }
        this.overlayPanel.hide();
    }

    isBaseCurrency(): boolean {
        return this.baseCurrency?.currencyId == this.accountInfo?.currencyId;
    }

            // footer level & line level fee & discount start
            getSelectedFee(): Fee | null {// we handled i)footer discount ii)line level additional discount iii)footer level additional discount .
                if (this.feeOrDiscountContext === FeeOrDiscountContext.LINE && !this.isFooterDiscount) {
                    return this.currentDialogType === DialogTypeFeeOrDiscount.HANDLING_FEE ? this.selectedHProduct?.additionalFeeType : this.selectedDProduct?.discountType;
                } else if(!this.isFooterDiscount){
                    return this.currentDialogType === DialogTypeFeeOrDiscount.HANDLING_FEE ? this.soForm?.controls["additionalFeeType"]?.value : this.soForm?.controls["additionalDiscountTypeName"]?.value;
                }
                else if(this.isFooterDiscount){
                    return this.soForm?.controls["discountType"]?.value;
                }
            }
        
            getFeeList(): Fee[] {
                if (this.currentDialogType === DialogTypeFeeOrDiscount.HANDLING_FEE) {
                    return this.feeOrDiscountContext === FeeOrDiscountContext.LINE ? this.lineLevelHandlingFees : this.footerLevelHandlingFees;
                } else {
                    return this.feeOrDiscountContext === FeeOrDiscountContext.LINE ? this.lineLevelDiscounts : this.footerLevelDiscounts;
                }
            }
        
            openFooterLevelDiscount(isFooterDiscount?: boolean) {//footer level discount & additional discount are different things
                this.feeOrDiscountContext = FeeOrDiscountContext.FOOTER;
                this.footerLevelDiscounts = this.additionalDiscounts.filter((d) => d.discountCategoryId === 2);
                this.currentDialogType = DialogTypeFeeOrDiscount.DISCOUNT;
                this.displayFeeOrDiscountDialog = true;
                this.isFooterDiscount = isFooterDiscount;
            }
    
            openLineLevelDiscount(product?: any) {
                this.feeOrDiscountContext = FeeOrDiscountContext.LINE;
                this.selectedDProduct = product || null;
                this.lineLevelDiscounts = this.discountOptions.filter((d) => d.discountCategoryId === 1);
                this.currentDialogType = DialogTypeFeeOrDiscount.DISCOUNT;
                this.isFooterDiscount = false;
                this.displayFeeOrDiscountDialog = true;
            }
        
        applyDiscount(discount: any) {
             if (this.feeOrDiscountContext === FeeOrDiscountContext.LINE && !this.isFooterDiscount) {
                this.selectedDProduct.discountType = discount;
                this.selectedDProduct.discount = discount?.discountValue ?? 0;
                this.calculateProductsSubTotal(this.selectedDProduct, this.selectedDProduct.ordQty, "discounttype");
            } else if (!this.isFooterDiscount) {
                const appliedDiscount = JSON.parse(JSON.stringify(discount));
                this.soForm.controls["additionalDiscountTypeName"].setValue(appliedDiscount);
                this.onchangeAdditionalDiscountTypeName();
            } else {
                const appliedDiscount = discount ? { ...discount, name: discount?.type?.name ?? '' } : null;
                this.soForm.controls["discountType"].setValue(appliedDiscount);
                this.soForm.controls["discountValue"].setValue(appliedDiscount?.discountValue ?? 0);
                this.calculateOrderTotal('discounttype')
            }
            this.displayFeeOrDiscountDialog = false;
            this.isFooterDiscount = false;
        }
        
            openFooterLevelHandlingFees() {
                this.feeOrDiscountContext = FeeOrDiscountContext.FOOTER;
                this.footerLevelHandlingFees = this.additionalFees.filter((d) => d.discountCategoryId === 2 && d.statusId == 1);
                this.currentDialogType = DialogTypeFeeOrDiscount.HANDLING_FEE;
                this.isFooterDiscount = false;
                this.displayFeeOrDiscountDialog = true;
            }
        
            openLineLevelHandlingFees(product: any) {
                this.feeOrDiscountContext = FeeOrDiscountContext.LINE;
                this.selectedHProduct = product;
                this.lineLevelHandlingFees = this.additionalFees.filter((d) => d.discountCategoryId === 1 && d.statusId == 1);
                this.currentDialogType = DialogTypeFeeOrDiscount.HANDLING_FEE;
                this.isFooterDiscount = false;
                this.displayFeeOrDiscountDialog = true;
            }
            
            applyHandlingFee(fee: any) {
                if (this.feeOrDiscountContext === FeeOrDiscountContext.LINE) {
                    this.selectedHProduct.additionalFeeType = fee;
                    this.selectedHProduct.additionalFee = fee?.discountValue ?? 0;
                    this.calculateProductsSubTotal(this.selectedHProduct, this.selectedHProduct.ordQty, "additionalFeeType");
                } else {
                    this.soForm.controls["additionalFeeType"].setValue(fee);
                    this.soForm.controls["additionalFee"].setValue(fee?.discountValue || 0);
                    this.calculateOrderTotal("totalAdditionalFeetype");
                }
                this.displayFeeOrDiscountDialog = false;
            }
        
            onFeeApply(event: Fee): void {
                if (this.currentDialogType === DialogTypeFeeOrDiscount.HANDLING_FEE) {
                    this.applyHandlingFee(event);
                } else {
                    this.applyDiscount(event);
                }
            }
        
            // footer level & line level fee & discount end

            // Tax Selection
            openTax(product: any, productType: string) {
                this.currentProduct = product;
                this.currentProductType = productType;
                this.selectedTax = productType == 'bundleProduct' ? product?.bundleDetailSubTax ?? [] : product?.productSubTax ?? [];
                this.taxDialogContext = 'product';
                this.displayTaxSelectionDialog = true;
            }
            openFooterTax() {
                const allTaxes = this.purchaseListTB?.flatMap((product) => {
                    return product.typeId === this.typeIds.BundleTypeId
                        ? product.bundleDetails.flatMap((bundle) => bundle.bundleDetailSubTax || [])
                        : product.productSubTax || [];
                });
                this.selectedTax = this.getUniqueTaxes(allTaxes);
                this.taxDialogContext = 'footer';
                this.displayTaxSelectionDialog = true;
            }
            private getUniqueTaxes(taxes: any[]): any[] {
                const uniqueTaxMap = new Map();
                taxes?.forEach((tax) => {
                    if (!uniqueTaxMap.has(tax.taxId)) {
                        uniqueTaxMap.set(tax.taxId, tax);
                    }
                });
                return Array.from(uniqueTaxMap.values());
            }
            applyTax(event: TaxSelectionModel){
                this.displayTaxSelectionDialog = false;
                this.selectedTax = null;
                
                if (this.taxDialogContext === 'product') {
                    if (this.currentProduct && this.currentProductType != 'bundleProduct') {
                        this.currentProduct.productSubTax = event.selectedTaxes;
                        this.currentProduct.isManualTaxApplied = true;
                    } else {
                        this.currentProduct.bundleDetailSubTax = event.selectedTaxes;
                        this.currentProduct.isManualTaxApplied = true;
                    }
                } else if (this.taxDialogContext === 'footer') {
                    if(event?.selectedTaxes && event?.selectedTaxes?.length > 0){
                        const applicableTax = event?.selectedTaxes?.filter((tax) => tax?.isSelected == false);
                        if (this.purchaseListTB && this.purchaseListTB.length > 0) {

                            if(applicableTax && applicableTax.length > 0){
                                this.purchaseListTB.forEach(product => {
                                    if (product.typeId === this.typeIds.BundleTypeId) {
                                        product?.bundleDetails?.forEach(bundleItem => {
                                            if(bundleItem.bundleDetailSubTax && bundleItem.bundleDetailSubTax?.length >= 0){
                                                applicableTax?.forEach((tax) => {
                                                    const existingTax = bundleItem?.bundleDetailSubTax?.find((t) => t.taxId === tax.taxId);
                                                    if(!existingTax) {
                                                        bundleItem.bundleDetailSubTax?.push(existingTax);
                                                    }
                                                });
                                            } else {
                                                bundleItem.bundleDetailSubTax = [];
                                                bundleItem.bundleDetailSubTax?.push(...applicableTax);
                                            }
                                            bundleItem.isManualTaxApplied = true;
                                        });
                                    } else {
                                        if(product.productSubTax && product.productSubTax?.length >= 0){
                                            applicableTax?.forEach((tax) => {
                                                const existingTax = product?.productSubTax?.find((t) => t.taxId === tax.taxId);
                                                if(!existingTax) {
                                                    product.productSubTax?.push(tax);
                                                }
                                            });
                                        } else {
                                            product.productSubTax = [];
                                            product.productSubTax?.push(...applicableTax);
                                        }
                                        product.isManualTaxApplied = true;
                                    }
                                });
                            } else {
                                this.purchaseListTB.forEach((product) => {
                                    if (product.typeId === this.typeIds.BundleTypeId) {
                                        product?.bundleDetails?.forEach((bundleItem) => {
                                            let taxes = [];
                                            event?.selectedTaxes?.forEach((tax) => {
                                                const existingTax = bundleItem.bundleDetailSubTax?.find((t) => t.taxId === tax.taxId);
                                                if(existingTax) {
                                                    const isExistTax = taxes?.find((t) => t.taxId === tax.taxId);
                                                    if(!isExistTax) {
                                                        taxes.push(existingTax);
                                                    }
                                                }
                                            });
                                            bundleItem.bundleDetailSubTax = taxes;
                                            bundleItem.isManualTaxApplied = true;
                                        });
                                    } else {
                                        let taxes = [];
                                        event?.selectedTaxes?.forEach((tax) => {
                                            const existingTax = product.productSubTax?.find((t) => t.taxId === tax.taxId);
                                            if(existingTax) {
                                                const isExistTax = taxes?.find((t) => t.taxId === tax.taxId);
                                                    if(!isExistTax) {
                                                        taxes.push(existingTax);
                                                    }
                                            }
                                        });
                                        product.productSubTax = taxes;
                                        product.isManualTaxApplied = true;
                                    }
                                });
                            }
                        }
                    } else {
                        if (this.purchaseListTB && this.purchaseListTB.length > 0) {
                            this.purchaseListTB.forEach(product => {
                                if (product.typeId === this.typeIds.BundleTypeId) {
                                    product?.bundleDetails?.forEach(bundleItem => {
                                        bundleItem.bundleDetailSubTax = event.selectedTaxes;
                                        bundleItem.isManualTaxApplied = true;
                                    });
                                } else {
                                    product.productSubTax = event.selectedTaxes;
                                    product.isManualTaxApplied = true;
                                }
                            });
                        }
                    }
                }
        
                this.reCalculateProductsTotal('tax');
                this.calculateOrderTotal();
            }
            onCloseTaxSelectionDialog(event: any){
                this.displayTaxSelectionDialog = false;
            }
            // End of Tax Selection

            // posting period
            onPostingInfoChange(postingInfo: IPostingPeriodDetails) {
                this.updatedPostingPeriodInfo = postingInfo;
            }
}
